import { emptyDeinVerbandApi as api } from './empty-api';
export const addTagTypes = [
  'Access Attribute Resource',
  'Api Key Resource',
  'Association Resource',
  'Auth Resource',
  'Chat Resource',
  'Company Resource',
  'Control Plane Resource',
  'District Code Resource',
  'DocumentCategory',
  'Document Resource',
  'Email Render Resource',
  'EmailSignature',
  'EmailTemplate',
  'Email Template Resource',
  'Domain Email Config Resource',
  'Event Resource',
  'Group',
  'Image Resource',
  'Landing Pages Resource',
  'User List Resource',
  'Maintenance Public Resource',
  'Master Data Import Resource',
  'GroupMembership',
  'Membership Type Resource',
  'Oidc Resource',
  'Policy Resource',
  'Post Resource',
  'Role Resource',
  'Scheduler Task Resource',
  'Create Association Resource',
  'Batch Task Worker Resource',
  'Brevo Event Poller Resource',
  'Invoice Monthly Stats Resource',
  'Sync Chat Users Resource',
  'District Code Scheduler Resource',
  'Domain Sync Resource',
  'Email Delivery Alert Resource',
  'Email Event Poller Resource',
  'Email Send Queue Resource',
  'Invoice Resource',
  'Mailgun Event Poller Resource',
  'Meilisearch Setup',
  'Ms Graph Event Poller Resource',
  'Planned Posts Resource',
  'Upload Finished Resource',
  'Task Resource',
  'Survey Resource',
  'Tag Resource',
  'Test Resource',
  'TextBlock',
  'Text Generator Resource',
  'User Resource',
  'Version Resource'
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiAccessAttributes: build.query<
        GetApiAccessAttributesApiResponse,
        GetApiAccessAttributesApiArg
      >({
        query: () => ({ url: `/api/access-attributes` }),
        providesTags: ['Access Attribute Resource']
      }),
      postApiAccessAttributes: build.mutation<
        PostApiAccessAttributesApiResponse,
        PostApiAccessAttributesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/access-attributes`,
          method: 'POST',
          body: queryArg.createAccessAttribute
        }),
        invalidatesTags: ['Access Attribute Resource']
      }),
      postApiAccessAttributesValues: build.mutation<
        PostApiAccessAttributesValuesApiResponse,
        PostApiAccessAttributesValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/access-attributes/values`,
          method: 'POST',
          body: queryArg.createAttributeValueByName
        }),
        invalidatesTags: ['Access Attribute Resource']
      }),
      getApiAccessAttributesById: build.query<
        GetApiAccessAttributesByIdApiResponse,
        GetApiAccessAttributesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/access-attributes/${queryArg.id}` }),
        providesTags: ['Access Attribute Resource']
      }),
      getApiAccessAttributesByIdValues: build.query<
        GetApiAccessAttributesByIdValuesApiResponse,
        GetApiAccessAttributesByIdValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/access-attributes/${queryArg.id}/values`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            sortKey: queryArg.sortKey,
            sortOrder: queryArg.sortOrder
          }
        }),
        providesTags: ['Access Attribute Resource']
      }),
      getApiAccessAttributesByIdValuesAndValueId: build.query<
        GetApiAccessAttributesByIdValuesAndValueIdApiResponse,
        GetApiAccessAttributesByIdValuesAndValueIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/access-attributes/${queryArg.id}/values/${queryArg.valueId}`
        }),
        providesTags: ['Access Attribute Resource']
      }),
      deleteApiAccessAttributesByIdValuesAndValueId: build.mutation<
        DeleteApiAccessAttributesByIdValuesAndValueIdApiResponse,
        DeleteApiAccessAttributesByIdValuesAndValueIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/access-attributes/${queryArg.id}/values/${queryArg.valueId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Access Attribute Resource']
      }),
      getApiApiKeys: build.query<GetApiApiKeysApiResponse, GetApiApiKeysApiArg>(
        {
          query: () => ({ url: `/api/api-keys` }),
          providesTags: ['Api Key Resource']
        }
      ),
      postApiApiKeys: build.mutation<
        PostApiApiKeysApiResponse,
        PostApiApiKeysApiArg
      >({
        query: (queryArg) => ({
          url: `/api/api-keys`,
          method: 'POST',
          body: queryArg.createApiKeyRequest
        }),
        invalidatesTags: ['Api Key Resource']
      }),
      deleteApiApiKeysById: build.mutation<
        DeleteApiApiKeysByIdApiResponse,
        DeleteApiApiKeysByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/api-keys/${queryArg.id}`,
          method: 'DELETE',
          body: queryArg.revokeApiKeyRequest
        }),
        invalidatesTags: ['Api Key Resource']
      }),
      postApiAssociation: build.mutation<
        PostApiAssociationApiResponse,
        PostApiAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/association`,
          method: 'POST',
          body: queryArg.createAssociation
        }),
        invalidatesTags: ['Association Resource']
      }),
      getApiAssociationAdminAccessAttributeValue: build.query<
        GetApiAssociationAdminAccessAttributeValueApiResponse,
        GetApiAssociationAdminAccessAttributeValueApiArg
      >({
        query: () => ({ url: `/api/association/admin-access-attribute-value` }),
        providesTags: ['Association Resource']
      }),
      postApiAssociationConfig: build.mutation<
        PostApiAssociationConfigApiResponse,
        PostApiAssociationConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/api/association/config`,
          method: 'POST',
          body: queryArg.configValue
        }),
        invalidatesTags: ['Association Resource']
      }),
      getApiAssociationConfig: build.query<
        GetApiAssociationConfigApiResponse,
        GetApiAssociationConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/api/association/config`,
          params: {
            path: queryArg.path
          }
        }),
        providesTags: ['Association Resource']
      }),
      getApiAssociationInfo: build.query<
        GetApiAssociationInfoApiResponse,
        GetApiAssociationInfoApiArg
      >({
        query: () => ({ url: `/api/association/info` }),
        providesTags: ['Association Resource']
      }),
      getApiAuthLogin: build.query<
        GetApiAuthLoginApiResponse,
        GetApiAuthLoginApiArg
      >({
        query: (queryArg) => ({
          url: `/api/auth/login`,
          params: {
            redirectPath: queryArg.redirectPath
          }
        }),
        providesTags: ['Auth Resource']
      }),
      getApiAuthLogout: build.query<
        GetApiAuthLogoutApiResponse,
        GetApiAuthLogoutApiArg
      >({
        query: () => ({ url: `/api/auth/logout` }),
        providesTags: ['Auth Resource']
      }),
      getApiAuthSession: build.query<
        GetApiAuthSessionApiResponse,
        GetApiAuthSessionApiArg
      >({
        query: () => ({ url: `/api/auth/session` }),
        providesTags: ['Auth Resource']
      }),
      getApiChatDevices: build.query<
        GetApiChatDevicesApiResponse,
        GetApiChatDevicesApiArg
      >({
        query: () => ({ url: `/api/chat/devices` }),
        providesTags: ['Chat Resource']
      }),
      getApiChatToken: build.query<
        GetApiChatTokenApiResponse,
        GetApiChatTokenApiArg
      >({
        query: () => ({ url: `/api/chat/token` }),
        providesTags: ['Chat Resource']
      }),
      getApiCompanies: build.query<
        GetApiCompaniesApiResponse,
        GetApiCompaniesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies`,
          params: {
            groupId: queryArg.groupId,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sortKey: queryArg.sortKey,
            sortOrder: queryArg.sortOrder
          }
        }),
        providesTags: ['Company Resource']
      }),
      postApiCompanies: build.mutation<
        PostApiCompaniesApiResponse,
        PostApiCompaniesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies`,
          method: 'POST',
          body: queryArg.createCompany
        }),
        invalidatesTags: ['Company Resource']
      }),
      getApiCompaniesByExternalIdByExternalId: build.query<
        GetApiCompaniesByExternalIdByExternalIdApiResponse,
        GetApiCompaniesByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['Company Resource']
      }),
      getApiCompaniesMy: build.query<
        GetApiCompaniesMyApiResponse,
        GetApiCompaniesMyApiArg
      >({
        query: () => ({ url: `/api/companies/my` }),
        providesTags: ['Company Resource']
      }),
      patchApiCompaniesById: build.mutation<
        PatchApiCompaniesByIdApiResponse,
        PatchApiCompaniesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateCompany
        }),
        invalidatesTags: ['Company Resource']
      }),
      getApiCompaniesById: build.query<
        GetApiCompaniesByIdApiResponse,
        GetApiCompaniesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/companies/${queryArg.id}` }),
        providesTags: ['Company Resource']
      }),
      deleteApiCompaniesById: build.mutation<
        DeleteApiCompaniesByIdApiResponse,
        DeleteApiCompaniesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/companies/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Company Resource']
      }),
      getApiCompaniesByIdUsers: build.query<
        GetApiCompaniesByIdUsersApiResponse,
        GetApiCompaniesByIdUsersApiArg
      >({
        query: (queryArg) => ({ url: `/api/companies/${queryArg.id}/users` }),
        providesTags: ['Company Resource']
      }),
      postApiControlPlaneAssociation: build.mutation<
        PostApiControlPlaneAssociationApiResponse,
        PostApiControlPlaneAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/association`,
          method: 'POST',
          body: queryArg.createAssociation
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneAssociationResetByTenantId: build.mutation<
        PostApiControlPlaneAssociationResetByTenantIdApiResponse,
        PostApiControlPlaneAssociationResetByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/association/reset/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneAssociationSetTenantConfigByTenantId: build.mutation<
        PostApiControlPlaneAssociationSetTenantConfigByTenantIdApiResponse,
        PostApiControlPlaneAssociationSetTenantConfigByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/association/set-tenant-config/${queryArg.tenantId}`,
          method: 'POST',
          body: queryArg.tenantConfiguration
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneAssociationSyncIpByTenantId: build.mutation<
        PostApiControlPlaneAssociationSyncIpByTenantIdApiResponse,
        PostApiControlPlaneAssociationSyncIpByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/association/sync-ip/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneAssociations: build.query<
        GetApiControlPlaneAssociationsApiResponse,
        GetApiControlPlaneAssociationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/associations`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneAuditByTenantId: build.mutation<
        PostApiControlPlaneAuditByTenantIdApiResponse,
        PostApiControlPlaneAuditByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/audit/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneBillableMembershipsByTenantId: build.query<
        GetApiControlPlaneBillableMembershipsByTenantIdApiResponse,
        GetApiControlPlaneBillableMembershipsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/billable-memberships/${queryArg.tenantId}`
        }),
        providesTags: ['Control Plane Resource']
      }),
      putApiControlPlaneBillableMembershipsByTenantIdAndMembershipId:
        build.mutation<
          PutApiControlPlaneBillableMembershipsByTenantIdAndMembershipIdApiResponse,
          PutApiControlPlaneBillableMembershipsByTenantIdAndMembershipIdApiArg
        >({
          query: (queryArg) => ({
            url: `/api/control-plane/billable-memberships/${queryArg.tenantId}/${queryArg.membershipId}`,
            method: 'PUT',
            body: queryArg.setBillableRequest
          }),
          invalidatesTags: ['Control Plane Resource']
        }),
      getApiControlPlaneBillingMetricsByTenantId: build.query<
        GetApiControlPlaneBillingMetricsByTenantIdApiResponse,
        GetApiControlPlaneBillingMetricsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/billing-metrics/${queryArg.tenantId}`
        }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneDistrictCodeByTenantId: build.mutation<
        PostApiControlPlaneDistrictCodeByTenantIdApiResponse,
        PostApiControlPlaneDistrictCodeByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/district-code/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneDomainSync: build.mutation<
        PostApiControlPlaneDomainSyncApiResponse,
        PostApiControlPlaneDomainSyncApiArg
      >({
        query: () => ({
          url: `/api/control-plane/domain-sync`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneDomainSyncByTenantId: build.mutation<
        PostApiControlPlaneDomainSyncByTenantIdApiResponse,
        PostApiControlPlaneDomainSyncByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/domain-sync/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneDomainVerifyByTenantId: build.mutation<
        PostApiControlPlaneDomainVerifyByTenantIdApiResponse,
        PostApiControlPlaneDomainVerifyByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/domain-verify/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneDomainsByTenantId: build.query<
        GetApiControlPlaneDomainsByTenantIdApiResponse,
        GetApiControlPlaneDomainsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/domains/${queryArg.tenantId}`
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneEmailAlerts: build.query<
        GetApiControlPlaneEmailAlertsApiResponse,
        GetApiControlPlaneEmailAlertsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/alerts`,
          params: {
            page: queryArg.page,
            resolved: queryArg.resolved,
            size: queryArg.size,
            tenantId: queryArg.tenantId
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneEmailAlertsGenerate: build.mutation<
        PostApiControlPlaneEmailAlertsGenerateApiResponse,
        PostApiControlPlaneEmailAlertsGenerateApiArg
      >({
        query: () => ({
          url: `/api/control-plane/email/alerts/generate`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneEmailAlertsByIdResolve: build.mutation<
        PostApiControlPlaneEmailAlertsByIdResolveApiResponse,
        PostApiControlPlaneEmailAlertsByIdResolveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/alerts/${queryArg.id}/resolve`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneEmailBounced: build.query<
        GetApiControlPlaneEmailBouncedApiResponse,
        GetApiControlPlaneEmailBouncedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/bounced`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            tenantId: queryArg.tenantId
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      deleteApiControlPlaneEmailBouncedByTenantIdAndUserId: build.mutation<
        DeleteApiControlPlaneEmailBouncedByTenantIdAndUserIdApiResponse,
        DeleteApiControlPlaneEmailBouncedByTenantIdAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/bounced/${queryArg.tenantId}/${queryArg.userId}`,
          method: 'DELETE',
          params: {
            clearUpstream: queryArg.clearUpstream
          }
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneEmailDeliveryRates: build.query<
        GetApiControlPlaneEmailDeliveryRatesApiResponse,
        GetApiControlPlaneEmailDeliveryRatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/delivery-rates`,
          params: {
            since: queryArg.since
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneEmailFailed: build.query<
        GetApiControlPlaneEmailFailedApiResponse,
        GetApiControlPlaneEmailFailedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/failed`,
          params: {
            page: queryArg.page,
            since: queryArg.since,
            size: queryArg.size,
            tenantId: queryArg.tenantId
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneEmailProviders: build.query<
        GetApiControlPlaneEmailProvidersApiResponse,
        GetApiControlPlaneEmailProvidersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/providers`,
          params: {
            since: queryArg.since
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneEmailSenders: build.query<
        GetApiControlPlaneEmailSendersApiResponse,
        GetApiControlPlaneEmailSendersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/email/senders`,
          params: {
            since: queryArg.since
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneInvoices: build.query<
        GetApiControlPlaneInvoicesApiResponse,
        GetApiControlPlaneInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/invoices`,
          params: {
            limit: queryArg.limit,
            month: queryArg.month,
            tenantId: queryArg.tenantId
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneInvoicesCreate: build.query<
        GetApiControlPlaneInvoicesCreateApiResponse,
        GetApiControlPlaneInvoicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/invoices/create`,
          params: {
            'day-in-month': queryArg['day-in-month']
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      deleteApiControlPlaneLexofficeAssignmentByTenantId: build.mutation<
        DeleteApiControlPlaneLexofficeAssignmentByTenantIdApiResponse,
        DeleteApiControlPlaneLexofficeAssignmentByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/lexoffice/assignment/${queryArg.tenantId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneLexofficeAssignmentByTenantId: build.query<
        GetApiControlPlaneLexofficeAssignmentByTenantIdApiResponse,
        GetApiControlPlaneLexofficeAssignmentByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/lexoffice/assignment/${queryArg.tenantId}`
        }),
        providesTags: ['Control Plane Resource']
      }),
      putApiControlPlaneLexofficeAssignmentByTenantId: build.mutation<
        PutApiControlPlaneLexofficeAssignmentByTenantIdApiResponse,
        PutApiControlPlaneLexofficeAssignmentByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/lexoffice/assignment/${queryArg.tenantId}`,
          method: 'PUT',
          body: queryArg.assignLexofficeRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneLexofficeContacts: build.query<
        GetApiControlPlaneLexofficeContactsApiResponse,
        GetApiControlPlaneLexofficeContactsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/lexoffice/contacts`,
          params: {
            filter: queryArg.filter
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneMaintenance: build.query<
        GetApiControlPlaneMaintenanceApiResponse,
        GetApiControlPlaneMaintenanceApiArg
      >({
        query: () => ({ url: `/api/control-plane/maintenance` }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneMaintenance: build.mutation<
        PostApiControlPlaneMaintenanceApiResponse,
        PostApiControlPlaneMaintenanceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/maintenance`,
          method: 'POST',
          body: queryArg.createMaintenanceIntervalRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      deleteApiControlPlaneMaintenanceExpired: build.mutation<
        DeleteApiControlPlaneMaintenanceExpiredApiResponse,
        DeleteApiControlPlaneMaintenanceExpiredApiArg
      >({
        query: () => ({
          url: `/api/control-plane/maintenance/expired`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      putApiControlPlaneMaintenanceById: build.mutation<
        PutApiControlPlaneMaintenanceByIdApiResponse,
        PutApiControlPlaneMaintenanceByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/maintenance/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateMaintenanceIntervalRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      deleteApiControlPlaneMaintenanceById: build.mutation<
        DeleteApiControlPlaneMaintenanceByIdApiResponse,
        DeleteApiControlPlaneMaintenanceByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/maintenance/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneMappings: build.query<
        GetApiControlPlaneMappingsApiResponse,
        GetApiControlPlaneMappingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/mappings`,
          params: {
            userPk: queryArg.userPk
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneMappings: build.mutation<
        PostApiControlPlaneMappingsApiResponse,
        PostApiControlPlaneMappingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/mappings`,
          method: 'POST',
          body: queryArg.createMappingRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      deleteApiControlPlaneMappingsById: build.mutation<
        DeleteApiControlPlaneMappingsByIdApiResponse,
        DeleteApiControlPlaneMappingsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/mappings/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneMe: build.query<
        GetApiControlPlaneMeApiResponse,
        GetApiControlPlaneMeApiArg
      >({
        query: () => ({ url: `/api/control-plane/me` }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlanePaymentConditionsValidate: build.mutation<
        PostApiControlPlanePaymentConditionsValidateApiResponse,
        PostApiControlPlanePaymentConditionsValidateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/payment-conditions/validate`,
          method: 'POST',
          body: queryArg.formulaValidationRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      putApiControlPlanePaymentConditionsByTenantId: build.mutation<
        PutApiControlPlanePaymentConditionsByTenantIdApiResponse,
        PutApiControlPlanePaymentConditionsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/payment-conditions/${queryArg.tenantId}`,
          method: 'PUT',
          body: queryArg.paymentConditionsDto
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlanePaymentConditionsByTenantId: build.query<
        GetApiControlPlanePaymentConditionsByTenantIdApiResponse,
        GetApiControlPlanePaymentConditionsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/payment-conditions/${queryArg.tenantId}`
        }),
        providesTags: ['Control Plane Resource']
      }),
      deleteApiControlPlanePaymentConditionsByTenantId: build.mutation<
        DeleteApiControlPlanePaymentConditionsByTenantIdApiResponse,
        DeleteApiControlPlanePaymentConditionsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/payment-conditions/${queryArg.tenantId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlanePaymentConditionsByTenantIdPreview: build.mutation<
        PostApiControlPlanePaymentConditionsByTenantIdPreviewApiResponse,
        PostApiControlPlanePaymentConditionsByTenantIdPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/payment-conditions/${queryArg.tenantId}/preview`,
          method: 'POST',
          body: queryArg.formulaPreviewRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlanePolicyAccessTestByTenantId: build.mutation<
        PostApiControlPlanePolicyAccessTestByTenantIdApiResponse,
        PostApiControlPlanePolicyAccessTestByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/policy/access-test/${queryArg.tenantId}`,
          method: 'POST',
          body: queryArg.accessTestRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlanePolicyCacheByTenantId: build.mutation<
        PostApiControlPlanePolicyCacheByTenantIdApiResponse,
        PostApiControlPlanePolicyCacheByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/policy/cache/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneStatistics: build.query<
        GetApiControlPlaneStatisticsApiResponse,
        GetApiControlPlaneStatisticsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/statistics`,
          params: {
            month: queryArg.month
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneStatisticsByTenantId: build.query<
        GetApiControlPlaneStatisticsByTenantIdApiResponse,
        GetApiControlPlaneStatisticsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/statistics/${queryArg.tenantId}`,
          params: {
            month: queryArg.month
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneTemplatesByTenantIdLoadDefaults: build.mutation<
        PostApiControlPlaneTemplatesByTenantIdLoadDefaultsApiResponse,
        PostApiControlPlaneTemplatesByTenantIdLoadDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/templates/${queryArg.tenantId}/load-defaults`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneTemplatesByTenantIdResetAndType: build.mutation<
        PostApiControlPlaneTemplatesByTenantIdResetAndTypeApiResponse,
        PostApiControlPlaneTemplatesByTenantIdResetAndTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/templates/${queryArg.tenantId}/reset/${queryArg['type']}`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneTextBlocksByTenantIdLoadDefaults: build.mutation<
        PostApiControlPlaneTextBlocksByTenantIdLoadDefaultsApiResponse,
        PostApiControlPlaneTextBlocksByTenantIdLoadDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/text-blocks/${queryArg.tenantId}/load-defaults`,
          method: 'POST'
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneUserSyncIpByTenantId: build.mutation<
        PostApiControlPlaneUserSyncIpByTenantIdApiResponse,
        PostApiControlPlaneUserSyncIpByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/user/sync-ip/${queryArg.tenantId}`,
          method: 'POST',
          body: queryArg.syncUserRequest
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneUsersByTenantId: build.query<
        GetApiControlPlaneUsersByTenantIdApiResponse,
        GetApiControlPlaneUsersByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/users/${queryArg.tenantId}`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            userFilter: queryArg.userFilter
          }
        }),
        providesTags: ['Control Plane Resource']
      }),
      postApiControlPlaneUsersByTenantIdDedupe: build.mutation<
        PostApiControlPlaneUsersByTenantIdDedupeApiResponse,
        PostApiControlPlaneUsersByTenantIdDedupeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/users/${queryArg.tenantId}/dedupe`,
          method: 'POST',
          params: {
            dryRun: queryArg.dryRun,
            limit: queryArg.limit,
            loser: queryArg.loser,
            winner: queryArg.winner
          }
        }),
        invalidatesTags: ['Control Plane Resource']
      }),
      getApiControlPlaneUsersByTenantIdDuplicates: build.query<
        GetApiControlPlaneUsersByTenantIdDuplicatesApiResponse,
        GetApiControlPlaneUsersByTenantIdDuplicatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/control-plane/users/${queryArg.tenantId}/duplicates`
        }),
        providesTags: ['Control Plane Resource']
      }),
      getApiDistrictCode: build.query<
        GetApiDistrictCodeApiResponse,
        GetApiDistrictCodeApiArg
      >({
        query: () => ({ url: `/api/district-code` }),
        providesTags: ['District Code Resource']
      }),
      getApiDistrictCodeByPostalCodeByPostalCode: build.query<
        GetApiDistrictCodeByPostalCodeByPostalCodeApiResponse,
        GetApiDistrictCodeByPostalCodeByPostalCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/district-code/by-postal-code/${queryArg.postalCode}`
        }),
        providesTags: ['District Code Resource']
      }),
      getApiDocumentCategories: build.query<
        GetApiDocumentCategoriesApiResponse,
        GetApiDocumentCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-categories`,
          params: {
            name: queryArg.name,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['DocumentCategory']
      }),
      postApiDocumentCategories: build.mutation<
        PostApiDocumentCategoriesApiResponse,
        PostApiDocumentCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-categories`,
          method: 'POST',
          body: queryArg.documentCategoryCreateDto
        }),
        invalidatesTags: ['DocumentCategory']
      }),
      getApiDocumentCategoriesByExternalIdByExternalId: build.query<
        GetApiDocumentCategoriesByExternalIdByExternalIdApiResponse,
        GetApiDocumentCategoriesByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-categories/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['DocumentCategory']
      }),
      patchApiDocumentCategoriesById: build.mutation<
        PatchApiDocumentCategoriesByIdApiResponse,
        PatchApiDocumentCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-categories/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.documentCategoryUpdateDto
        }),
        invalidatesTags: ['DocumentCategory']
      }),
      getApiDocumentCategoriesById: build.query<
        GetApiDocumentCategoriesByIdApiResponse,
        GetApiDocumentCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-categories/${queryArg.id}`
        }),
        providesTags: ['DocumentCategory']
      }),
      deleteApiDocumentCategoriesById: build.mutation<
        DeleteApiDocumentCategoriesByIdApiResponse,
        DeleteApiDocumentCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-categories/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['DocumentCategory']
      }),
      postApiDocumentFilesMove: build.mutation<
        PostApiDocumentFilesMoveApiResponse,
        PostApiDocumentFilesMoveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/files/move`,
          method: 'POST',
          body: queryArg.moveDocumentsRequest
        }),
        invalidatesTags: ['Document Resource']
      }),
      putApiDocumentFilesById: build.mutation<
        PutApiDocumentFilesByIdApiResponse,
        PutApiDocumentFilesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/files/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateDocument
        }),
        invalidatesTags: ['Document Resource']
      }),
      deleteApiDocumentFilesById: build.mutation<
        DeleteApiDocumentFilesByIdApiResponse,
        DeleteApiDocumentFilesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/files/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Document Resource']
      }),
      getApiDocumentFilesByIdAccess: build.query<
        GetApiDocumentFilesByIdAccessApiResponse,
        GetApiDocumentFilesByIdAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/files/${queryArg.id}/access`
        }),
        providesTags: ['Document Resource']
      }),
      getApiDocumentFilesByIdDownload: build.mutation<
        GetApiDocumentFilesByIdDownloadApiResponse,
        GetApiDocumentFilesByIdDownloadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/files/${queryArg.id}/download`,
          method: 'GET'
        }),
        invalidatesTags: ['Document Resource']
      }),
      getApiDocumentFilesByIdReplace: build.mutation<
        GetApiDocumentFilesByIdReplaceApiResponse,
        GetApiDocumentFilesByIdReplaceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/files/${queryArg.id}/replace`,
          method: 'GET'
        }),
        invalidatesTags: ['Document Resource']
      }),
      getApiDocumentFolders: build.query<
        GetApiDocumentFoldersApiResponse,
        GetApiDocumentFoldersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders`,
          params: {
            page: queryArg.page,
            size: queryArg.size,
            sortKey: queryArg.sortKey,
            sortOrder: queryArg.sortOrder
          }
        }),
        providesTags: ['Document Resource']
      }),
      postApiDocumentFolders: build.mutation<
        PostApiDocumentFoldersApiResponse,
        PostApiDocumentFoldersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders`,
          method: 'POST',
          body: queryArg.createFolder
        }),
        invalidatesTags: ['Document Resource']
      }),
      postApiDocumentFoldersMove: build.mutation<
        PostApiDocumentFoldersMoveApiResponse,
        PostApiDocumentFoldersMoveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/move`,
          method: 'POST',
          body: queryArg.moveFoldersRequest
        }),
        invalidatesTags: ['Document Resource']
      }),
      putApiDocumentFoldersById: build.mutation<
        PutApiDocumentFoldersByIdApiResponse,
        PutApiDocumentFoldersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateFolderV2
        }),
        invalidatesTags: ['Document Resource']
      }),
      getApiDocumentFoldersById: build.query<
        GetApiDocumentFoldersByIdApiResponse,
        GetApiDocumentFoldersByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/document/folders/${queryArg.id}` }),
        providesTags: ['Document Resource']
      }),
      deleteApiDocumentFoldersById: build.mutation<
        DeleteApiDocumentFoldersByIdApiResponse,
        DeleteApiDocumentFoldersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Document Resource']
      }),
      getApiDocumentFoldersByIdAccess: build.query<
        GetApiDocumentFoldersByIdAccessApiResponse,
        GetApiDocumentFoldersByIdAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}/access`
        }),
        providesTags: ['Document Resource']
      }),
      getApiDocumentFoldersByIdContents: build.query<
        GetApiDocumentFoldersByIdContentsApiResponse,
        GetApiDocumentFoldersByIdContentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}/contents`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sortKey: queryArg.sortKey,
            sortOrder: queryArg.sortOrder
          }
        }),
        providesTags: ['Document Resource']
      }),
      postApiDocumentFoldersByIdFiles: build.mutation<
        PostApiDocumentFoldersByIdFilesApiResponse,
        PostApiDocumentFoldersByIdFilesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}/files`,
          method: 'POST',
          body: queryArg.createDocument
        }),
        invalidatesTags: ['Document Resource']
      }),
      postApiDocumentFoldersByIdFolders: build.mutation<
        PostApiDocumentFoldersByIdFoldersApiResponse,
        PostApiDocumentFoldersByIdFoldersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}/folders`,
          method: 'POST',
          body: queryArg.createFolder
        }),
        invalidatesTags: ['Document Resource']
      }),
      getApiDocumentFoldersByIdParents: build.query<
        GetApiDocumentFoldersByIdParentsApiResponse,
        GetApiDocumentFoldersByIdParentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document/folders/${queryArg.id}/parents`
        }),
        providesTags: ['Document Resource']
      }),
      postApiEmailRenderCustom: build.query<
        PostApiEmailRenderCustomApiResponse,
        PostApiEmailRenderCustomApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-render/custom`,
          method: 'POST',
          body: queryArg.emailRenderRequest
        }),
        providesTags: ['Email Render Resource']
      }),
      postApiEmailRenderCustomPreview: build.mutation<
        PostApiEmailRenderCustomPreviewApiResponse,
        PostApiEmailRenderCustomPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-render/custom-preview`,
          method: 'POST',
          body: queryArg.emailRenderPreviewRequest
        }),
        invalidatesTags: ['Email Render Resource']
      }),
      getApiEmailRenderPostByPostId: build.query<
        GetApiEmailRenderPostByPostIdApiResponse,
        GetApiEmailRenderPostByPostIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-render/post/${queryArg.postId}`
        }),
        providesTags: ['Email Render Resource']
      }),
      getApiEmailSignature: build.query<
        GetApiEmailSignatureApiResponse,
        GetApiEmailSignatureApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-signature`,
          params: {
            organizationName: queryArg.organizationName,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['EmailSignature']
      }),
      postApiEmailSignature: build.mutation<
        PostApiEmailSignatureApiResponse,
        PostApiEmailSignatureApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-signature`,
          method: 'POST',
          body: queryArg.emailSignatureCreateDto
        }),
        invalidatesTags: ['EmailSignature']
      }),
      patchApiEmailSignatureById: build.mutation<
        PatchApiEmailSignatureByIdApiResponse,
        PatchApiEmailSignatureByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-signature/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.emailSignatureUpdateDto
        }),
        invalidatesTags: ['EmailSignature']
      }),
      getApiEmailSignatureById: build.query<
        GetApiEmailSignatureByIdApiResponse,
        GetApiEmailSignatureByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/email-signature/${queryArg.id}` }),
        providesTags: ['EmailSignature']
      }),
      deleteApiEmailSignatureById: build.mutation<
        DeleteApiEmailSignatureByIdApiResponse,
        DeleteApiEmailSignatureByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-signature/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['EmailSignature']
      }),
      getApiEmailTemplate: build.query<
        GetApiEmailTemplateApiResponse,
        GetApiEmailTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-template`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            status: queryArg.status,
            type: queryArg['type']
          }
        }),
        providesTags: ['EmailTemplate']
      }),
      postApiEmailTemplate: build.mutation<
        PostApiEmailTemplateApiResponse,
        PostApiEmailTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-template`,
          method: 'POST',
          body: queryArg.emailTemplateCreateDto
        }),
        invalidatesTags: ['EmailTemplate']
      }),
      patchApiEmailTemplateById: build.mutation<
        PatchApiEmailTemplateByIdApiResponse,
        PatchApiEmailTemplateByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-template/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.emailTemplateUpdateDto
        }),
        invalidatesTags: ['EmailTemplate']
      }),
      getApiEmailTemplateById: build.query<
        GetApiEmailTemplateByIdApiResponse,
        GetApiEmailTemplateByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/email-template/${queryArg.id}` }),
        providesTags: ['EmailTemplate']
      }),
      deleteApiEmailTemplateById: build.mutation<
        DeleteApiEmailTemplateByIdApiResponse,
        DeleteApiEmailTemplateByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-template/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['EmailTemplate']
      }),
      getApiEmailTemplates: build.query<
        GetApiEmailTemplatesApiResponse,
        GetApiEmailTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-templates`,
          params: {
            status: queryArg.status,
            type: queryArg['type']
          }
        }),
        providesTags: ['Email Template Resource']
      }),
      postApiEmailTemplates: build.mutation<
        PostApiEmailTemplatesApiResponse,
        PostApiEmailTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-templates`,
          method: 'POST',
          body: queryArg.emailTemplateCreateDto
        }),
        invalidatesTags: ['Email Template Resource']
      }),
      postApiEmailTemplatesCopyFromDefault: build.mutation<
        PostApiEmailTemplatesCopyFromDefaultApiResponse,
        PostApiEmailTemplatesCopyFromDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-templates/copy-from-default`,
          method: 'POST',
          body: queryArg.copyEmailTemplateFromDefaultDto
        }),
        invalidatesTags: ['Email Template Resource']
      }),
      getApiEmailTemplatesVariables: build.query<
        GetApiEmailTemplatesVariablesApiResponse,
        GetApiEmailTemplatesVariablesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-templates/variables`,
          params: {
            type: queryArg['type']
          }
        }),
        providesTags: ['Email Template Resource']
      }),
      patchApiEmailTemplatesById: build.mutation<
        PatchApiEmailTemplatesByIdApiResponse,
        PatchApiEmailTemplatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-templates/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.emailTemplateUpdateDto
        }),
        invalidatesTags: ['Email Template Resource']
      }),
      getApiEmailTemplatesById: build.query<
        GetApiEmailTemplatesByIdApiResponse,
        GetApiEmailTemplatesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/email-templates/${queryArg.id}` }),
        providesTags: ['Email Template Resource']
      }),
      putApiEmailTemplatesByIdStatus: build.mutation<
        PutApiEmailTemplatesByIdStatusApiResponse,
        PutApiEmailTemplatesByIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email-templates/${queryArg.id}/status`,
          method: 'PUT',
          body: queryArg.emailTemplateStatusUpdateDto
        }),
        invalidatesTags: ['Email Template Resource']
      }),
      putApiEmailConfig: build.mutation<
        PutApiEmailConfigApiResponse,
        PutApiEmailConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email/config`,
          method: 'PUT',
          body: queryArg.domainEmailConfigEntry
        }),
        invalidatesTags: ['Domain Email Config Resource']
      }),
      getApiEmailConfig: build.query<
        GetApiEmailConfigApiResponse,
        GetApiEmailConfigApiArg
      >({
        query: () => ({ url: `/api/email/config` }),
        providesTags: ['Domain Email Config Resource']
      }),
      getApiEmailConfigDomainByDomainId: build.query<
        GetApiEmailConfigDomainByDomainIdApiResponse,
        GetApiEmailConfigDomainByDomainIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email/config/domain/${queryArg.domainId}`
        }),
        providesTags: ['Domain Email Config Resource']
      }),
      deleteApiEmailConfigByDomainIdAndSenderId: build.mutation<
        DeleteApiEmailConfigByDomainIdAndSenderIdApiResponse,
        DeleteApiEmailConfigByDomainIdAndSenderIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/email/config/${queryArg.domainId}/${queryArg.senderId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Domain Email Config Resource']
      }),
      getApiEvents: build.query<GetApiEventsApiResponse, GetApiEventsApiArg>({
        query: (queryArg) => ({
          url: `/api/events`,
          params: {
            from: queryArg['from'],
            page: queryArg.page,
            publish_status: queryArg.publishStatus,
            search: queryArg.search,
            size: queryArg.size,
            to: queryArg.to
          }
        }),
        providesTags: ['Event Resource']
      }),
      postApiEvents: build.mutation<
        PostApiEventsApiResponse,
        PostApiEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events`,
          method: 'POST',
          body: queryArg.createEvent
        }),
        invalidatesTags: ['Event Resource']
      }),
      postApiEventsAttend: build.mutation<
        PostApiEventsAttendApiResponse,
        PostApiEventsAttendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/attend`,
          method: 'POST',
          body: queryArg.attendWithToken
        }),
        invalidatesTags: ['Event Resource']
      }),
      getApiEventsAttendeeStatusAttribute: build.query<
        GetApiEventsAttendeeStatusAttributeApiResponse,
        GetApiEventsAttendeeStatusAttributeApiArg
      >({
        query: () => ({ url: `/api/events/attendee-status-attribute` }),
        providesTags: ['Event Resource']
      }),
      patchApiEventsById: build.mutation<
        PatchApiEventsByIdApiResponse,
        PatchApiEventsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateEvent
        }),
        invalidatesTags: ['Event Resource']
      }),
      getApiEventsById: build.query<
        GetApiEventsByIdApiResponse,
        GetApiEventsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/events/${queryArg.id}` }),
        providesTags: ['Event Resource']
      }),
      deleteApiEventsById: build.mutation<
        DeleteApiEventsByIdApiResponse,
        DeleteApiEventsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Event Resource']
      }),
      getApiEventsByIdAllAttendees: build.query<
        GetApiEventsByIdAllAttendeesApiResponse,
        GetApiEventsByIdAllAttendeesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.id}/all_attendees`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            search: queryArg.search,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Event Resource']
      }),
      getApiEventsByIdAttendees: build.query<
        GetApiEventsByIdAttendeesApiResponse,
        GetApiEventsByIdAttendeesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.id}/attendees`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Event Resource']
      }),
      postApiEventsByIdAttendees: build.mutation<
        PostApiEventsByIdAttendeesApiResponse,
        PostApiEventsByIdAttendeesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.id}/attendees`,
          method: 'POST',
          body: queryArg.attendRequest
        }),
        invalidatesTags: ['Event Resource']
      }),
      getApiEventsByIdIcs: build.query<
        GetApiEventsByIdIcsApiResponse,
        GetApiEventsByIdIcsApiArg
      >({
        query: (queryArg) => ({ url: `/api/events/${queryArg.id}/ics` }),
        providesTags: ['Event Resource']
      }),
      postApiEventsByIdPublish: build.mutation<
        PostApiEventsByIdPublishApiResponse,
        PostApiEventsByIdPublishApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.id}/publish`,
          method: 'POST'
        }),
        invalidatesTags: ['Event Resource']
      }),
      getApiGroup: build.query<GetApiGroupApiResponse, GetApiGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/group`,
          params: {
            number: queryArg['number'],
            page: queryArg.page,
            parentId: queryArg.parentId,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Group']
      }),
      postApiGroup: build.mutation<PostApiGroupApiResponse, PostApiGroupApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/group`,
            method: 'POST',
            body: queryArg.groupCreateDto
          }),
          invalidatesTags: ['Group']
        }
      ),
      getApiGroupByExternalIdById: build.query<
        GetApiGroupByExternalIdByIdApiResponse,
        GetApiGroupByExternalIdByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/group/by-external-id/${queryArg.id}`
        }),
        providesTags: ['Group']
      }),
      patchApiGroupById: build.mutation<
        PatchApiGroupByIdApiResponse,
        PatchApiGroupByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/group/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.groupUpdateDto
        }),
        invalidatesTags: ['Group']
      }),
      getApiGroupById: build.query<
        GetApiGroupByIdApiResponse,
        GetApiGroupByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/group/${queryArg.id}` }),
        providesTags: ['Group']
      }),
      deleteApiGroupById: build.mutation<
        DeleteApiGroupByIdApiResponse,
        DeleteApiGroupByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/group/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Group']
      }),
      getApiGroupByIdMembers: build.query<
        GetApiGroupByIdMembersApiResponse,
        GetApiGroupByIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/group/${queryArg.id}/members`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Group']
      }),
      postApiImages: build.mutation<
        PostApiImagesApiResponse,
        PostApiImagesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/images`,
          method: 'POST',
          body: queryArg.createImage
        }),
        invalidatesTags: ['Image Resource']
      }),
      getApiLandingNewsletterByToken: build.query<
        GetApiLandingNewsletterByTokenApiResponse,
        GetApiLandingNewsletterByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/landing/newsletter/${queryArg.token}`
        }),
        providesTags: ['Landing Pages Resource']
      }),
      getApiLandingPostByToken: build.query<
        GetApiLandingPostByTokenApiResponse,
        GetApiLandingPostByTokenApiArg
      >({
        query: (queryArg) => ({ url: `/api/landing/post/${queryArg.token}` }),
        providesTags: ['Landing Pages Resource']
      }),
      getApiLists: build.query<GetApiListsApiResponse, GetApiListsApiArg>({
        query: (queryArg) => ({
          url: `/api/lists`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['User List Resource']
      }),
      postApiLists: build.mutation<PostApiListsApiResponse, PostApiListsApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/lists`,
            method: 'POST',
            body: queryArg.createUserList
          }),
          invalidatesTags: ['User List Resource']
        }
      ),
      patchApiListsById: build.mutation<
        PatchApiListsByIdApiResponse,
        PatchApiListsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/lists/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateUserListInfo
        }),
        invalidatesTags: ['User List Resource']
      }),
      getApiListsById: build.query<
        GetApiListsByIdApiResponse,
        GetApiListsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/lists/${queryArg.id}` }),
        providesTags: ['User List Resource']
      }),
      deleteApiListsById: build.mutation<
        DeleteApiListsByIdApiResponse,
        DeleteApiListsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/lists/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['User List Resource']
      }),
      getApiListsByIdUsers: build.query<
        GetApiListsByIdUsersApiResponse,
        GetApiListsByIdUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/lists/${queryArg.id}/users`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['User List Resource']
      }),
      getApiMaintenance: build.query<
        GetApiMaintenanceApiResponse,
        GetApiMaintenanceApiArg
      >({
        query: () => ({ url: `/api/maintenance` }),
        providesTags: ['Maintenance Public Resource']
      }),
      postApiMasterDataImportBatchImport: build.mutation<
        PostApiMasterDataImportBatchImportApiResponse,
        PostApiMasterDataImportBatchImportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/batch-import`,
          method: 'POST',
          body: queryArg.body,
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportBatchImportAsync: build.mutation<
        PostApiMasterDataImportBatchImportAsyncApiResponse,
        PostApiMasterDataImportBatchImportAsyncApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/batch-import/async`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportBatchImportExecute: build.mutation<
        PostApiMasterDataImportBatchImportExecuteApiResponse,
        PostApiMasterDataImportBatchImportExecuteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/batch-import/execute`,
          method: 'POST',
          body: queryArg.updatePlan
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportBatchImportExecuteAsync: build.mutation<
        PostApiMasterDataImportBatchImportExecuteAsyncApiResponse,
        PostApiMasterDataImportBatchImportExecuteAsyncApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/batch-import/execute/async`,
          method: 'POST',
          body: queryArg.updatePlan
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportBatchImportPlan: build.mutation<
        PostApiMasterDataImportBatchImportPlanApiResponse,
        PostApiMasterDataImportBatchImportPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/batch-import/plan`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportBatchImportPlanAsync: build.mutation<
        PostApiMasterDataImportBatchImportPlanAsyncApiResponse,
        PostApiMasterDataImportBatchImportPlanAsyncApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/batch-import/plan/async`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportCompanies: build.query<
        GetApiMasterDataImportCompaniesApiResponse,
        GetApiMasterDataImportCompaniesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/companies`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportCompanies: build.mutation<
        PostApiMasterDataImportCompaniesApiResponse,
        PostApiMasterDataImportCompaniesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/companies`,
          method: 'POST',
          body: queryArg.externalCompanyChangeRequest,
          params: {
            autoCommit: queryArg.autoCommit
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportCompaniesByExternalIdByExternalId: build.query<
        GetApiMasterDataImportCompaniesByExternalIdByExternalIdApiResponse,
        GetApiMasterDataImportCompaniesByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/companies/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportCompaniesExternalIds: build.query<
        GetApiMasterDataImportCompaniesExternalIdsApiResponse,
        GetApiMasterDataImportCompaniesExternalIdsApiArg
      >({
        query: () => ({
          url: `/api/master-data-import/companies/external-ids`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportCompaniesSquashedByExternalId: build.query<
        GetApiMasterDataImportCompaniesSquashedByExternalIdApiResponse,
        GetApiMasterDataImportCompaniesSquashedByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/companies/squashed/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportCompaniesById: build.mutation<
        PostApiMasterDataImportCompaniesByIdApiResponse,
        PostApiMasterDataImportCompaniesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/companies/${queryArg.id}`,
          method: 'POST',
          body: queryArg.externalCompanyChangeResponse
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportCompaniesById: build.query<
        GetApiMasterDataImportCompaniesByIdApiResponse,
        GetApiMasterDataImportCompaniesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/companies/${queryArg.id}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportDocumentCategories: build.query<
        GetApiMasterDataImportDocumentCategoriesApiResponse,
        GetApiMasterDataImportDocumentCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/document-categories`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportDocumentCategories: build.mutation<
        PostApiMasterDataImportDocumentCategoriesApiResponse,
        PostApiMasterDataImportDocumentCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/document-categories`,
          method: 'POST',
          body: queryArg.externalDocumentCategoryChangeRequest,
          params: {
            autoCommit: queryArg.autoCommit
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportDocumentCategoriesByExternalIdByExternalId:
        build.query<
          GetApiMasterDataImportDocumentCategoriesByExternalIdByExternalIdApiResponse,
          GetApiMasterDataImportDocumentCategoriesByExternalIdByExternalIdApiArg
        >({
          query: (queryArg) => ({
            url: `/api/master-data-import/document-categories/by-external-id/${queryArg.externalId}`
          }),
          providesTags: ['Master Data Import Resource']
        }),
      getApiMasterDataImportDocumentCategoriesExternalIds: build.query<
        GetApiMasterDataImportDocumentCategoriesExternalIdsApiResponse,
        GetApiMasterDataImportDocumentCategoriesExternalIdsApiArg
      >({
        query: () => ({
          url: `/api/master-data-import/document-categories/external-ids`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportDocumentCategoriesSquashedByExternalId: build.query<
        GetApiMasterDataImportDocumentCategoriesSquashedByExternalIdApiResponse,
        GetApiMasterDataImportDocumentCategoriesSquashedByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/document-categories/squashed/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportDocumentCategoriesById: build.mutation<
        PostApiMasterDataImportDocumentCategoriesByIdApiResponse,
        PostApiMasterDataImportDocumentCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/document-categories/${queryArg.id}`,
          method: 'POST',
          body: queryArg.externalDocumentCategoryChangeResponse
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportDocumentCategoriesById: build.query<
        GetApiMasterDataImportDocumentCategoriesByIdApiResponse,
        GetApiMasterDataImportDocumentCategoriesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/document-categories/${queryArg.id}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportExport: build.query<
        GetApiMasterDataImportExportApiResponse,
        GetApiMasterDataImportExportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/export`,
          params: {
            includeAttributes: queryArg.includeAttributes
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportExternalIds: build.mutation<
        PostApiMasterDataImportExternalIdsApiResponse,
        PostApiMasterDataImportExternalIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/external-ids`,
          method: 'POST',
          body: queryArg.setExternalIdsRequest
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportGuilds: build.query<
        GetApiMasterDataImportGuildsApiResponse,
        GetApiMasterDataImportGuildsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/guilds`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportGuilds: build.mutation<
        PostApiMasterDataImportGuildsApiResponse,
        PostApiMasterDataImportGuildsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/guilds`,
          method: 'POST',
          body: queryArg.externalGuildChangeRequest,
          params: {
            autoCommit: queryArg.autoCommit
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportGuildsExternalIds: build.query<
        GetApiMasterDataImportGuildsExternalIdsApiResponse,
        GetApiMasterDataImportGuildsExternalIdsApiArg
      >({
        query: () => ({ url: `/api/master-data-import/guilds/external-ids` }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportGuildsSquashedByExternalId: build.query<
        GetApiMasterDataImportGuildsSquashedByExternalIdApiResponse,
        GetApiMasterDataImportGuildsSquashedByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/guilds/squashed/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportGuildsById: build.mutation<
        PostApiMasterDataImportGuildsByIdApiResponse,
        PostApiMasterDataImportGuildsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/guilds/${queryArg.id}`,
          method: 'POST',
          body: queryArg.externalGuildChangeResponse
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportGuildsById: build.query<
        GetApiMasterDataImportGuildsByIdApiResponse,
        GetApiMasterDataImportGuildsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/guilds/${queryArg.id}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportMembershipTypes: build.query<
        GetApiMasterDataImportMembershipTypesApiResponse,
        GetApiMasterDataImportMembershipTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/membership-types`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportMembershipTypes: build.mutation<
        PostApiMasterDataImportMembershipTypesApiResponse,
        PostApiMasterDataImportMembershipTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/membership-types`,
          method: 'POST',
          body: queryArg.externalMembershipTypeChangeRequest,
          params: {
            autoCommit: queryArg.autoCommit
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportMembershipTypesByExternalIdByExternalId:
        build.query<
          GetApiMasterDataImportMembershipTypesByExternalIdByExternalIdApiResponse,
          GetApiMasterDataImportMembershipTypesByExternalIdByExternalIdApiArg
        >({
          query: (queryArg) => ({
            url: `/api/master-data-import/membership-types/by-external-id/${queryArg.externalId}`
          }),
          providesTags: ['Master Data Import Resource']
        }),
      getApiMasterDataImportMembershipTypesExternalIds: build.query<
        GetApiMasterDataImportMembershipTypesExternalIdsApiResponse,
        GetApiMasterDataImportMembershipTypesExternalIdsApiArg
      >({
        query: () => ({
          url: `/api/master-data-import/membership-types/external-ids`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportMembershipTypesSquashedByExternalId: build.query<
        GetApiMasterDataImportMembershipTypesSquashedByExternalIdApiResponse,
        GetApiMasterDataImportMembershipTypesSquashedByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/membership-types/squashed/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportMembershipTypesById: build.mutation<
        PostApiMasterDataImportMembershipTypesByIdApiResponse,
        PostApiMasterDataImportMembershipTypesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/membership-types/${queryArg.id}`,
          method: 'POST',
          body: queryArg.externalMembershipTypeChangeResponse
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportMembershipTypesById: build.query<
        GetApiMasterDataImportMembershipTypesByIdApiResponse,
        GetApiMasterDataImportMembershipTypesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/membership-types/${queryArg.id}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportRoles: build.query<
        GetApiMasterDataImportRolesApiResponse,
        GetApiMasterDataImportRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/roles`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportRoles: build.mutation<
        PostApiMasterDataImportRolesApiResponse,
        PostApiMasterDataImportRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/roles`,
          method: 'POST',
          body: queryArg.externalRoleChangeRequest,
          params: {
            autoCommit: queryArg.autoCommit
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportRolesByExternalIdByExternalId: build.query<
        GetApiMasterDataImportRolesByExternalIdByExternalIdApiResponse,
        GetApiMasterDataImportRolesByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/roles/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportRolesExternalIds: build.query<
        GetApiMasterDataImportRolesExternalIdsApiResponse,
        GetApiMasterDataImportRolesExternalIdsApiArg
      >({
        query: () => ({ url: `/api/master-data-import/roles/external-ids` }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportRolesSquashedByExternalId: build.query<
        GetApiMasterDataImportRolesSquashedByExternalIdApiResponse,
        GetApiMasterDataImportRolesSquashedByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/roles/squashed/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportRolesById: build.mutation<
        PostApiMasterDataImportRolesByIdApiResponse,
        PostApiMasterDataImportRolesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/roles/${queryArg.id}`,
          method: 'POST',
          body: queryArg.externalRoleChangeResponse
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportRolesById: build.query<
        GetApiMasterDataImportRolesByIdApiResponse,
        GetApiMasterDataImportRolesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/roles/${queryArg.id}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsers: build.query<
        GetApiMasterDataImportUsersApiResponse,
        GetApiMasterDataImportUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users`,
          params: {
            onlyLatest: queryArg.onlyLatest,
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportUsers: build.mutation<
        PostApiMasterDataImportUsersApiResponse,
        PostApiMasterDataImportUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users`,
          method: 'POST',
          body: queryArg.externalUserChangeRequest,
          params: {
            autoCommit: queryArg.autoCommit
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsersByExternalIdByExternalId: build.query<
        GetApiMasterDataImportUsersByExternalIdByExternalIdApiResponse,
        GetApiMasterDataImportUsersByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsersExternalIds: build.query<
        GetApiMasterDataImportUsersExternalIdsApiResponse,
        GetApiMasterDataImportUsersExternalIdsApiArg
      >({
        query: () => ({ url: `/api/master-data-import/users/external-ids` }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsersExternalIdsWithEmails: build.query<
        GetApiMasterDataImportUsersExternalIdsWithEmailsApiResponse,
        GetApiMasterDataImportUsersExternalIdsWithEmailsApiArg
      >({
        query: () => ({
          url: `/api/master-data-import/users/external-ids-with-emails`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsersExternalIdsRebuild: build.query<
        GetApiMasterDataImportUsersExternalIdsRebuildApiResponse,
        GetApiMasterDataImportUsersExternalIdsRebuildApiArg
      >({
        query: () => ({
          url: `/api/master-data-import/users/external-ids/rebuild`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsersHashes: build.query<
        GetApiMasterDataImportUsersHashesApiResponse,
        GetApiMasterDataImportUsersHashesApiArg
      >({
        query: () => ({ url: `/api/master-data-import/users/hashes` }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportUsersLatest: build.mutation<
        PostApiMasterDataImportUsersLatestApiResponse,
        PostApiMasterDataImportUsersLatestApiArg
      >({
        query: () => ({
          url: `/api/master-data-import/users/latest`,
          method: 'POST'
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportUsersSyncAllToSquashed: build.mutation<
        PostApiMasterDataImportUsersSyncAllToSquashedApiResponse,
        PostApiMasterDataImportUsersSyncAllToSquashedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users/sync-all-to-squashed`,
          method: 'POST',
          params: {
            accessAttributeNames: queryArg.accessAttributeNames,
            dryRun: queryArg.dryRun,
            recalculate: queryArg.recalculate
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportUsersSyncById: build.mutation<
        PostApiMasterDataImportUsersSyncByIdApiResponse,
        PostApiMasterDataImportUsersSyncByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users/sync/${queryArg.id}`,
          method: 'POST'
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportUsersById: build.mutation<
        PostApiMasterDataImportUsersByIdApiResponse,
        PostApiMasterDataImportUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users/${queryArg.id}`,
          method: 'POST',
          body: queryArg.externalUserChangeResponse,
          params: {
            acceptAll: queryArg.acceptAll
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMasterDataImportUsersById: build.query<
        GetApiMasterDataImportUsersByIdApiResponse,
        GetApiMasterDataImportUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users/${queryArg.id}`
        }),
        providesTags: ['Master Data Import Resource']
      }),
      postApiMasterDataImportUsersByUserIdSyncToSquashed: build.mutation<
        PostApiMasterDataImportUsersByUserIdSyncToSquashedApiResponse,
        PostApiMasterDataImportUsersByUserIdSyncToSquashedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/master-data-import/users/${queryArg.userId}/sync-to-squashed`,
          method: 'POST',
          params: {
            accessAttributeNames: queryArg.accessAttributeNames,
            dryRun: queryArg.dryRun,
            recalculate: queryArg.recalculate
          }
        }),
        invalidatesTags: ['Master Data Import Resource']
      }),
      getApiMembershipType: build.query<
        GetApiMembershipTypeApiResponse,
        GetApiMembershipTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/membership-type`,
          params: {
            name: queryArg.name,
            search: queryArg.search,
            sort: queryArg.sort
          }
        }),
        providesTags: ['GroupMembership']
      }),
      postApiMembershipType: build.mutation<
        PostApiMembershipTypeApiResponse,
        PostApiMembershipTypeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/membership-type`,
          method: 'POST',
          body: queryArg.groupMembershipCreateDto
        }),
        invalidatesTags: ['GroupMembership']
      }),
      getApiMembershipTypeAll: build.query<
        GetApiMembershipTypeAllApiResponse,
        GetApiMembershipTypeAllApiArg
      >({
        query: () => ({ url: `/api/membership-type/all` }),
        providesTags: ['Membership Type Resource']
      }),
      getApiMembershipTypeByExternalIdByExternalId: build.query<
        GetApiMembershipTypeByExternalIdByExternalIdApiResponse,
        GetApiMembershipTypeByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/membership-type/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['Membership Type Resource']
      }),
      patchApiMembershipTypeById: build.mutation<
        PatchApiMembershipTypeByIdApiResponse,
        PatchApiMembershipTypeByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/membership-type/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.groupMembershipUpdateDto
        }),
        invalidatesTags: ['GroupMembership']
      }),
      getApiMembershipTypeById: build.query<
        GetApiMembershipTypeByIdApiResponse,
        GetApiMembershipTypeByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/membership-type/${queryArg.id}` }),
        providesTags: ['GroupMembership']
      }),
      deleteApiMembershipTypeById: build.mutation<
        DeleteApiMembershipTypeByIdApiResponse,
        DeleteApiMembershipTypeByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/membership-type/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['GroupMembership']
      }),
      getApiOidcCallback: build.query<
        GetApiOidcCallbackApiResponse,
        GetApiOidcCallbackApiArg
      >({
        query: () => ({ url: `/api/oidc/callback` }),
        providesTags: ['Oidc Resource']
      }),
      getApiOidcLogin: build.query<
        GetApiOidcLoginApiResponse,
        GetApiOidcLoginApiArg
      >({
        query: () => ({ url: `/api/oidc/login` }),
        providesTags: ['Oidc Resource']
      }),
      getApiOidcLogout: build.query<
        GetApiOidcLogoutApiResponse,
        GetApiOidcLogoutApiArg
      >({
        query: () => ({ url: `/api/oidc/logout` }),
        providesTags: ['Oidc Resource']
      }),
      getApiPolicy: build.query<GetApiPolicyApiResponse, GetApiPolicyApiArg>({
        query: (queryArg) => ({
          url: `/api/policy`,
          params: {
            action: queryArg.action,
            page: queryArg.page,
            resourceType: queryArg.resourceType,
            size: queryArg.size,
            sortKey: queryArg.sortKey,
            sortOrder: queryArg.sortOrder
          }
        }),
        providesTags: ['Policy Resource']
      }),
      postApiPolicy: build.mutation<
        PostApiPolicyApiResponse,
        PostApiPolicyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/policy`,
          method: 'POST',
          body: queryArg.createPolicy
        }),
        invalidatesTags: ['Policy Resource']
      }),
      patchApiPolicyById: build.mutation<
        PatchApiPolicyByIdApiResponse,
        PatchApiPolicyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/policy/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updatePolicy
        }),
        invalidatesTags: ['Policy Resource']
      }),
      getApiPolicyById: build.query<
        GetApiPolicyByIdApiResponse,
        GetApiPolicyByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/policy/${queryArg.id}` }),
        providesTags: ['Policy Resource']
      }),
      deleteApiPolicyById: build.mutation<
        DeleteApiPolicyByIdApiResponse,
        DeleteApiPolicyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/policy/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Policy Resource']
      }),
      getApiPosts: build.query<GetApiPostsApiResponse, GetApiPostsApiArg>({
        query: (queryArg) => ({
          url: `/api/posts`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            onlyRoot: queryArg.onlyRoot,
            page: queryArg.page,
            parent: queryArg.parent,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            status: queryArg.status,
            type: queryArg['type']
          }
        }),
        providesTags: ['Post Resource']
      }),
      postApiPosts: build.mutation<PostApiPostsApiResponse, PostApiPostsApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/posts`,
            method: 'POST',
            body: queryArg.createPost
          }),
          invalidatesTags: ['Post Resource']
        }
      ),
      getApiPostsDrafts: build.query<
        GetApiPostsDraftsApiResponse,
        GetApiPostsDraftsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/drafts`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            parent: queryArg.parent,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            type: queryArg['type']
          }
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsDraftsRoot: build.query<
        GetApiPostsDraftsRootApiResponse,
        GetApiPostsDraftsRootApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/drafts/root`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            parent: queryArg.parent,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            type: queryArg['type']
          }
        }),
        providesTags: ['Post Resource']
      }),
      patchApiPostsDraftsById: build.mutation<
        PatchApiPostsDraftsByIdApiResponse,
        PatchApiPostsDraftsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/drafts/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updatePost
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsDraftsById: build.query<
        GetApiPostsDraftsByIdApiResponse,
        GetApiPostsDraftsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/drafts/${queryArg.id}` }),
        providesTags: ['Post Resource']
      }),
      getApiPostsPlanned: build.query<
        GetApiPostsPlannedApiResponse,
        GetApiPostsPlannedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/planned`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            parent: queryArg.parent,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsPlannedById: build.query<
        GetApiPostsPlannedByIdApiResponse,
        GetApiPostsPlannedByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/planned/${queryArg.id}` }),
        providesTags: ['Post Resource']
      }),
      getApiPostsRoot: build.query<
        GetApiPostsRootApiResponse,
        GetApiPostsRootApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/root`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            parent: queryArg.parent,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort,
            type: queryArg['type']
          }
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsSearch: build.query<
        GetApiPostsSearchApiResponse,
        GetApiPostsSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/search`,
          params: {
            page: queryArg.page,
            q: queryArg.q,
            size: queryArg.size,
            type: queryArg['type']
          }
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsSummaryById: build.query<
        GetApiPostsSummaryByIdApiResponse,
        GetApiPostsSummaryByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/summary/${queryArg.id}` }),
        providesTags: ['Post Resource']
      }),
      patchApiPostsById: build.mutation<
        PatchApiPostsByIdApiResponse,
        PatchApiPostsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updatePost
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsById: build.query<
        GetApiPostsByIdApiResponse,
        GetApiPostsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/${queryArg.id}` }),
        providesTags: ['Post Resource']
      }),
      deleteApiPostsById: build.mutation<
        DeleteApiPostsByIdApiResponse,
        DeleteApiPostsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsByIdAttachments: build.query<
        GetApiPostsByIdAttachmentsApiResponse,
        GetApiPostsByIdAttachmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/attachments`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdBreadcrumbs: build.query<
        GetApiPostsByIdBreadcrumbsApiResponse,
        GetApiPostsByIdBreadcrumbsApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/${queryArg.id}/breadcrumbs` }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdComments: build.query<
        GetApiPostsByIdCommentsApiResponse,
        GetApiPostsByIdCommentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/comments`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['Post Resource']
      }),
      postApiPostsByIdComments: build.mutation<
        PostApiPostsByIdCommentsApiResponse,
        PostApiPostsByIdCommentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/comments`,
          method: 'POST',
          body: queryArg.createComment
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsByIdEmailSignature: build.query<
        GetApiPostsByIdEmailSignatureApiResponse,
        GetApiPostsByIdEmailSignatureApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/email-signature`
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdEmailTemplate: build.query<
        GetApiPostsByIdEmailTemplateApiResponse,
        GetApiPostsByIdEmailTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/email-template`
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdNewsletter: build.query<
        GetApiPostsByIdNewsletterApiResponse,
        GetApiPostsByIdNewsletterApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/${queryArg.id}/newsletter` }),
        providesTags: ['Post Resource']
      }),
      postApiPostsByIdNewsletter: build.mutation<
        PostApiPostsByIdNewsletterApiResponse,
        PostApiPostsByIdNewsletterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/newsletter`,
          method: 'POST',
          body: queryArg.createNewsletterArticle
        }),
        invalidatesTags: ['Post Resource']
      }),
      patchApiPostsByIdNewsletterAndArticleId: build.mutation<
        PatchApiPostsByIdNewsletterAndArticleIdApiResponse,
        PatchApiPostsByIdNewsletterAndArticleIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/newsletter/${queryArg.articleId}`,
          method: 'PATCH',
          body: queryArg.updateNewsletterArticle
        }),
        invalidatesTags: ['Post Resource']
      }),
      deleteApiPostsByIdNewsletterAndArticleId: build.mutation<
        DeleteApiPostsByIdNewsletterAndArticleIdApiResponse,
        DeleteApiPostsByIdNewsletterAndArticleIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/newsletter/${queryArg.articleId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsByIdNotifications: build.query<
        GetApiPostsByIdNotificationsApiResponse,
        GetApiPostsByIdNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/notifications`
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdNotificationsUserAndTargetUserIdHistory: build.query<
        GetApiPostsByIdNotificationsUserAndTargetUserIdHistoryApiResponse,
        GetApiPostsByIdNotificationsUserAndTargetUserIdHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/notifications/user/${queryArg.targetUserId}/history`
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdNotificationsAndNotificationIdHistory: build.query<
        GetApiPostsByIdNotificationsAndNotificationIdHistoryApiResponse,
        GetApiPostsByIdNotificationsAndNotificationIdHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/notifications/${queryArg.notificationId}/history`
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdParents: build.query<
        GetApiPostsByIdParentsApiResponse,
        GetApiPostsByIdParentsApiArg
      >({
        query: (queryArg) => ({ url: `/api/posts/${queryArg.id}/parents` }),
        providesTags: ['Post Resource']
      }),
      postApiPostsByIdPublish: build.mutation<
        PostApiPostsByIdPublishApiResponse,
        PostApiPostsByIdPublishApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/publish`,
          method: 'POST'
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsByIdRecipients: build.query<
        GetApiPostsByIdRecipientsApiResponse,
        GetApiPostsByIdRecipientsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/recipients`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            emailFilter: queryArg.emailFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdRecipientsSummary: build.query<
        GetApiPostsByIdRecipientsSummaryApiResponse,
        GetApiPostsByIdRecipientsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/recipients/summary`
        }),
        providesTags: ['Post Resource']
      }),
      getApiPostsByIdResendAndNotificationId: build.mutation<
        GetApiPostsByIdResendAndNotificationIdApiResponse,
        GetApiPostsByIdResendAndNotificationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/resend/${queryArg.notificationId}`,
          method: 'GET'
        }),
        invalidatesTags: ['Post Resource']
      }),
      postApiPostsByIdSend: build.mutation<
        PostApiPostsByIdSendApiResponse,
        PostApiPostsByIdSendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/send`,
          method: 'POST'
        }),
        invalidatesTags: ['Post Resource']
      }),
      postApiPostsByIdSendAndUserId: build.mutation<
        PostApiPostsByIdSendAndUserIdApiResponse,
        PostApiPostsByIdSendAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/send/${queryArg.userId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiPostsByIdUndeliveredNotifications: build.query<
        GetApiPostsByIdUndeliveredNotificationsApiResponse,
        GetApiPostsByIdUndeliveredNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/undelivered-notifications`
        }),
        providesTags: ['Post Resource']
      }),
      postApiPostsByIdVote: build.mutation<
        PostApiPostsByIdVoteApiResponse,
        PostApiPostsByIdVoteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/posts/${queryArg.id}/vote`,
          method: 'POST',
          body: queryArg.vote
        }),
        invalidatesTags: ['Post Resource']
      }),
      getApiRoles: build.query<GetApiRolesApiResponse, GetApiRolesApiArg>({
        query: (queryArg) => ({
          url: `/api/roles`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Role Resource']
      }),
      postApiRoles: build.mutation<PostApiRolesApiResponse, PostApiRolesApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/roles`,
            method: 'POST',
            body: queryArg.createRole
          }),
          invalidatesTags: ['Role Resource']
        }
      ),
      getApiRolesByExternalIdByExternalId: build.query<
        GetApiRolesByExternalIdByExternalIdApiResponse,
        GetApiRolesByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/roles/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['Role Resource']
      }),
      patchApiRolesByRoleId: build.mutation<
        PatchApiRolesByRoleIdApiResponse,
        PatchApiRolesByRoleIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/roles/${queryArg.roleId}`,
          method: 'PATCH',
          body: queryArg.createRole
        }),
        invalidatesTags: ['Role Resource']
      }),
      getApiRolesByRoleId: build.query<
        GetApiRolesByRoleIdApiResponse,
        GetApiRolesByRoleIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/roles/${queryArg.roleId}` }),
        providesTags: ['Role Resource']
      }),
      getApiSchedulerTasks: build.query<
        GetApiSchedulerTasksApiResponse,
        GetApiSchedulerTasksApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler-tasks`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Scheduler Task Resource']
      }),
      getApiSchedulerTasksById: build.query<
        GetApiSchedulerTasksByIdApiResponse,
        GetApiSchedulerTasksByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/scheduler-tasks/${queryArg.id}` }),
        providesTags: ['Scheduler Task Resource']
      }),
      postApiSchedulerAssociation: build.mutation<
        PostApiSchedulerAssociationApiResponse,
        PostApiSchedulerAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/association`,
          method: 'POST',
          body: queryArg.createAssociation
        }),
        invalidatesTags: ['Create Association Resource']
      }),
      postApiSchedulerBatchTasksRun: build.mutation<
        PostApiSchedulerBatchTasksRunApiResponse,
        PostApiSchedulerBatchTasksRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/batch-tasks/run`,
          method: 'POST',
          body: queryArg.batchTaskRunRequest
        }),
        invalidatesTags: ['Batch Task Worker Resource']
      }),
      getApiSchedulerBrevoEvents: build.query<
        GetApiSchedulerBrevoEventsApiResponse,
        GetApiSchedulerBrevoEventsApiArg
      >({
        query: () => ({ url: `/api/scheduler/brevo/events` }),
        providesTags: ['Brevo Event Poller Resource']
      }),
      getApiSchedulerBrevoEventsPollByTenantId: build.query<
        GetApiSchedulerBrevoEventsPollByTenantIdApiResponse,
        GetApiSchedulerBrevoEventsPollByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/brevo/events/poll/${queryArg.tenantId}`
        }),
        providesTags: ['Brevo Event Poller Resource']
      }),
      getApiSchedulerCalculateMonthlyStatsCalculate: build.query<
        GetApiSchedulerCalculateMonthlyStatsCalculateApiResponse,
        GetApiSchedulerCalculateMonthlyStatsCalculateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/calculate-monthly-stats/calculate`,
          params: {
            'day-in-month': queryArg['day-in-month']
          }
        }),
        providesTags: ['Invoice Monthly Stats Resource']
      }),
      postApiSchedulerChatSyncByTenantId: build.mutation<
        PostApiSchedulerChatSyncByTenantIdApiResponse,
        PostApiSchedulerChatSyncByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/chat/sync/${queryArg.tenantId}`,
          method: 'POST',
          params: {
            dryRun: queryArg.dryRun
          }
        }),
        invalidatesTags: ['Sync Chat Users Resource']
      }),
      postApiSchedulerDistrictCodeByTenantId: build.mutation<
        PostApiSchedulerDistrictCodeByTenantIdApiResponse,
        PostApiSchedulerDistrictCodeByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/district-code/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['District Code Scheduler Resource']
      }),
      postApiSchedulerDomainSync: build.mutation<
        PostApiSchedulerDomainSyncApiResponse,
        PostApiSchedulerDomainSyncApiArg
      >({
        query: () => ({ url: `/api/scheduler/domain-sync`, method: 'POST' }),
        invalidatesTags: ['Domain Sync Resource']
      }),
      postApiSchedulerDomainSyncByTenantId: build.mutation<
        PostApiSchedulerDomainSyncByTenantIdApiResponse,
        PostApiSchedulerDomainSyncByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/domain-sync/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Domain Sync Resource']
      }),
      getApiSchedulerEmailAlerts: build.query<
        GetApiSchedulerEmailAlertsApiResponse,
        GetApiSchedulerEmailAlertsApiArg
      >({
        query: () => ({ url: `/api/scheduler/email/alerts` }),
        providesTags: ['Email Delivery Alert Resource']
      }),
      getApiSchedulerEmailEvents: build.query<
        GetApiSchedulerEmailEventsApiResponse,
        GetApiSchedulerEmailEventsApiArg
      >({
        query: () => ({ url: `/api/scheduler/email/events` }),
        providesTags: ['Email Event Poller Resource']
      }),
      getApiSchedulerEmailSender: build.query<
        GetApiSchedulerEmailSenderApiResponse,
        GetApiSchedulerEmailSenderApiArg
      >({
        query: () => ({ url: `/api/scheduler/email/sender` }),
        providesTags: ['Email Send Queue Resource']
      }),
      postApiSchedulerEmailSenderSend: build.mutation<
        PostApiSchedulerEmailSenderSendApiResponse,
        PostApiSchedulerEmailSenderSendApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/email/sender/send`,
          method: 'POST',
          body: queryArg.emailSendRequest
        }),
        invalidatesTags: ['Email Send Queue Resource']
      }),
      getApiSchedulerEmailSenderSmooth: build.query<
        GetApiSchedulerEmailSenderSmoothApiResponse,
        GetApiSchedulerEmailSenderSmoothApiArg
      >({
        query: () => ({ url: `/api/scheduler/email/sender/smooth` }),
        providesTags: ['Email Send Queue Resource']
      }),
      postApiSchedulerEmailSenderByTenantIdAndPostId: build.mutation<
        PostApiSchedulerEmailSenderByTenantIdAndPostIdApiResponse,
        PostApiSchedulerEmailSenderByTenantIdAndPostIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/email/sender/${queryArg.tenantId}/${queryArg.postId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Email Send Queue Resource']
      }),
      getApiSchedulerInvoicesCreate: build.query<
        GetApiSchedulerInvoicesCreateApiResponse,
        GetApiSchedulerInvoicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/invoices/create`,
          params: {
            'day-in-month': queryArg['day-in-month']
          }
        }),
        providesTags: ['Invoice Resource']
      }),
      getApiSchedulerMailgunEvents: build.query<
        GetApiSchedulerMailgunEventsApiResponse,
        GetApiSchedulerMailgunEventsApiArg
      >({
        query: () => ({ url: `/api/scheduler/mailgun/events` }),
        providesTags: ['Mailgun Event Poller Resource']
      }),
      getApiSchedulerMailgunEventsPollByTenantId: build.query<
        GetApiSchedulerMailgunEventsPollByTenantIdApiResponse,
        GetApiSchedulerMailgunEventsPollByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/mailgun/events/poll/${queryArg.tenantId}`
        }),
        providesTags: ['Mailgun Event Poller Resource']
      }),
      postApiSchedulerMeilisearchCompaniesByTenantId: build.mutation<
        PostApiSchedulerMeilisearchCompaniesByTenantIdApiResponse,
        PostApiSchedulerMeilisearchCompaniesByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/meilisearch/companies/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Meilisearch Setup']
      }),
      postApiSchedulerMeilisearchPostTimestampsByTenantId: build.mutation<
        PostApiSchedulerMeilisearchPostTimestampsByTenantIdApiResponse,
        PostApiSchedulerMeilisearchPostTimestampsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/meilisearch/post_timestamps/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Meilisearch Setup']
      }),
      postApiSchedulerMeilisearchPostTypesByTenantId: build.mutation<
        PostApiSchedulerMeilisearchPostTypesByTenantIdApiResponse,
        PostApiSchedulerMeilisearchPostTypesByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/meilisearch/post_types/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Meilisearch Setup']
      }),
      postApiSchedulerMeilisearchPostsByTenantId: build.mutation<
        PostApiSchedulerMeilisearchPostsByTenantIdApiResponse,
        PostApiSchedulerMeilisearchPostsByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/meilisearch/posts/${queryArg.tenantId}`,
          method: 'POST'
        }),
        invalidatesTags: ['Meilisearch Setup']
      }),
      postApiSchedulerMeilisearchSetup: build.mutation<
        PostApiSchedulerMeilisearchSetupApiResponse,
        PostApiSchedulerMeilisearchSetupApiArg
      >({
        query: () => ({
          url: `/api/scheduler/meilisearch/setup`,
          method: 'POST'
        }),
        invalidatesTags: ['Meilisearch Setup']
      }),
      getApiSchedulerMsGraphEvents: build.query<
        GetApiSchedulerMsGraphEventsApiResponse,
        GetApiSchedulerMsGraphEventsApiArg
      >({
        query: () => ({ url: `/api/scheduler/ms-graph/events` }),
        providesTags: ['Ms Graph Event Poller Resource']
      }),
      postApiSchedulerPlannedPostsCacheByTenantId: build.mutation<
        PostApiSchedulerPlannedPostsCacheByTenantIdApiResponse,
        PostApiSchedulerPlannedPostsCacheByTenantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/planned_posts/cache/${queryArg.tenantId}`,
          method: 'POST',
          body: queryArg.postBuildCacheRequest
        }),
        invalidatesTags: ['Planned Posts Resource']
      }),
      getApiSchedulerPlannedPostsPublish: build.query<
        GetApiSchedulerPlannedPostsPublishApiResponse,
        GetApiSchedulerPlannedPostsPublishApiArg
      >({
        query: () => ({ url: `/api/scheduler/planned_posts/publish` }),
        providesTags: ['Planned Posts Resource']
      }),
      getApiSchedulerPlannedPostsPublishByTenantIdAndPostId: build.query<
        GetApiSchedulerPlannedPostsPublishByTenantIdAndPostIdApiResponse,
        GetApiSchedulerPlannedPostsPublishByTenantIdAndPostIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/planned_posts/publish/${queryArg.tenantId}/${queryArg.postId}`,
          params: {
            isPlanned: queryArg.isPlanned
          }
        }),
        providesTags: ['Planned Posts Resource']
      }),
      postApiSchedulerStorageDocumentUpload: build.mutation<
        PostApiSchedulerStorageDocumentUploadApiResponse,
        PostApiSchedulerStorageDocumentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/storage/document-upload`,
          method: 'POST',
          body: queryArg.jsonObject
        }),
        invalidatesTags: ['Upload Finished Resource']
      }),
      postApiSchedulerTasksExecute: build.mutation<
        PostApiSchedulerTasksExecuteApiResponse,
        PostApiSchedulerTasksExecuteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scheduler/tasks/execute`,
          method: 'POST',
          body: queryArg.httpJob
        }),
        invalidatesTags: ['Task Resource']
      }),
      postApiSchedulerTasksTest: build.mutation<
        PostApiSchedulerTasksTestApiResponse,
        PostApiSchedulerTasksTestApiArg
      >({
        query: () => ({ url: `/api/scheduler/tasks/test`, method: 'POST' }),
        invalidatesTags: ['Task Resource']
      }),
      getApiSchedulerTasksTest: build.query<
        GetApiSchedulerTasksTestApiResponse,
        GetApiSchedulerTasksTestApiArg
      >({
        query: () => ({ url: `/api/scheduler/tasks/test` }),
        providesTags: ['Task Resource']
      }),
      postApiSurveys: build.mutation<
        PostApiSurveysApiResponse,
        PostApiSurveysApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys`,
          method: 'POST',
          body: queryArg.createSurvey
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysByTokenByToken: build.query<
        GetApiSurveysByTokenByTokenApiResponse,
        GetApiSurveysByTokenByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/by-token/${queryArg.token}`
        }),
        providesTags: ['Survey Resource']
      }),
      postApiSurveysRespond: build.mutation<
        PostApiSurveysRespondApiResponse,
        PostApiSurveysRespondApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/respond`,
          method: 'POST',
          body: queryArg.createOrUpdateSurveyResponseWithToken
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysTemplates: build.query<
        GetApiSurveysTemplatesApiResponse,
        GetApiSurveysTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/templates`,
          params: {
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Survey Resource']
      }),
      patchApiSurveysById: build.mutation<
        PatchApiSurveysByIdApiResponse,
        PatchApiSurveysByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateSurvey
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysById: build.query<
        GetApiSurveysByIdApiResponse,
        GetApiSurveysByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/surveys/${queryArg.id}` }),
        providesTags: ['Survey Resource']
      }),
      deleteApiSurveysById: build.mutation<
        DeleteApiSurveysByIdApiResponse,
        DeleteApiSurveysByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysByIdAllResponses: build.query<
        GetApiSurveysByIdAllResponsesApiResponse,
        GetApiSurveysByIdAllResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/all-responses`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            search: queryArg.search,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Survey Resource']
      }),
      getApiSurveysByIdParticipants: build.query<
        GetApiSurveysByIdParticipantsApiResponse,
        GetApiSurveysByIdParticipantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/participants`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Survey Resource']
      }),
      postApiSurveysByIdPublish: build.mutation<
        PostApiSurveysByIdPublishApiResponse,
        PostApiSurveysByIdPublishApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/publish`,
          method: 'POST'
        }),
        invalidatesTags: ['Survey Resource']
      }),
      patchApiSurveysByIdResponse: build.mutation<
        PatchApiSurveysByIdResponseApiResponse,
        PatchApiSurveysByIdResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/response`,
          method: 'PATCH',
          body: queryArg.createSurveyResponse
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysByIdResponse: build.query<
        GetApiSurveysByIdResponseApiResponse,
        GetApiSurveysByIdResponseApiArg
      >({
        query: (queryArg) => ({ url: `/api/surveys/${queryArg.id}/response` }),
        providesTags: ['Survey Resource']
      }),
      postApiSurveysByIdResponse: build.mutation<
        PostApiSurveysByIdResponseApiResponse,
        PostApiSurveysByIdResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/response`,
          method: 'POST',
          body: queryArg.createSurveyResponse
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysByIdResponseByUserAndUserId: build.query<
        GetApiSurveysByIdResponseByUserAndUserIdApiResponse,
        GetApiSurveysByIdResponseByUserAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/response-by-user/${queryArg.userId}`
        }),
        providesTags: ['Survey Resource']
      }),
      patchApiSurveysByIdResponseAndResponseId: build.mutation<
        PatchApiSurveysByIdResponseAndResponseIdApiResponse,
        PatchApiSurveysByIdResponseAndResponseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/response/${queryArg.responseId}`,
          method: 'PATCH',
          body: queryArg.createSurveyResponse
        }),
        invalidatesTags: ['Survey Resource']
      }),
      getApiSurveysByIdResponses: build.query<
        GetApiSurveysByIdResponsesApiResponse,
        GetApiSurveysByIdResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/surveys/${queryArg.id}/responses`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['Survey Resource']
      }),
      getApiTags: build.query<GetApiTagsApiResponse, GetApiTagsApiArg>({
        query: () => ({ url: `/api/tags` }),
        providesTags: ['Tag Resource']
      }),
      postApiTags: build.mutation<PostApiTagsApiResponse, PostApiTagsApiArg>({
        query: (queryArg) => ({
          url: `/api/tags`,
          method: 'POST',
          body: queryArg.tag
        }),
        invalidatesTags: ['Tag Resource']
      }),
      patchApiTagsById: build.mutation<
        PatchApiTagsByIdApiResponse,
        PatchApiTagsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/tags/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.tag
        }),
        invalidatesTags: ['Tag Resource']
      }),
      deleteApiTagsById: build.mutation<
        DeleteApiTagsByIdApiResponse,
        DeleteApiTagsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/tags/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Tag Resource']
      }),
      postApiTestIdentityPlatformManagedOverride: build.mutation<
        PostApiTestIdentityPlatformManagedOverrideApiResponse,
        PostApiTestIdentityPlatformManagedOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/test/identity-platform/managed-override`,
          method: 'POST',
          params: {
            managed: queryArg.managed
          }
        }),
        invalidatesTags: ['Test Resource']
      }),
      getApiTextBlock: build.query<
        GetApiTextBlockApiResponse,
        GetApiTextBlockApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-block`,
          params: {
            key: queryArg.key,
            locale: queryArg.locale,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['TextBlock']
      }),
      postApiTextBlock: build.mutation<
        PostApiTextBlockApiResponse,
        PostApiTextBlockApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-block`,
          method: 'POST',
          body: queryArg.textBlockCreateDto
        }),
        invalidatesTags: ['TextBlock']
      }),
      postApiTextBlockLoadDefaults: build.mutation<
        PostApiTextBlockLoadDefaultsApiResponse,
        PostApiTextBlockLoadDefaultsApiArg
      >({
        query: () => ({ url: `/api/text-block/load-defaults`, method: 'POST' }),
        invalidatesTags: ['TextBlock']
      }),
      patchApiTextBlockById: build.mutation<
        PatchApiTextBlockByIdApiResponse,
        PatchApiTextBlockByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-block/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.textBlockUpdateDto
        }),
        invalidatesTags: ['TextBlock']
      }),
      getApiTextBlockById: build.query<
        GetApiTextBlockByIdApiResponse,
        GetApiTextBlockByIdApiArg
      >({
        query: (queryArg) => ({ url: `/api/text-block/${queryArg.id}` }),
        providesTags: ['TextBlock']
      }),
      deleteApiTextBlockById: build.mutation<
        DeleteApiTextBlockByIdApiResponse,
        DeleteApiTextBlockByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-block/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['TextBlock']
      }),
      postApiTextGeneratorFeedMessage: build.mutation<
        PostApiTextGeneratorFeedMessageApiResponse,
        PostApiTextGeneratorFeedMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-generator/feed-message`,
          method: 'POST',
          body: queryArg.generateText
        }),
        invalidatesTags: ['Text Generator Resource']
      }),
      postApiTextGeneratorTeaser: build.mutation<
        PostApiTextGeneratorTeaserApiResponse,
        PostApiTextGeneratorTeaserApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-generator/teaser`,
          method: 'POST',
          body: queryArg.generateText
        }),
        invalidatesTags: ['Text Generator Resource']
      }),
      getApiUsers: build.query<GetApiUsersApiResponse, GetApiUsersApiArg>({
        query: (queryArg) => ({
          url: `/api/users`,
          params: {
            accessAttributeFilter: queryArg.accessAttributeFilter,
            filter: queryArg.filter,
            page: queryArg.page,
            search: queryArg.search,
            size: queryArg.size,
            sort: queryArg.sort
          }
        }),
        providesTags: ['User Resource']
      }),
      postApiUsers: build.mutation<PostApiUsersApiResponse, PostApiUsersApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/users`,
            method: 'POST',
            body: queryArg.createUser
          }),
          invalidatesTags: ['User Resource']
        }
      ),
      getApiUsersByExternalIdByExternalId: build.query<
        GetApiUsersByExternalIdByExternalIdApiResponse,
        GetApiUsersByExternalIdByExternalIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/by-external-id/${queryArg.externalId}`
        }),
        providesTags: ['User Resource']
      }),
      getApiUsersEmailBlocked: build.query<
        GetApiUsersEmailBlockedApiResponse,
        GetApiUsersEmailBlockedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/email-blocked`,
          params: {
            page: queryArg.page,
            size: queryArg.size
          }
        }),
        providesTags: ['User Resource']
      }),
      deleteApiUsersEmailBlockedByUserId: build.mutation<
        DeleteApiUsersEmailBlockedByUserIdApiResponse,
        DeleteApiUsersEmailBlockedByUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/email-blocked/${queryArg.userId}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['User Resource']
      }),
      patchApiUsersMe: build.mutation<
        PatchApiUsersMeApiResponse,
        PatchApiUsersMeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/me`,
          method: 'PATCH',
          body: queryArg.updateUser
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersMe: build.query<GetApiUsersMeApiResponse, GetApiUsersMeApiArg>(
        {
          query: () => ({ url: `/api/users/me` }),
          providesTags: ['User Resource']
        }
      ),
      getApiUsersMeChatToken: build.query<
        GetApiUsersMeChatTokenApiResponse,
        GetApiUsersMeChatTokenApiArg
      >({
        query: () => ({ url: `/api/users/me/chat_token` }),
        providesTags: ['User Resource']
      }),
      postApiUsersMeCloudMessageToken: build.mutation<
        PostApiUsersMeCloudMessageTokenApiResponse,
        PostApiUsersMeCloudMessageTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/me/cloud_message_token`,
          method: 'POST',
          body: queryArg.setCloudMessageToken
        }),
        invalidatesTags: ['User Resource']
      }),
      postApiUsersMeResetPassword: build.mutation<
        PostApiUsersMeResetPasswordApiResponse,
        PostApiUsersMeResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/me/reset_password`,
          method: 'POST',
          body: queryArg.resetPasswordRequest
        }),
        invalidatesTags: ['User Resource']
      }),
      patchApiUsersMeTagNotificationSettings: build.mutation<
        PatchApiUsersMeTagNotificationSettingsApiResponse,
        PatchApiUsersMeTagNotificationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/me/tag_notification_settings`,
          method: 'PATCH',
          body: queryArg.userTagNotificationUpdate
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersMeTagNotificationSettings: build.query<
        GetApiUsersMeTagNotificationSettingsApiResponse,
        GetApiUsersMeTagNotificationSettingsApiArg
      >({
        query: () => ({ url: `/api/users/me/tag_notification_settings` }),
        providesTags: ['User Resource']
      }),
      putApiUsersNotificationSettingsByToken: build.mutation<
        PutApiUsersNotificationSettingsByTokenApiResponse,
        PutApiUsersNotificationSettingsByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/notification-settings/${queryArg.token}`,
          method: 'PUT',
          body: queryArg.userTagNotificationUpdate
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersNotificationSettingsByToken: build.query<
        GetApiUsersNotificationSettingsByTokenApiResponse,
        GetApiUsersNotificationSettingsByTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/notification-settings/${queryArg.token}`
        }),
        providesTags: ['User Resource']
      }),
      postApiUsersRecoverPassword: build.mutation<
        PostApiUsersRecoverPasswordApiResponse,
        PostApiUsersRecoverPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/recover_password`,
          method: 'POST',
          body: queryArg.recoverPasswordRequest
        }),
        invalidatesTags: ['User Resource']
      }),
      postApiUsersSetPassword: build.mutation<
        PostApiUsersSetPasswordApiResponse,
        PostApiUsersSetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/set_password`,
          method: 'POST',
          body: queryArg.setPasswordWithTokenRequest
        }),
        invalidatesTags: ['User Resource']
      }),
      postApiUsersSignInWithEmailLink: build.mutation<
        PostApiUsersSignInWithEmailLinkApiResponse,
        PostApiUsersSignInWithEmailLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/sign_in_with_email_link`,
          method: 'POST',
          body: queryArg.signInWithEmailLink
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersTenant: build.query<
        GetApiUsersTenantApiResponse,
        GetApiUsersTenantApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/tenant`,
          params: {
            email: queryArg.email
          }
        }),
        providesTags: ['User Resource']
      }),
      getApiUsersUnsubscribeByCredential: build.query<
        GetApiUsersUnsubscribeByCredentialApiResponse,
        GetApiUsersUnsubscribeByCredentialApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/unsubscribe/${queryArg.credential}`
        }),
        providesTags: ['User Resource']
      }),
      postApiUsersUnsubscribeByCredential: build.mutation<
        PostApiUsersUnsubscribeByCredentialApiResponse,
        PostApiUsersUnsubscribeByCredentialApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/unsubscribe/${queryArg.credential}`,
          method: 'POST'
        }),
        invalidatesTags: ['User Resource']
      }),
      putApiUsersUnsubscribeByCredentialEmail: build.mutation<
        PutApiUsersUnsubscribeByCredentialEmailApiResponse,
        PutApiUsersUnsubscribeByCredentialEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/unsubscribe/${queryArg.credential}/email`,
          method: 'PUT',
          body: queryArg.setEmailEnabledRequest
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersUnsubscribeByCredentialPreferences: build.query<
        GetApiUsersUnsubscribeByCredentialPreferencesApiResponse,
        GetApiUsersUnsubscribeByCredentialPreferencesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/unsubscribe/${queryArg.credential}/preferences`
        }),
        providesTags: ['User Resource']
      }),
      putApiUsersUnsubscribeByCredentialTopicsAndTag: build.mutation<
        PutApiUsersUnsubscribeByCredentialTopicsAndTagApiResponse,
        PutApiUsersUnsubscribeByCredentialTopicsAndTagApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/unsubscribe/${queryArg.credential}/topics/${queryArg.tag}`,
          method: 'PUT',
          body: queryArg.setEmailEnabledRequest
        }),
        invalidatesTags: ['User Resource']
      }),
      patchApiUsersById: build.mutation<
        PatchApiUsersByIdApiResponse,
        PatchApiUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateUser
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersById: build.query<
        GetApiUsersByIdApiResponse,
        GetApiUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}`,
          params: {
            expandAccessAttributes: queryArg.expandAccessAttributes
          }
        }),
        providesTags: ['User Resource']
      }),
      deleteApiUsersById: build.mutation<
        DeleteApiUsersByIdApiResponse,
        DeleteApiUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['User Resource']
      }),
      postApiUsersByIdResetPassword: build.mutation<
        PostApiUsersByIdResetPasswordApiResponse,
        PostApiUsersByIdResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/reset_password`,
          method: 'POST',
          body: queryArg.resetPasswordRequest
        }),
        invalidatesTags: ['User Resource']
      }),
      patchApiUsersByIdTagNotificationSettings: build.mutation<
        PatchApiUsersByIdTagNotificationSettingsApiResponse,
        PatchApiUsersByIdTagNotificationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/tag_notification_settings`,
          method: 'PATCH',
          body: queryArg.userTagNotificationUpdate
        }),
        invalidatesTags: ['User Resource']
      }),
      getApiUsersByIdTagNotificationSettings: build.query<
        GetApiUsersByIdTagNotificationSettingsApiResponse,
        GetApiUsersByIdTagNotificationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${queryArg.id}/tag_notification_settings`
        }),
        providesTags: ['User Resource']
      }),
      getApiVersion: build.query<GetApiVersionApiResponse, GetApiVersionApiArg>(
        {
          query: () => ({ url: `/api/version` }),
          providesTags: ['Version Resource']
        }
      )
    }),
    overrideExisting: false
  });
export { injectedRtkApi as deinVerbandApi };
export type GetApiAccessAttributesApiResponse =
  /** status 200 OK */ AccessAttribute[];
export type GetApiAccessAttributesApiArg = void;
export type PostApiAccessAttributesApiResponse = /** status 200 OK */ any;
export type PostApiAccessAttributesApiArg = {
  createAccessAttribute: CreateAccessAttribute;
};
export type PostApiAccessAttributesValuesApiResponse = /** status 200 OK */ any;
export type PostApiAccessAttributesValuesApiArg = {
  createAttributeValueByName: CreateAttributeValueByName;
};
export type GetApiAccessAttributesByIdApiResponse =
  /** status 200 OK */ AccessAttribute;
export type GetApiAccessAttributesByIdApiArg = {
  id: number;
};
export type GetApiAccessAttributesByIdValuesApiResponse =
  /** status 200 OK */ PaginatedResponseAccessAttributeValue;
export type GetApiAccessAttributesByIdValuesApiArg = {
  id: number;
  page?: number | null;
  size?: number | null;
  sortKey?: AccessAttributeSortKey & any;
  sortOrder?: SortOrder & any;
};
export type GetApiAccessAttributesByIdValuesAndValueIdApiResponse =
  /** status 200 OK */ AccessAttributeValue;
export type GetApiAccessAttributesByIdValuesAndValueIdApiArg = {
  id: number;
  valueId: number;
};
export type DeleteApiAccessAttributesByIdValuesAndValueIdApiResponse = unknown;
export type DeleteApiAccessAttributesByIdValuesAndValueIdApiArg = {
  id: number;
  valueId: number;
};
export type GetApiApiKeysApiResponse = /** status 200 OK */ ApiKeyInfo[];
export type GetApiApiKeysApiArg = void;
export type PostApiApiKeysApiResponse = /** status 200 OK */ ApiKeyCreated;
export type PostApiApiKeysApiArg = {
  createApiKeyRequest: CreateApiKeyRequest;
};
export type DeleteApiApiKeysByIdApiResponse = unknown;
export type DeleteApiApiKeysByIdApiArg = {
  id: number;
  revokeApiKeyRequest: RevokeApiKeyRequest;
};
export type PostApiAssociationApiResponse =
  /** status 200 OK */ AssociationCreatedResponse;
export type PostApiAssociationApiArg = {
  createAssociation: CreateAssociation;
};
export type GetApiAssociationAdminAccessAttributeValueApiResponse =
  /** status 200 OK */ AccessAttributeValue;
export type GetApiAssociationAdminAccessAttributeValueApiArg = void;
export type PostApiAssociationConfigApiResponse = unknown;
export type PostApiAssociationConfigApiArg = {
  configValue: ConfigValue;
};
export type GetApiAssociationConfigApiResponse = /** status 200 OK */ string;
export type GetApiAssociationConfigApiArg = {
  path: string;
};
export type GetApiAssociationInfoApiResponse =
  /** status 200 OK */ AssociationInfo;
export type GetApiAssociationInfoApiArg = void;
export type GetApiAuthLoginApiResponse = /** status 200 OK */ any;
export type GetApiAuthLoginApiArg = {
  redirectPath?: string | null;
};
export type GetApiAuthLogoutApiResponse = /** status 200 OK */ any;
export type GetApiAuthLogoutApiArg = void;
export type GetApiAuthSessionApiResponse = /** status 200 OK */ any;
export type GetApiAuthSessionApiArg = void;
export type GetApiChatDevicesApiResponse = /** status 200 OK */ string[];
export type GetApiChatDevicesApiArg = void;
export type GetApiChatTokenApiResponse = /** status 200 OK */ string;
export type GetApiChatTokenApiArg = void;
export type GetApiCompaniesApiResponse =
  /** status 200 OK */ PaginatedResponseCompanySummary;
export type GetApiCompaniesApiArg = {
  groupId?: ResourceId | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sortKey?: CompanySortKey & any;
  sortOrder?: SortOrder & any;
};
export type PostApiCompaniesApiResponse = /** status 200 OK */ any;
export type PostApiCompaniesApiArg = {
  createCompany: CreateCompany;
};
export type GetApiCompaniesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ CompanyDetails;
export type GetApiCompaniesByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type GetApiCompaniesMyApiResponse =
  /** status 200 OK */ CompanyDetails[];
export type GetApiCompaniesMyApiArg = void;
export type PatchApiCompaniesByIdApiResponse = unknown;
export type PatchApiCompaniesByIdApiArg = {
  id: ResourceId;
  updateCompany: UpdateCompany;
};
export type GetApiCompaniesByIdApiResponse =
  /** status 200 OK */ CompanyDetails;
export type GetApiCompaniesByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiCompaniesByIdApiResponse = unknown;
export type DeleteApiCompaniesByIdApiArg = {
  id: ResourceId;
};
export type GetApiCompaniesByIdUsersApiResponse =
  /** status 200 OK */ UserSummary[];
export type GetApiCompaniesByIdUsersApiArg = {
  id: ResourceId;
};
export type PostApiControlPlaneAssociationApiResponse =
  /** status 200 OK */ AssociationCreatedResponse;
export type PostApiControlPlaneAssociationApiArg = {
  createAssociation: CreateAssociation;
};
export type PostApiControlPlaneAssociationResetByTenantIdApiResponse = unknown;
export type PostApiControlPlaneAssociationResetByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiControlPlaneAssociationSetTenantConfigByTenantIdApiResponse =
  unknown;
export type PostApiControlPlaneAssociationSetTenantConfigByTenantIdApiArg = {
  tenantId: string;
  tenantConfiguration: TenantConfiguration;
};
export type PostApiControlPlaneAssociationSyncIpByTenantIdApiResponse = unknown;
export type PostApiControlPlaneAssociationSyncIpByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiControlPlaneAssociationsApiResponse =
  /** status 200 OK */ PaginatedResponseAssociation;
export type GetApiControlPlaneAssociationsApiArg = {
  page?: number | null;
  size?: number | null;
};
export type PostApiControlPlaneAuditByTenantIdApiResponse =
  /** status 200 OK */ AuditReport[];
export type PostApiControlPlaneAuditByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiControlPlaneBillableMembershipsByTenantIdApiResponse =
  /** status 200 OK */ BillableMembershipDto[];
export type GetApiControlPlaneBillableMembershipsByTenantIdApiArg = {
  tenantId: string;
};
export type PutApiControlPlaneBillableMembershipsByTenantIdAndMembershipIdApiResponse =
  unknown;
export type PutApiControlPlaneBillableMembershipsByTenantIdAndMembershipIdApiArg =
  {
    membershipId: string;
    tenantId: string;
    setBillableRequest: SetBillableRequest;
  };
export type GetApiControlPlaneBillingMetricsByTenantIdApiResponse =
  /** status 200 OK */ BillingMetricDto[];
export type GetApiControlPlaneBillingMetricsByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiControlPlaneDistrictCodeByTenantIdApiResponse = unknown;
export type PostApiControlPlaneDistrictCodeByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiControlPlaneDomainSyncApiResponse = unknown;
export type PostApiControlPlaneDomainSyncApiArg = void;
export type PostApiControlPlaneDomainSyncByTenantIdApiResponse = unknown;
export type PostApiControlPlaneDomainSyncByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiControlPlaneDomainVerifyByTenantIdApiResponse =
  /** status 200 OK */ DomainVerification[];
export type PostApiControlPlaneDomainVerifyByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiControlPlaneDomainsByTenantIdApiResponse =
  /** status 200 OK */ DomainStatusDto[];
export type GetApiControlPlaneDomainsByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiControlPlaneEmailAlertsApiResponse =
  /** status 200 OK */ PaginatedResponseDeliveryAlertDto;
export type GetApiControlPlaneEmailAlertsApiArg = {
  page?: number | null;
  resolved?: boolean | null;
  size?: number | null;
  tenantId?: string | null;
};
export type PostApiControlPlaneEmailAlertsGenerateApiResponse = unknown;
export type PostApiControlPlaneEmailAlertsGenerateApiArg = void;
export type PostApiControlPlaneEmailAlertsByIdResolveApiResponse = unknown;
export type PostApiControlPlaneEmailAlertsByIdResolveApiArg = {
  id: number;
};
export type GetApiControlPlaneEmailBouncedApiResponse =
  /** status 200 OK */ PaginatedResponseBouncedUserDto;
export type GetApiControlPlaneEmailBouncedApiArg = {
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort: string[];
  tenantId?: string | null;
};
export type DeleteApiControlPlaneEmailBouncedByTenantIdAndUserIdApiResponse =
  /** status 200 OK */ UnbounceResult;
export type DeleteApiControlPlaneEmailBouncedByTenantIdAndUserIdApiArg = {
  tenantId: string;
  userId: ResourceId;
  clearUpstream: boolean;
};
export type GetApiControlPlaneEmailDeliveryRatesApiResponse =
  /** status 200 OK */ DeliveryRateDto[];
export type GetApiControlPlaneEmailDeliveryRatesApiArg = {
  since?: string | null;
};
export type GetApiControlPlaneEmailFailedApiResponse =
  /** status 200 OK */ PaginatedResponseFailedNotificationDto;
export type GetApiControlPlaneEmailFailedApiArg = {
  page?: number | null;
  since?: string | null;
  size?: number | null;
  tenantId?: string | null;
};
export type GetApiControlPlaneEmailProvidersApiResponse =
  /** status 200 OK */ ProviderProblemDto[];
export type GetApiControlPlaneEmailProvidersApiArg = {
  since?: string | null;
};
export type GetApiControlPlaneEmailSendersApiResponse =
  /** status 200 OK */ SenderStatsDto[];
export type GetApiControlPlaneEmailSendersApiArg = {
  since?: string | null;
};
export type GetApiControlPlaneInvoicesApiResponse =
  /** status 200 OK */ InvoiceDto[];
export type GetApiControlPlaneInvoicesApiArg = {
  limit: number;
  month: string | null;
  tenantId: string | null;
};
export type GetApiControlPlaneInvoicesCreateApiResponse = unknown;
export type GetApiControlPlaneInvoicesCreateApiArg = {
  'day-in-month': LocalDate;
};
export type DeleteApiControlPlaneLexofficeAssignmentByTenantIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiControlPlaneLexofficeAssignmentByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiControlPlaneLexofficeAssignmentByTenantIdApiResponse =
  /** status 200 OK */ LexofficeContactView;
export type GetApiControlPlaneLexofficeAssignmentByTenantIdApiArg = {
  tenantId: string;
};
export type PutApiControlPlaneLexofficeAssignmentByTenantIdApiResponse =
  /** status 200 OK */ any;
export type PutApiControlPlaneLexofficeAssignmentByTenantIdApiArg = {
  tenantId: string;
  assignLexofficeRequest: AssignLexofficeRequest;
};
export type GetApiControlPlaneLexofficeContactsApiResponse =
  /** status 200 OK */ LexofficeContactView[];
export type GetApiControlPlaneLexofficeContactsApiArg = {
  filter?: LexofficeContactFilter & any;
};
export type GetApiControlPlaneMaintenanceApiResponse =
  /** status 200 OK */ MaintenanceIntervalDto[];
export type GetApiControlPlaneMaintenanceApiArg = void;
export type PostApiControlPlaneMaintenanceApiResponse =
  /** status 200 OK */ MaintenanceIntervalDto;
export type PostApiControlPlaneMaintenanceApiArg = {
  createMaintenanceIntervalRequest: CreateMaintenanceIntervalRequest;
};
export type DeleteApiControlPlaneMaintenanceExpiredApiResponse = unknown;
export type DeleteApiControlPlaneMaintenanceExpiredApiArg = void;
export type PutApiControlPlaneMaintenanceByIdApiResponse =
  /** status 200 OK */ MaintenanceIntervalDto;
export type PutApiControlPlaneMaintenanceByIdApiArg = {
  id: number;
  updateMaintenanceIntervalRequest: UpdateMaintenanceIntervalRequest;
};
export type DeleteApiControlPlaneMaintenanceByIdApiResponse = unknown;
export type DeleteApiControlPlaneMaintenanceByIdApiArg = {
  id: number;
};
export type GetApiControlPlaneMappingsApiResponse =
  /** status 200 OK */ ControlPlaneUserMappingEntry[];
export type GetApiControlPlaneMappingsApiArg = {
  userPk?: number | null;
};
export type PostApiControlPlaneMappingsApiResponse = /** status 200 OK */ any;
export type PostApiControlPlaneMappingsApiArg = {
  createMappingRequest: CreateMappingRequest;
};
export type DeleteApiControlPlaneMappingsByIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiControlPlaneMappingsByIdApiArg = {
  id: number;
};
export type GetApiControlPlaneMeApiResponse =
  /** status 200 OK */ ControlPlaneUserInfo;
export type GetApiControlPlaneMeApiArg = void;
export type PostApiControlPlanePaymentConditionsValidateApiResponse =
  /** status 200 OK */ FormulaValidationResponse;
export type PostApiControlPlanePaymentConditionsValidateApiArg = {
  formulaValidationRequest: FormulaValidationRequest;
};
export type PutApiControlPlanePaymentConditionsByTenantIdApiResponse = unknown;
export type PutApiControlPlanePaymentConditionsByTenantIdApiArg = {
  tenantId: string;
  paymentConditionsDto: PaymentConditionsDto;
};
export type GetApiControlPlanePaymentConditionsByTenantIdApiResponse =
  /** status 200 OK */ PaymentConditionsDto;
export type GetApiControlPlanePaymentConditionsByTenantIdApiArg = {
  tenantId: string;
};
export type DeleteApiControlPlanePaymentConditionsByTenantIdApiResponse =
  unknown;
export type DeleteApiControlPlanePaymentConditionsByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiControlPlanePaymentConditionsByTenantIdPreviewApiResponse =
  /** status 200 OK */ FormulaPreviewResponse;
export type PostApiControlPlanePaymentConditionsByTenantIdPreviewApiArg = {
  tenantId: string;
  formulaPreviewRequest: FormulaPreviewRequest;
};
export type PostApiControlPlanePolicyAccessTestByTenantIdApiResponse =
  /** status 200 OK */ AccessTestResponse[];
export type PostApiControlPlanePolicyAccessTestByTenantIdApiArg = {
  tenantId: string;
  accessTestRequest: AccessTestRequest;
};
export type PostApiControlPlanePolicyCacheByTenantIdApiResponse = unknown;
export type PostApiControlPlanePolicyCacheByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiControlPlaneStatisticsApiResponse =
  /** status 200 OK */ AssociationMonthlyStatistics[];
export type GetApiControlPlaneStatisticsApiArg = {
  month?: string | null;
};
export type GetApiControlPlaneStatisticsByTenantIdApiResponse =
  /** status 200 OK */ AssociationMonthlyStatistics;
export type GetApiControlPlaneStatisticsByTenantIdApiArg = {
  tenantId: string;
  month?: string | null;
};
export type PostApiControlPlaneTemplatesByTenantIdLoadDefaultsApiResponse =
  /** status 200 OK */ string[];
export type PostApiControlPlaneTemplatesByTenantIdLoadDefaultsApiArg = {
  tenantId: string;
};
export type PostApiControlPlaneTemplatesByTenantIdResetAndTypeApiResponse =
  unknown;
export type PostApiControlPlaneTemplatesByTenantIdResetAndTypeApiArg = {
  tenantId: string;
  type: EmailTemplateType;
};
export type PostApiControlPlaneTextBlocksByTenantIdLoadDefaultsApiResponse =
  /** status 200 OK */ string[];
export type PostApiControlPlaneTextBlocksByTenantIdLoadDefaultsApiArg = {
  tenantId: string;
};
export type PostApiControlPlaneUserSyncIpByTenantIdApiResponse = unknown;
export type PostApiControlPlaneUserSyncIpByTenantIdApiArg = {
  tenantId: string;
  syncUserRequest: SyncUserRequest;
};
export type GetApiControlPlaneUsersByTenantIdApiResponse =
  /** status 200 OK */ PaginatedResponseUserSummary;
export type GetApiControlPlaneUsersByTenantIdApiArg = {
  tenantId: string;
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
  userFilter?: UserFilter & any;
};
export type PostApiControlPlaneUsersByTenantIdDedupeApiResponse =
  /** status 200 OK */ DedupeMergeResult[];
export type PostApiControlPlaneUsersByTenantIdDedupeApiArg = {
  tenantId: string;
  dryRun: boolean;
  limit?: number | null;
  loser?: ResourceId | null;
  winner?: ResourceId | null;
};
export type GetApiControlPlaneUsersByTenantIdDuplicatesApiResponse =
  /** status 200 OK */ DuplicateUserGroup[];
export type GetApiControlPlaneUsersByTenantIdDuplicatesApiArg = {
  tenantId: string;
};
export type GetApiDistrictCodeApiResponse = /** status 200 OK */ string[];
export type GetApiDistrictCodeApiArg = void;
export type GetApiDistrictCodeByPostalCodeByPostalCodeApiResponse =
  /** status 200 OK */ string;
export type GetApiDistrictCodeByPostalCodeByPostalCodeApiArg = {
  postalCode: string;
};
export type GetApiDocumentCategoriesApiResponse =
  /** status 200 OK */ PaginatedResponseDocumentCategory;
export type GetApiDocumentCategoriesApiArg = {
  name?: string;
  page?: number;
  search?: string | null;
  size?: number;
  sort?: string[];
};
export type PostApiDocumentCategoriesApiResponse = /** status 200 OK */ any;
export type PostApiDocumentCategoriesApiArg = {
  documentCategoryCreateDto: DocumentCategoryCreateDto;
};
export type GetApiDocumentCategoriesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ DocumentCategory;
export type GetApiDocumentCategoriesByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type PatchApiDocumentCategoriesByIdApiResponse =
  /** status 200 OK */ any;
export type PatchApiDocumentCategoriesByIdApiArg = {
  id: ResourceId;
  documentCategoryUpdateDto: DocumentCategoryUpdateDto;
};
export type GetApiDocumentCategoriesByIdApiResponse =
  /** status 200 OK */ DocumentCategory;
export type GetApiDocumentCategoriesByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiDocumentCategoriesByIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiDocumentCategoriesByIdApiArg = {
  id: ResourceId;
};
export type PostApiDocumentFilesMoveApiResponse = /** status 200 OK */ any;
export type PostApiDocumentFilesMoveApiArg = {
  moveDocumentsRequest: MoveDocumentsRequest;
};
export type PutApiDocumentFilesByIdApiResponse = /** status 200 OK */ any;
export type PutApiDocumentFilesByIdApiArg = {
  id: ResourceId;
  updateDocument: UpdateDocument;
};
export type DeleteApiDocumentFilesByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiDocumentFilesByIdApiArg = {
  id: ResourceId;
};
export type GetApiDocumentFilesByIdAccessApiResponse =
  /** status 200 OK */ AppliedAccessAttributes;
export type GetApiDocumentFilesByIdAccessApiArg = {
  id: ResourceId;
};
export type GetApiDocumentFilesByIdDownloadApiResponse =
  /** status 200 OK */ DownloadLink;
export type GetApiDocumentFilesByIdDownloadApiArg = {
  id: ResourceId;
};
export type GetApiDocumentFilesByIdReplaceApiResponse =
  /** status 200 OK */ CreateDocumentResponse;
export type GetApiDocumentFilesByIdReplaceApiArg = {
  id: ResourceId;
};
export type GetApiDocumentFoldersApiResponse =
  /** status 200 OK */ PaginatedResponseDocumentItem;
export type GetApiDocumentFoldersApiArg = {
  page?: number | null;
  size?: number | null;
  sortKey?: DocumentSortKey & any;
  sortOrder?: SortOrder & any;
};
export type PostApiDocumentFoldersApiResponse = /** status 200 OK */ any;
export type PostApiDocumentFoldersApiArg = {
  createFolder: CreateFolder;
};
export type PostApiDocumentFoldersMoveApiResponse = /** status 200 OK */ any;
export type PostApiDocumentFoldersMoveApiArg = {
  moveFoldersRequest: MoveFoldersRequest;
};
export type PutApiDocumentFoldersByIdApiResponse = /** status 200 OK */ any;
export type PutApiDocumentFoldersByIdApiArg = {
  id: ResourceId;
  updateFolderV2: UpdateFolderV2;
};
export type GetApiDocumentFoldersByIdApiResponse = /** status 200 OK */ Folder1;
export type GetApiDocumentFoldersByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiDocumentFoldersByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiDocumentFoldersByIdApiArg = {
  id: ResourceId;
};
export type GetApiDocumentFoldersByIdAccessApiResponse =
  /** status 200 OK */ AppliedAccessAttributes;
export type GetApiDocumentFoldersByIdAccessApiArg = {
  id: ResourceId;
};
export type GetApiDocumentFoldersByIdContentsApiResponse =
  /** status 200 OK */ PaginatedResponseDocumentItem;
export type GetApiDocumentFoldersByIdContentsApiArg = {
  id: ResourceId;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sortKey?: DocumentSortKey & any;
  sortOrder?: SortOrder & any;
};
export type PostApiDocumentFoldersByIdFilesApiResponse =
  /** status 200 OK */ CreateDocumentResponse;
export type PostApiDocumentFoldersByIdFilesApiArg = {
  id: ResourceId;
  createDocument: CreateDocument;
};
export type PostApiDocumentFoldersByIdFoldersApiResponse =
  /** status 200 OK */ any;
export type PostApiDocumentFoldersByIdFoldersApiArg = {
  id: ResourceId;
  createFolder: CreateFolder;
};
export type GetApiDocumentFoldersByIdParentsApiResponse =
  /** status 200 OK */ Folder[];
export type GetApiDocumentFoldersByIdParentsApiArg = {
  id: ResourceId;
};
export type PostApiEmailRenderCustomApiResponse = /** status 200 OK */ string;
export type PostApiEmailRenderCustomApiArg = {
  emailRenderRequest: EmailRenderRequest;
};
export type PostApiEmailRenderCustomPreviewApiResponse =
  /** status 200 OK */ string;
export type PostApiEmailRenderCustomPreviewApiArg = {
  emailRenderPreviewRequest: EmailRenderPreviewRequest;
};
export type GetApiEmailRenderPostByPostIdApiResponse =
  /** status 200 OK */ string;
export type GetApiEmailRenderPostByPostIdApiArg = {
  postId: ResourceId;
};
export type GetApiEmailSignatureApiResponse =
  /** status 200 OK */ PaginatedResponseEmailSignature;
export type GetApiEmailSignatureApiArg = {
  organizationName?: string;
  page?: number;
  search?: string | null;
  size?: number;
  sort?: string[];
};
export type PostApiEmailSignatureApiResponse = /** status 200 OK */ any;
export type PostApiEmailSignatureApiArg = {
  emailSignatureCreateDto: EmailSignatureCreateDto;
};
export type PatchApiEmailSignatureByIdApiResponse = /** status 200 OK */ any;
export type PatchApiEmailSignatureByIdApiArg = {
  id: ResourceId;
  emailSignatureUpdateDto: EmailSignatureUpdateDto;
};
export type GetApiEmailSignatureByIdApiResponse =
  /** status 200 OK */ EmailSignature;
export type GetApiEmailSignatureByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiEmailSignatureByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiEmailSignatureByIdApiArg = {
  id: ResourceId;
};
export type GetApiEmailTemplateApiResponse =
  /** status 200 OK */ PaginatedResponseEmailTemplate;
export type GetApiEmailTemplateApiArg = {
  page?: number;
  search?: string | null;
  size?: number;
  sort?: string[];
  status?: string;
  type?: string;
};
export type PostApiEmailTemplateApiResponse = /** status 200 OK */ any;
export type PostApiEmailTemplateApiArg = {
  emailTemplateCreateDto: EmailTemplateCreateDto;
};
export type PatchApiEmailTemplateByIdApiResponse = /** status 200 OK */ any;
export type PatchApiEmailTemplateByIdApiArg = {
  id: ResourceId;
  emailTemplateUpdateDto: EmailTemplateUpdateDto;
};
export type GetApiEmailTemplateByIdApiResponse =
  /** status 200 OK */ EmailTemplate;
export type GetApiEmailTemplateByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiEmailTemplateByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiEmailTemplateByIdApiArg = {
  id: ResourceId;
};
export type GetApiEmailTemplatesApiResponse =
  /** status 200 OK */ EmailTemplate[];
export type GetApiEmailTemplatesApiArg = {
  status?: string | null;
  type?: string | null;
};
export type PostApiEmailTemplatesApiResponse = /** status 200 OK */ any;
export type PostApiEmailTemplatesApiArg = {
  emailTemplateCreateDto: EmailTemplateCreateDto;
};
export type PostApiEmailTemplatesCopyFromDefaultApiResponse =
  /** status 200 OK */ any;
export type PostApiEmailTemplatesCopyFromDefaultApiArg = {
  copyEmailTemplateFromDefaultDto: CopyEmailTemplateFromDefaultDto;
};
export type GetApiEmailTemplatesVariablesApiResponse =
  /** status 200 OK */ EmailTemplateVariablesDto;
export type GetApiEmailTemplatesVariablesApiArg = {
  type: string;
};
export type PatchApiEmailTemplatesByIdApiResponse = unknown;
export type PatchApiEmailTemplatesByIdApiArg = {
  id: ResourceId;
  emailTemplateUpdateDto: EmailTemplateUpdateDto;
};
export type GetApiEmailTemplatesByIdApiResponse =
  /** status 200 OK */ EmailTemplate;
export type GetApiEmailTemplatesByIdApiArg = {
  id: ResourceId;
};
export type PutApiEmailTemplatesByIdStatusApiResponse = unknown;
export type PutApiEmailTemplatesByIdStatusApiArg = {
  id: ResourceId;
  emailTemplateStatusUpdateDto: EmailTemplateStatusUpdateDto;
};
export type PutApiEmailConfigApiResponse =
  /** status 200 OK */ DomainEmailConfigEntry;
export type PutApiEmailConfigApiArg = {
  domainEmailConfigEntry: DomainEmailConfigEntry;
};
export type GetApiEmailConfigApiResponse =
  /** status 200 OK */ DomainEmailConfigEntry[];
export type GetApiEmailConfigApiArg = void;
export type GetApiEmailConfigDomainByDomainIdApiResponse =
  /** status 200 OK */ DomainEmailConfigEntry[];
export type GetApiEmailConfigDomainByDomainIdApiArg = {
  domainId: number;
};
export type DeleteApiEmailConfigByDomainIdAndSenderIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiEmailConfigByDomainIdAndSenderIdApiArg = {
  domainId: number;
  senderId: string;
};
export type GetApiEventsApiResponse =
  /** status 200 OK */ PaginatedResponseEventDetails;
export type GetApiEventsApiArg = {
  from?: string | null;
  page?: number | null;
  publishStatus?: PublishStatus & any;
  search?: string | null;
  size?: number | null;
  to?: string | null;
};
export type PostApiEventsApiResponse = /** status 200 OK */ any;
export type PostApiEventsApiArg = {
  createEvent: CreateEvent;
};
export type PostApiEventsAttendApiResponse =
  /** status 200 OK */ AttendResponseRead;
export type PostApiEventsAttendApiArg = {
  attendWithToken: AttendWithToken;
};
export type GetApiEventsAttendeeStatusAttributeApiResponse =
  /** status 200 OK */ AccessAttribute;
export type GetApiEventsAttendeeStatusAttributeApiArg = void;
export type PatchApiEventsByIdApiResponse = /** status 200 OK */ any;
export type PatchApiEventsByIdApiArg = {
  id: ResourceId;
  updateEvent: UpdateEvent;
};
export type GetApiEventsByIdApiResponse = /** status 200 OK */ EventDetails;
export type GetApiEventsByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiEventsByIdApiResponse = unknown;
export type DeleteApiEventsByIdApiArg = {
  id: ResourceId;
};
export type GetApiEventsByIdAllAttendeesApiResponse =
  /** status 200 OK */ AttendResponseRead[];
export type GetApiEventsByIdAllAttendeesApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  search?: string | null;
  sort?: string[];
};
export type GetApiEventsByIdAttendeesApiResponse =
  /** status 200 OK */ PaginatedResponseAttendResponseRead;
export type GetApiEventsByIdAttendeesApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string;
};
export type PostApiEventsByIdAttendeesApiResponse = /** status 200 OK */ any;
export type PostApiEventsByIdAttendeesApiArg = {
  id: ResourceId;
  attendRequest: AttendRequest;
};
export type GetApiEventsByIdIcsApiResponse = /** status 200 OK */ string;
export type GetApiEventsByIdIcsApiArg = {
  id: ResourceId;
};
export type PostApiEventsByIdPublishApiResponse = unknown;
export type PostApiEventsByIdPublishApiArg = {
  id: ResourceId;
};
export type GetApiGroupApiResponse =
  /** status 200 OK */ PaginatedResponseGroup;
export type GetApiGroupApiArg = {
  number?: string;
  page?: number;
  parentId?: string;
  search?: string | null;
  size?: number;
  sort?: string[];
};
export type PostApiGroupApiResponse = /** status 200 OK */ any;
export type PostApiGroupApiArg = {
  groupCreateDto: GroupCreateDto;
};
export type GetApiGroupByExternalIdByIdApiResponse =
  /** status 200 OK */ Group1;
export type GetApiGroupByExternalIdByIdApiArg = {
  id: string;
};
export type PatchApiGroupByIdApiResponse = /** status 200 OK */ any;
export type PatchApiGroupByIdApiArg = {
  id: ResourceId;
  groupUpdateDto: GroupUpdateDto;
};
export type GetApiGroupByIdApiResponse = /** status 200 OK */ Group1;
export type GetApiGroupByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiGroupByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiGroupByIdApiArg = {
  id: ResourceId;
};
export type GetApiGroupByIdMembersApiResponse =
  /** status 200 OK */ PaginatedResponseEmailUser;
export type GetApiGroupByIdMembersApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type PostApiImagesApiResponse = /** status 200 OK */ CreateImageResponse;
export type PostApiImagesApiArg = {
  createImage: CreateImage;
};
export type GetApiLandingNewsletterByTokenApiResponse =
  /** status 200 OK */ UserTokenNewsletter;
export type GetApiLandingNewsletterByTokenApiArg = {
  token: string;
};
export type GetApiLandingPostByTokenApiResponse =
  /** status 200 OK */ PostDetailsRead;
export type GetApiLandingPostByTokenApiArg = {
  token: string;
};
export type GetApiListsApiResponse =
  /** status 200 OK */ PaginatedResponseUserListInfo;
export type GetApiListsApiArg = {
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type PostApiListsApiResponse = /** status 200 OK */ any;
export type PostApiListsApiArg = {
  createUserList: CreateUserList;
};
export type PatchApiListsByIdApiResponse = unknown;
export type PatchApiListsByIdApiArg = {
  id: ResourceId;
  updateUserListInfo: UpdateUserListInfo;
};
export type GetApiListsByIdApiResponse = /** status 200 OK */ UserListInfo;
export type GetApiListsByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiListsByIdApiResponse = unknown;
export type DeleteApiListsByIdApiArg = {
  id: ResourceId;
};
export type GetApiListsByIdUsersApiResponse =
  /** status 200 OK */ PaginatedResponseEmailUser;
export type GetApiListsByIdUsersApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type GetApiMaintenanceApiResponse =
  /** status 200 OK */ MaintenanceIntervalDto[];
export type GetApiMaintenanceApiArg = void;
export type PostApiMasterDataImportBatchImportApiResponse =
  /** status 200 OK */ UpdatePlan;
export type PostApiMasterDataImportBatchImportApiArg = {
  dryRun: boolean;
  body: Blob;
};
export type PostApiMasterDataImportBatchImportAsyncApiResponse =
  /** status 200 OK */ any;
export type PostApiMasterDataImportBatchImportAsyncApiArg = {
  body: Blob;
};
export type PostApiMasterDataImportBatchImportExecuteApiResponse =
  /** status 200 OK */ BatchImportResult;
export type PostApiMasterDataImportBatchImportExecuteApiArg = {
  updatePlan: UpdatePlan;
};
export type PostApiMasterDataImportBatchImportExecuteAsyncApiResponse =
  /** status 200 OK */ any;
export type PostApiMasterDataImportBatchImportExecuteAsyncApiArg = {
  updatePlan: UpdatePlan;
};
export type PostApiMasterDataImportBatchImportPlanApiResponse =
  /** status 200 OK */ UpdatePlan;
export type PostApiMasterDataImportBatchImportPlanApiArg = {
  body: Blob;
};
export type PostApiMasterDataImportBatchImportPlanAsyncApiResponse =
  /** status 200 OK */ any;
export type PostApiMasterDataImportBatchImportPlanAsyncApiArg = {
  body: Blob;
};
export type GetApiMasterDataImportCompaniesApiResponse =
  /** status 200 OK */ PaginatedResponseExternalCompanyChangeRequestRead;
export type GetApiMasterDataImportCompaniesApiArg = {
  page?: number | null;
  size?: number | null;
};
export type PostApiMasterDataImportCompaniesApiResponse =
  /** status 200 OK */ any;
export type PostApiMasterDataImportCompaniesApiArg = {
  autoCommit: boolean;
  externalCompanyChangeRequest: ExternalCompanyChangeRequest;
};
export type GetApiMasterDataImportCompaniesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ ExternalCompanyChangeRequestRead[];
export type GetApiMasterDataImportCompaniesByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type GetApiMasterDataImportCompaniesExternalIdsApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportCompaniesExternalIdsApiArg = void;
export type GetApiMasterDataImportCompaniesSquashedByExternalIdApiResponse =
  /** status 200 OK */ SquashedExternalCompanyUpdate;
export type GetApiMasterDataImportCompaniesSquashedByExternalIdApiArg = {
  externalId: string;
};
export type PostApiMasterDataImportCompaniesByIdApiResponse = unknown;
export type PostApiMasterDataImportCompaniesByIdApiArg = {
  id: number;
  externalCompanyChangeResponse: ExternalCompanyChangeResponse;
};
export type GetApiMasterDataImportCompaniesByIdApiResponse =
  /** status 200 OK */ ExternalCompanyChangeRequestRead;
export type GetApiMasterDataImportCompaniesByIdApiArg = {
  id: number;
};
export type GetApiMasterDataImportDocumentCategoriesApiResponse =
  /** status 200 OK */ PaginatedResponseExternalDocumentCategoryChangeRequestRead;
export type GetApiMasterDataImportDocumentCategoriesApiArg = {
  page?: number | null;
  size?: number | null;
};
export type PostApiMasterDataImportDocumentCategoriesApiResponse =
  /** status 200 OK */ any;
export type PostApiMasterDataImportDocumentCategoriesApiArg = {
  autoCommit: boolean;
  externalDocumentCategoryChangeRequest: ExternalDocumentCategoryChangeRequest;
};
export type GetApiMasterDataImportDocumentCategoriesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ ExternalDocumentCategoryChangeRequestRead[];
export type GetApiMasterDataImportDocumentCategoriesByExternalIdByExternalIdApiArg =
  {
    externalId: string;
  };
export type GetApiMasterDataImportDocumentCategoriesExternalIdsApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportDocumentCategoriesExternalIdsApiArg = void;
export type GetApiMasterDataImportDocumentCategoriesSquashedByExternalIdApiResponse =
  /** status 200 OK */ SquashedExternalDocumentCategoryUpdate;
export type GetApiMasterDataImportDocumentCategoriesSquashedByExternalIdApiArg =
  {
    externalId: string;
  };
export type PostApiMasterDataImportDocumentCategoriesByIdApiResponse = unknown;
export type PostApiMasterDataImportDocumentCategoriesByIdApiArg = {
  id: number;
  externalDocumentCategoryChangeResponse: ExternalDocumentCategoryChangeResponse;
};
export type GetApiMasterDataImportDocumentCategoriesByIdApiResponse =
  /** status 200 OK */ ExternalDocumentCategoryChangeRequestRead;
export type GetApiMasterDataImportDocumentCategoriesByIdApiArg = {
  id: number;
};
export type GetApiMasterDataImportExportApiResponse = /** status 200 OK */ Blob;
export type GetApiMasterDataImportExportApiArg = {
  includeAttributes?: string[];
};
export type PostApiMasterDataImportExternalIdsApiResponse =
  /** status 200 OK */ SetExternalIdsResult;
export type PostApiMasterDataImportExternalIdsApiArg = {
  setExternalIdsRequest: SetExternalIdsRequest;
};
export type GetApiMasterDataImportGuildsApiResponse =
  /** status 200 OK */ PaginatedResponseExternalGuildChangeRequestRead;
export type GetApiMasterDataImportGuildsApiArg = {
  page?: number | null;
  size?: number | null;
};
export type PostApiMasterDataImportGuildsApiResponse = /** status 200 OK */ any;
export type PostApiMasterDataImportGuildsApiArg = {
  autoCommit: boolean;
  externalGuildChangeRequest: ExternalGuildChangeRequest;
};
export type GetApiMasterDataImportGuildsExternalIdsApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportGuildsExternalIdsApiArg = void;
export type GetApiMasterDataImportGuildsSquashedByExternalIdApiResponse =
  /** status 200 OK */ SquashedExternalGuildUpdate;
export type GetApiMasterDataImportGuildsSquashedByExternalIdApiArg = {
  externalId: string;
};
export type PostApiMasterDataImportGuildsByIdApiResponse = unknown;
export type PostApiMasterDataImportGuildsByIdApiArg = {
  id: number;
  externalGuildChangeResponse: ExternalGuildChangeResponse;
};
export type GetApiMasterDataImportGuildsByIdApiResponse =
  /** status 200 OK */ ExternalGuildChangeRequestRead;
export type GetApiMasterDataImportGuildsByIdApiArg = {
  id: number;
};
export type GetApiMasterDataImportMembershipTypesApiResponse =
  /** status 200 OK */ PaginatedResponseExternalMembershipTypeChangeRequestRead;
export type GetApiMasterDataImportMembershipTypesApiArg = {
  page?: number | null;
  size?: number | null;
};
export type PostApiMasterDataImportMembershipTypesApiResponse =
  /** status 200 OK */ any;
export type PostApiMasterDataImportMembershipTypesApiArg = {
  autoCommit: boolean;
  externalMembershipTypeChangeRequest: ExternalMembershipTypeChangeRequest;
};
export type GetApiMasterDataImportMembershipTypesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ ExternalMembershipTypeChangeRequestRead[];
export type GetApiMasterDataImportMembershipTypesByExternalIdByExternalIdApiArg =
  {
    externalId: string;
  };
export type GetApiMasterDataImportMembershipTypesExternalIdsApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportMembershipTypesExternalIdsApiArg = void;
export type GetApiMasterDataImportMembershipTypesSquashedByExternalIdApiResponse =
  /** status 200 OK */ SquashedExternalMembershipTypeUpdate;
export type GetApiMasterDataImportMembershipTypesSquashedByExternalIdApiArg = {
  externalId: string;
};
export type PostApiMasterDataImportMembershipTypesByIdApiResponse = unknown;
export type PostApiMasterDataImportMembershipTypesByIdApiArg = {
  id: number;
  externalMembershipTypeChangeResponse: ExternalMembershipTypeChangeResponse;
};
export type GetApiMasterDataImportMembershipTypesByIdApiResponse =
  /** status 200 OK */ ExternalMembershipTypeChangeRequestRead;
export type GetApiMasterDataImportMembershipTypesByIdApiArg = {
  id: number;
};
export type GetApiMasterDataImportRolesApiResponse =
  /** status 200 OK */ PaginatedResponseExternalRoleChangeRequestRead;
export type GetApiMasterDataImportRolesApiArg = {
  page?: number | null;
  size?: number | null;
};
export type PostApiMasterDataImportRolesApiResponse = /** status 200 OK */ any;
export type PostApiMasterDataImportRolesApiArg = {
  autoCommit: boolean;
  externalRoleChangeRequest: ExternalRoleChangeRequest;
};
export type GetApiMasterDataImportRolesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ ExternalRoleChangeRequestRead[];
export type GetApiMasterDataImportRolesByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type GetApiMasterDataImportRolesExternalIdsApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportRolesExternalIdsApiArg = void;
export type GetApiMasterDataImportRolesSquashedByExternalIdApiResponse =
  /** status 200 OK */ SquashedExternalRoleUpdate;
export type GetApiMasterDataImportRolesSquashedByExternalIdApiArg = {
  externalId: string;
};
export type PostApiMasterDataImportRolesByIdApiResponse = unknown;
export type PostApiMasterDataImportRolesByIdApiArg = {
  id: number;
  externalRoleChangeResponse: ExternalRoleChangeResponse;
};
export type GetApiMasterDataImportRolesByIdApiResponse =
  /** status 200 OK */ ExternalRoleChangeRequestRead;
export type GetApiMasterDataImportRolesByIdApiArg = {
  id: number;
};
export type GetApiMasterDataImportUsersApiResponse =
  /** status 200 OK */ PaginatedResponseExternalUserChangeRequestRead;
export type GetApiMasterDataImportUsersApiArg = {
  onlyLatest?: boolean;
  page?: number | null;
  size?: number | null;
};
export type PostApiMasterDataImportUsersApiResponse = /** status 200 OK */ any;
export type PostApiMasterDataImportUsersApiArg = {
  autoCommit: boolean;
  externalUserChangeRequest: ExternalUserChangeRequest;
};
export type GetApiMasterDataImportUsersByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ ExternalUserChangeRequestRead[];
export type GetApiMasterDataImportUsersByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type GetApiMasterDataImportUsersExternalIdsApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportUsersExternalIdsApiArg = void;
export type GetApiMasterDataImportUsersExternalIdsWithEmailsApiResponse =
  /** status 200 OK */ ExternalIdWithEmails[];
export type GetApiMasterDataImportUsersExternalIdsWithEmailsApiArg = void;
export type GetApiMasterDataImportUsersExternalIdsRebuildApiResponse =
  /** status 200 OK */ string[];
export type GetApiMasterDataImportUsersExternalIdsRebuildApiArg = void;
export type GetApiMasterDataImportUsersHashesApiResponse =
  /** status 200 OK */ ExternalUserUpdateHash[];
export type GetApiMasterDataImportUsersHashesApiArg = void;
export type PostApiMasterDataImportUsersLatestApiResponse = unknown;
export type PostApiMasterDataImportUsersLatestApiArg = void;
export type PostApiMasterDataImportUsersSyncAllToSquashedApiResponse =
  /** status 200 OK */ SyncResult[];
export type PostApiMasterDataImportUsersSyncAllToSquashedApiArg = {
  accessAttributeNames: string[];
  dryRun: boolean;
  recalculate: boolean;
};
export type PostApiMasterDataImportUsersSyncByIdApiResponse = unknown;
export type PostApiMasterDataImportUsersSyncByIdApiArg = {
  id: ResourceId;
};
export type PostApiMasterDataImportUsersByIdApiResponse = unknown;
export type PostApiMasterDataImportUsersByIdApiArg = {
  id: number;
  acceptAll: boolean;
  externalUserChangeResponse: ExternalUserChangeResponse;
};
export type GetApiMasterDataImportUsersByIdApiResponse =
  /** status 200 OK */ ExternalUserChangeRequestRead;
export type GetApiMasterDataImportUsersByIdApiArg = {
  id: number;
};
export type PostApiMasterDataImportUsersByUserIdSyncToSquashedApiResponse =
  /** status 200 OK */ SyncResult;
export type PostApiMasterDataImportUsersByUserIdSyncToSquashedApiArg = {
  userId: ResourceId;
  accessAttributeNames: string[];
  dryRun: boolean;
  recalculate: boolean;
};
export type GetApiMembershipTypeApiResponse =
  /** status 200 OK */ GroupMembership[];
export type GetApiMembershipTypeApiArg = {
  name?: string;
  search?: string | null;
  sort?: string[];
};
export type PostApiMembershipTypeApiResponse = /** status 200 OK */ any;
export type PostApiMembershipTypeApiArg = {
  groupMembershipCreateDto: GroupMembershipCreateDto;
};
export type GetApiMembershipTypeAllApiResponse =
  /** status 200 OK */ GroupMembership[];
export type GetApiMembershipTypeAllApiArg = void;
export type GetApiMembershipTypeByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ GroupMembership;
export type GetApiMembershipTypeByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type PatchApiMembershipTypeByIdApiResponse = /** status 200 OK */ any;
export type PatchApiMembershipTypeByIdApiArg = {
  id: ResourceId;
  groupMembershipUpdateDto: GroupMembershipUpdateDto;
};
export type GetApiMembershipTypeByIdApiResponse =
  /** status 200 OK */ GroupMembership;
export type GetApiMembershipTypeByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiMembershipTypeByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiMembershipTypeByIdApiArg = {
  id: ResourceId;
};
export type GetApiOidcCallbackApiResponse = unknown;
export type GetApiOidcCallbackApiArg = void;
export type GetApiOidcLoginApiResponse = unknown;
export type GetApiOidcLoginApiArg = void;
export type GetApiOidcLogoutApiResponse = unknown;
export type GetApiOidcLogoutApiArg = void;
export type GetApiPolicyApiResponse =
  /** status 200 OK */ PaginatedResponsePolicy;
export type GetApiPolicyApiArg = {
  action?: string | null;
  page?: number | null;
  resourceType?: ResourceType | null;
  size?: number | null;
  sortKey?: PolicySortKey & any;
  sortOrder?: SortOrder & any;
};
export type PostApiPolicyApiResponse = /** status 200 OK */ any;
export type PostApiPolicyApiArg = {
  createPolicy: CreatePolicy;
};
export type PatchApiPolicyByIdApiResponse = unknown;
export type PatchApiPolicyByIdApiArg = {
  id: number;
  updatePolicy: UpdatePolicy;
};
export type GetApiPolicyByIdApiResponse = /** status 200 OK */ Policy;
export type GetApiPolicyByIdApiArg = {
  id: number;
};
export type DeleteApiPolicyByIdApiResponse = unknown;
export type DeleteApiPolicyByIdApiArg = {
  id: number;
};
export type GetApiPostsApiResponse =
  /** status 200 OK */ PaginatedResponsePostSummary;
export type GetApiPostsApiArg = {
  accessAttributeFilter?: AccessAttributeFilter | null;
  onlyRoot?: boolean;
  page?: number | null;
  parent?: ResourceId | null;
  search?: string | null;
  size?: number | null;
  sort?: string;
  status?: PostStatus[];
  type?: PostType[];
};
export type PostApiPostsApiResponse = /** status 200 OK */ any;
export type PostApiPostsApiArg = {
  createPost: CreatePost;
};
export type GetApiPostsDraftsApiResponse =
  /** status 200 OK */ PaginatedResponsePostSummary;
export type GetApiPostsDraftsApiArg = {
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  parent?: ResourceId | null;
  search?: string | null;
  size?: number | null;
  sort?: string;
  type?: PostType[];
};
export type GetApiPostsDraftsRootApiResponse =
  /** status 200 OK */ PaginatedResponsePostSummary;
export type GetApiPostsDraftsRootApiArg = {
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  parent?: ResourceId | null;
  search?: string | null;
  size?: number | null;
  sort?: string;
  type?: PostType[];
};
export type PatchApiPostsDraftsByIdApiResponse = /** status 200 OK */ any;
export type PatchApiPostsDraftsByIdApiArg = {
  id: ResourceId;
  updatePost: UpdatePost;
};
export type GetApiPostsDraftsByIdApiResponse =
  /** status 200 OK */ PostDetailsRead;
export type GetApiPostsDraftsByIdApiArg = {
  id: ResourceId;
};
export type GetApiPostsPlannedApiResponse =
  /** status 200 OK */ PaginatedResponsePostSummary;
export type GetApiPostsPlannedApiArg = {
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  parent?: ResourceId | null;
  search?: string | null;
  size?: number | null;
  sort?: string;
};
export type GetApiPostsPlannedByIdApiResponse =
  /** status 200 OK */ PostDetailsRead;
export type GetApiPostsPlannedByIdApiArg = {
  id: ResourceId;
};
export type GetApiPostsRootApiResponse =
  /** status 200 OK */ PaginatedResponsePostSummary;
export type GetApiPostsRootApiArg = {
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  parent?: ResourceId | null;
  search?: string | null;
  size?: number | null;
  sort?: string;
  type?: PostType[];
};
export type GetApiPostsSearchApiResponse =
  /** status 200 OK */ PaginatedResponsePostSearchRecord;
export type GetApiPostsSearchApiArg = {
  page?: number | null;
  q: string;
  size?: number | null;
  type?: PostType[];
};
export type GetApiPostsSummaryByIdApiResponse =
  /** status 200 OK */ PostSummary;
export type GetApiPostsSummaryByIdApiArg = {
  id: ResourceId;
};
export type PatchApiPostsByIdApiResponse = /** status 200 OK */ any;
export type PatchApiPostsByIdApiArg = {
  id: ResourceId;
  updatePost: UpdatePost;
};
export type GetApiPostsByIdApiResponse = /** status 200 OK */ PostDetailsRead;
export type GetApiPostsByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiPostsByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiPostsByIdApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdAttachmentsApiResponse =
  /** status 200 OK */ PaginatedResponsePostAttachment;
export type GetApiPostsByIdAttachmentsApiArg = {
  id: ResourceId;
  page?: number | null;
  size?: number | null;
};
export type GetApiPostsByIdBreadcrumbsApiResponse =
  /** status 200 OK */ PostNameAndId[];
export type GetApiPostsByIdBreadcrumbsApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdCommentsApiResponse =
  /** status 200 OK */ PaginatedResponsePostComment;
export type GetApiPostsByIdCommentsApiArg = {
  id: number;
  page?: number | null;
  size?: number | null;
};
export type PostApiPostsByIdCommentsApiResponse = /** status 200 OK */ any;
export type PostApiPostsByIdCommentsApiArg = {
  id: number;
  createComment: CreateComment;
};
export type GetApiPostsByIdEmailSignatureApiResponse =
  /** status 200 OK */ EmailSignature;
export type GetApiPostsByIdEmailSignatureApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdEmailTemplateApiResponse =
  /** status 200 OK */ EmailTemplate;
export type GetApiPostsByIdEmailTemplateApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdNewsletterApiResponse =
  /** status 200 OK */ Newsletter;
export type GetApiPostsByIdNewsletterApiArg = {
  id: ResourceId;
};
export type PostApiPostsByIdNewsletterApiResponse = /** status 200 OK */ any;
export type PostApiPostsByIdNewsletterApiArg = {
  id: ResourceId;
  createNewsletterArticle: CreateNewsletterArticle;
};
export type PatchApiPostsByIdNewsletterAndArticleIdApiResponse = unknown;
export type PatchApiPostsByIdNewsletterAndArticleIdApiArg = {
  articleId: ResourceId;
  id: ResourceId;
  updateNewsletterArticle: UpdateNewsletterArticle;
};
export type DeleteApiPostsByIdNewsletterAndArticleIdApiResponse = unknown;
export type DeleteApiPostsByIdNewsletterAndArticleIdApiArg = {
  articleId: ResourceId;
  id: ResourceId;
};
export type GetApiPostsByIdNotificationsApiResponse =
  /** status 200 OK */ number[];
export type GetApiPostsByIdNotificationsApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdNotificationsUserAndTargetUserIdHistoryApiResponse =
  /** status 200 OK */ NotificationHistoryEntry[];
export type GetApiPostsByIdNotificationsUserAndTargetUserIdHistoryApiArg = {
  id: ResourceId;
  targetUserId: ResourceId;
};
export type GetApiPostsByIdNotificationsAndNotificationIdHistoryApiResponse =
  /** status 200 OK */ NotificationHistoryEntry[];
export type GetApiPostsByIdNotificationsAndNotificationIdHistoryApiArg = {
  id: ResourceId;
  notificationId: number;
};
export type GetApiPostsByIdParentsApiResponse =
  /** status 200 OK */ PostNameAndId[];
export type GetApiPostsByIdParentsApiArg = {
  id: ResourceId;
};
export type PostApiPostsByIdPublishApiResponse = /** status 200 OK */ any;
export type PostApiPostsByIdPublishApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdRecipientsApiResponse =
  /** status 200 OK */ PaginatedResponsePostRecipient;
export type GetApiPostsByIdRecipientsApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  emailFilter?: UserEmailFilter & any;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[] | null;
};
export type GetApiPostsByIdRecipientsSummaryApiResponse =
  /** status 200 OK */ PostRecipientSummaries;
export type GetApiPostsByIdRecipientsSummaryApiArg = {
  id: ResourceId;
};
export type GetApiPostsByIdResendAndNotificationIdApiResponse = unknown;
export type GetApiPostsByIdResendAndNotificationIdApiArg = {
  id: number;
  notificationId: number;
};
export type PostApiPostsByIdSendApiResponse = unknown;
export type PostApiPostsByIdSendApiArg = {
  id: ResourceId;
};
export type PostApiPostsByIdSendAndUserIdApiResponse = unknown;
export type PostApiPostsByIdSendAndUserIdApiArg = {
  id: ResourceId;
  userId: ResourceId;
};
export type GetApiPostsByIdUndeliveredNotificationsApiResponse =
  /** status 200 OK */ UndeliveredNotification[];
export type GetApiPostsByIdUndeliveredNotificationsApiArg = {
  id: ResourceId;
};
export type PostApiPostsByIdVoteApiResponse = /** status 200 OK */ any;
export type PostApiPostsByIdVoteApiArg = {
  id: ResourceId;
  vote: Vote;
};
export type GetApiRolesApiResponse = /** status 200 OK */ PaginatedResponseRole;
export type GetApiRolesApiArg = {
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[] | null;
};
export type PostApiRolesApiResponse = /** status 200 OK */ any;
export type PostApiRolesApiArg = {
  createRole: CreateRole;
};
export type GetApiRolesByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ Role;
export type GetApiRolesByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type PatchApiRolesByRoleIdApiResponse = unknown;
export type PatchApiRolesByRoleIdApiArg = {
  roleId: ResourceId;
  createRole: CreateRole;
};
export type GetApiRolesByRoleIdApiResponse = /** status 200 OK */ Role;
export type GetApiRolesByRoleIdApiArg = {
  roleId: ResourceId;
};
export type GetApiSchedulerTasksApiResponse =
  /** status 200 OK */ SchedulerTask[];
export type GetApiSchedulerTasksApiArg = {
  page: number;
  search?: string | null;
  size: number;
  sort?: string[];
};
export type GetApiSchedulerTasksByIdApiResponse =
  /** status 200 OK */ SchedulerTaskView;
export type GetApiSchedulerTasksByIdApiArg = {
  id: ResourceId;
};
export type PostApiSchedulerAssociationApiResponse =
  /** status 200 OK */ AssociationCreatedResponse;
export type PostApiSchedulerAssociationApiArg = {
  createAssociation: CreateAssociation;
};
export type PostApiSchedulerBatchTasksRunApiResponse = unknown;
export type PostApiSchedulerBatchTasksRunApiArg = {
  batchTaskRunRequest: BatchTaskRunRequest;
};
export type GetApiSchedulerBrevoEventsApiResponse = unknown;
export type GetApiSchedulerBrevoEventsApiArg = void;
export type GetApiSchedulerBrevoEventsPollByTenantIdApiResponse = unknown;
export type GetApiSchedulerBrevoEventsPollByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiSchedulerCalculateMonthlyStatsCalculateApiResponse = unknown;
export type GetApiSchedulerCalculateMonthlyStatsCalculateApiArg = {
  'day-in-month': LocalDate;
};
export type PostApiSchedulerChatSyncByTenantIdApiResponse = unknown;
export type PostApiSchedulerChatSyncByTenantIdApiArg = {
  tenantId: string;
  dryRun?: boolean;
};
export type PostApiSchedulerDistrictCodeByTenantIdApiResponse = unknown;
export type PostApiSchedulerDistrictCodeByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiSchedulerDomainSyncApiResponse = unknown;
export type PostApiSchedulerDomainSyncApiArg = void;
export type PostApiSchedulerDomainSyncByTenantIdApiResponse = unknown;
export type PostApiSchedulerDomainSyncByTenantIdApiArg = {
  tenantId: string;
};
export type GetApiSchedulerEmailAlertsApiResponse = unknown;
export type GetApiSchedulerEmailAlertsApiArg = void;
export type GetApiSchedulerEmailEventsApiResponse = unknown;
export type GetApiSchedulerEmailEventsApiArg = void;
export type GetApiSchedulerEmailSenderApiResponse = unknown;
export type GetApiSchedulerEmailSenderApiArg = void;
export type PostApiSchedulerEmailSenderSendApiResponse = unknown;
export type PostApiSchedulerEmailSenderSendApiArg = {
  emailSendRequest: EmailSendRequest;
};
export type GetApiSchedulerEmailSenderSmoothApiResponse = unknown;
export type GetApiSchedulerEmailSenderSmoothApiArg = void;
export type PostApiSchedulerEmailSenderByTenantIdAndPostIdApiResponse = unknown;
export type PostApiSchedulerEmailSenderByTenantIdAndPostIdApiArg = {
  postId: number;
  tenantId: string;
};
export type GetApiSchedulerInvoicesCreateApiResponse = unknown;
export type GetApiSchedulerInvoicesCreateApiArg = {
  'day-in-month': LocalDate;
};
export type GetApiSchedulerMailgunEventsApiResponse = unknown;
export type GetApiSchedulerMailgunEventsApiArg = void;
export type GetApiSchedulerMailgunEventsPollByTenantIdApiResponse = unknown;
export type GetApiSchedulerMailgunEventsPollByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiSchedulerMeilisearchCompaniesByTenantIdApiResponse = unknown;
export type PostApiSchedulerMeilisearchCompaniesByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiSchedulerMeilisearchPostTimestampsByTenantIdApiResponse =
  unknown;
export type PostApiSchedulerMeilisearchPostTimestampsByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiSchedulerMeilisearchPostTypesByTenantIdApiResponse = unknown;
export type PostApiSchedulerMeilisearchPostTypesByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiSchedulerMeilisearchPostsByTenantIdApiResponse = unknown;
export type PostApiSchedulerMeilisearchPostsByTenantIdApiArg = {
  tenantId: string;
};
export type PostApiSchedulerMeilisearchSetupApiResponse = unknown;
export type PostApiSchedulerMeilisearchSetupApiArg = void;
export type GetApiSchedulerMsGraphEventsApiResponse = unknown;
export type GetApiSchedulerMsGraphEventsApiArg = void;
export type PostApiSchedulerPlannedPostsCacheByTenantIdApiResponse = unknown;
export type PostApiSchedulerPlannedPostsCacheByTenantIdApiArg = {
  tenantId: string;
  postBuildCacheRequest: PostBuildCacheRequest;
};
export type GetApiSchedulerPlannedPostsPublishApiResponse = unknown;
export type GetApiSchedulerPlannedPostsPublishApiArg = void;
export type GetApiSchedulerPlannedPostsPublishByTenantIdAndPostIdApiResponse =
  unknown;
export type GetApiSchedulerPlannedPostsPublishByTenantIdAndPostIdApiArg = {
  postId: ResourceId;
  tenantId: string;
  isPlanned?: boolean;
};
export type PostApiSchedulerStorageDocumentUploadApiResponse = unknown;
export type PostApiSchedulerStorageDocumentUploadApiArg = {
  jsonObject: JsonObject;
};
export type PostApiSchedulerTasksExecuteApiResponse = unknown;
export type PostApiSchedulerTasksExecuteApiArg = {
  httpJob: HttpJob;
};
export type PostApiSchedulerTasksTestApiResponse = unknown;
export type PostApiSchedulerTasksTestApiArg = void;
export type GetApiSchedulerTasksTestApiResponse = unknown;
export type GetApiSchedulerTasksTestApiArg = void;
export type PostApiSurveysApiResponse = /** status 200 OK */ any;
export type PostApiSurveysApiArg = {
  createSurvey: CreateSurvey;
};
export type GetApiSurveysByTokenByTokenApiResponse =
  /** status 200 OK */ SurveyWithResponseRead;
export type GetApiSurveysByTokenByTokenApiArg = {
  token: string;
};
export type PostApiSurveysRespondApiResponse =
  /** status 200 OK */ SurveyWithResponseRead;
export type PostApiSurveysRespondApiArg = {
  createOrUpdateSurveyResponseWithToken: CreateOrUpdateSurveyResponseWithToken;
};
export type GetApiSurveysTemplatesApiResponse =
  /** status 200 OK */ PaginatedResponseSurveyRead;
export type GetApiSurveysTemplatesApiArg = {
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type PatchApiSurveysByIdApiResponse = unknown;
export type PatchApiSurveysByIdApiArg = {
  id: ResourceId;
  updateSurvey: UpdateSurvey;
};
export type GetApiSurveysByIdApiResponse = /** status 200 OK */ SurveyRead;
export type GetApiSurveysByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiSurveysByIdApiResponse = unknown;
export type DeleteApiSurveysByIdApiArg = {
  id: ResourceId;
};
export type GetApiSurveysByIdAllResponsesApiResponse =
  /** status 200 OK */ SurveyResponseList;
export type GetApiSurveysByIdAllResponsesApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  search?: string | null;
  sort?: string[];
};
export type GetApiSurveysByIdParticipantsApiResponse =
  /** status 200 OK */ PaginatedResponseSurveyParticipant;
export type GetApiSurveysByIdParticipantsApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type PostApiSurveysByIdPublishApiResponse = unknown;
export type PostApiSurveysByIdPublishApiArg = {
  id: ResourceId;
};
export type PatchApiSurveysByIdResponseApiResponse = unknown;
export type PatchApiSurveysByIdResponseApiArg = {
  id: ResourceId;
  createSurveyResponse: CreateSurveyResponse;
};
export type GetApiSurveysByIdResponseApiResponse =
  /** status 200 OK */ SurveyResponse;
export type GetApiSurveysByIdResponseApiArg = {
  id: ResourceId;
};
export type PostApiSurveysByIdResponseApiResponse = /** status 200 OK */ any;
export type PostApiSurveysByIdResponseApiArg = {
  id: ResourceId;
  createSurveyResponse: CreateSurveyResponse;
};
export type GetApiSurveysByIdResponseByUserAndUserIdApiResponse =
  /** status 200 OK */ SurveyResponse;
export type GetApiSurveysByIdResponseByUserAndUserIdApiArg = {
  id: ResourceId;
  userId: ResourceId;
};
export type PatchApiSurveysByIdResponseAndResponseIdApiResponse = unknown;
export type PatchApiSurveysByIdResponseAndResponseIdApiArg = {
  id: ResourceId;
  responseId: number;
  createSurveyResponse: CreateSurveyResponse;
};
export type GetApiSurveysByIdResponsesApiResponse =
  /** status 200 OK */ PaginatedResponseSurveyResponse;
export type GetApiSurveysByIdResponsesApiArg = {
  id: ResourceId;
  accessAttributeFilter?: AccessAttributeFilter | null;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type GetApiTagsApiResponse = /** status 200 OK */ Tag[];
export type GetApiTagsApiArg = void;
export type PostApiTagsApiResponse = /** status 200 OK */ any;
export type PostApiTagsApiArg = {
  tag: Tag;
};
export type PatchApiTagsByIdApiResponse = unknown;
export type PatchApiTagsByIdApiArg = {
  id: ResourceId;
  tag: Tag;
};
export type DeleteApiTagsByIdApiResponse = unknown;
export type DeleteApiTagsByIdApiArg = {
  id: ResourceId;
};
export type PostApiTestIdentityPlatformManagedOverrideApiResponse =
  /** status 200 OK */ any;
export type PostApiTestIdentityPlatformManagedOverrideApiArg = {
  managed?: boolean | null;
};
export type GetApiTextBlockApiResponse =
  /** status 200 OK */ PaginatedResponseTextBlock;
export type GetApiTextBlockApiArg = {
  key?: string;
  locale?: string;
  page?: number;
  search?: string | null;
  size?: number;
  sort?: string[];
};
export type PostApiTextBlockApiResponse = /** status 200 OK */ any;
export type PostApiTextBlockApiArg = {
  textBlockCreateDto: TextBlockCreateDto;
};
export type PostApiTextBlockLoadDefaultsApiResponse =
  /** status 200 OK */ string[];
export type PostApiTextBlockLoadDefaultsApiArg = void;
export type PatchApiTextBlockByIdApiResponse = /** status 200 OK */ any;
export type PatchApiTextBlockByIdApiArg = {
  id: ResourceId;
  textBlockUpdateDto: TextBlockUpdateDto;
};
export type GetApiTextBlockByIdApiResponse = /** status 200 OK */ TextBlock;
export type GetApiTextBlockByIdApiArg = {
  id: ResourceId;
};
export type DeleteApiTextBlockByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiTextBlockByIdApiArg = {
  id: ResourceId;
};
export type PostApiTextGeneratorFeedMessageApiResponse =
  /** status 200 OK */ GenerateTextResponse;
export type PostApiTextGeneratorFeedMessageApiArg = {
  generateText: GenerateText;
};
export type PostApiTextGeneratorTeaserApiResponse =
  /** status 200 OK */ GenerateTextResponse;
export type PostApiTextGeneratorTeaserApiArg = {
  generateText: GenerateText;
};
export type GetApiUsersApiResponse =
  /** status 200 OK */ PaginatedResponseUserSummary;
export type GetApiUsersApiArg = {
  accessAttributeFilter?: AccessAttributeFilter | null;
  filter?: UserFilter & any;
  page?: number | null;
  search?: string | null;
  size?: number | null;
  sort?: string[];
};
export type PostApiUsersApiResponse = /** status 200 OK */ any;
export type PostApiUsersApiArg = {
  createUser: CreateUser;
};
export type GetApiUsersByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ UserDetails;
export type GetApiUsersByExternalIdByExternalIdApiArg = {
  externalId: string;
};
export type GetApiUsersEmailBlockedApiResponse =
  /** status 200 OK */ PaginatedResponseBlockedRecipientDto;
export type GetApiUsersEmailBlockedApiArg = {
  page?: number | null;
  size?: number | null;
};
export type DeleteApiUsersEmailBlockedByUserIdApiResponse = unknown;
export type DeleteApiUsersEmailBlockedByUserIdApiArg = {
  userId: ResourceId;
};
export type PatchApiUsersMeApiResponse = unknown;
export type PatchApiUsersMeApiArg = {
  updateUser: UpdateUser;
};
export type GetApiUsersMeApiResponse = /** status 200 OK */ UserDetails;
export type GetApiUsersMeApiArg = void;
export type GetApiUsersMeChatTokenApiResponse = /** status 200 OK */ ChatToken;
export type GetApiUsersMeChatTokenApiArg = void;
export type PostApiUsersMeCloudMessageTokenApiResponse = unknown;
export type PostApiUsersMeCloudMessageTokenApiArg = {
  setCloudMessageToken: SetCloudMessageToken;
};
export type PostApiUsersMeResetPasswordApiResponse = unknown;
export type PostApiUsersMeResetPasswordApiArg = {
  resetPasswordRequest: ResetPasswordRequest;
};
export type PatchApiUsersMeTagNotificationSettingsApiResponse = unknown;
export type PatchApiUsersMeTagNotificationSettingsApiArg = {
  userTagNotificationUpdate: UserTagNotificationUpdate;
};
export type GetApiUsersMeTagNotificationSettingsApiResponse =
  /** status 200 OK */ UserTagNotificationSettings;
export type GetApiUsersMeTagNotificationSettingsApiArg = void;
export type PutApiUsersNotificationSettingsByTokenApiResponse = unknown;
export type PutApiUsersNotificationSettingsByTokenApiArg = {
  token: string;
  userTagNotificationUpdate: UserTagNotificationUpdate;
};
export type GetApiUsersNotificationSettingsByTokenApiResponse =
  /** status 200 OK */ UserTagNotificationSettings;
export type GetApiUsersNotificationSettingsByTokenApiArg = {
  token: string;
};
export type PostApiUsersRecoverPasswordApiResponse = unknown;
export type PostApiUsersRecoverPasswordApiArg = {
  recoverPasswordRequest: RecoverPasswordRequest;
};
export type PostApiUsersSetPasswordApiResponse = unknown;
export type PostApiUsersSetPasswordApiArg = {
  setPasswordWithTokenRequest: SetPasswordWithTokenRequest;
};
export type PostApiUsersSignInWithEmailLinkApiResponse = unknown;
export type PostApiUsersSignInWithEmailLinkApiArg = {
  signInWithEmailLink: SignInWithEmailLink;
};
export type GetApiUsersTenantApiResponse = /** status 200 OK */ TenantInfo[];
export type GetApiUsersTenantApiArg = {
  email: string;
};
export type GetApiUsersUnsubscribeByCredentialApiResponse =
  /** status 200 OK */ UnsubscribePreview;
export type GetApiUsersUnsubscribeByCredentialApiArg = {
  credential: string;
};
export type PostApiUsersUnsubscribeByCredentialApiResponse =
  /** status 200 OK */ UnsubscribePreferences;
export type PostApiUsersUnsubscribeByCredentialApiArg = {
  credential: string;
};
export type PutApiUsersUnsubscribeByCredentialEmailApiResponse =
  /** status 200 OK */ UnsubscribePreferences;
export type PutApiUsersUnsubscribeByCredentialEmailApiArg = {
  credential: string;
  setEmailEnabledRequest: SetEmailEnabledRequest;
};
export type GetApiUsersUnsubscribeByCredentialPreferencesApiResponse =
  /** status 200 OK */ UnsubscribePreferences;
export type GetApiUsersUnsubscribeByCredentialPreferencesApiArg = {
  credential: string;
};
export type PutApiUsersUnsubscribeByCredentialTopicsAndTagApiResponse =
  /** status 200 OK */ UnsubscribePreferences;
export type PutApiUsersUnsubscribeByCredentialTopicsAndTagApiArg = {
  credential: string;
  tag: string;
  setEmailEnabledRequest: SetEmailEnabledRequest;
};
export type PatchApiUsersByIdApiResponse = unknown;
export type PatchApiUsersByIdApiArg = {
  id: ResourceId;
  updateUser: UpdateUser;
};
export type GetApiUsersByIdApiResponse = /** status 200 OK */ UserDetails;
export type GetApiUsersByIdApiArg = {
  id: ResourceId;
  expandAccessAttributes: boolean;
};
export type DeleteApiUsersByIdApiResponse = unknown;
export type DeleteApiUsersByIdApiArg = {
  id: ResourceId;
};
export type PostApiUsersByIdResetPasswordApiResponse = unknown;
export type PostApiUsersByIdResetPasswordApiArg = {
  id: ResourceId;
  resetPasswordRequest: ResetPasswordRequest;
};
export type PatchApiUsersByIdTagNotificationSettingsApiResponse = unknown;
export type PatchApiUsersByIdTagNotificationSettingsApiArg = {
  id: ResourceId;
  userTagNotificationUpdate: UserTagNotificationUpdate;
};
export type GetApiUsersByIdTagNotificationSettingsApiResponse =
  /** status 200 OK */ UserTagNotificationSettings;
export type GetApiUsersByIdTagNotificationSettingsApiArg = {
  id: ResourceId;
};
export type GetApiVersionApiResponse = /** status 200 OK */ Version;
export type GetApiVersionApiArg = void;
export type Instant = string;
export type AccessAttribute = {
  id: number;
  name: string;
  jsonSchema: string;
  createdAt: Instant;
  publicOnUser?: boolean;
};
export type Responsible = 'USER' | 'AUTHOR' | 'TENANT_ADMIN' | 'PLATFORM';
export type ErrorBody = {
  /** Stable i18n key the client should use to look up the localized template in /i18n/errors.<locale>.json. */
  key: string;
  /** English fallback **template** with `{name}` placeholders. Identical to the entry under `key` in /i18n/errors.en.json — provided in the response so clients without the EN file can still render. Clients should ALWAYS substitute `messageArgs` into this (or into the locale-specific template) — never display it directly. */
  message: string;
  /** HTTP status code, echoed for convenience. */
  status: number;
  /** Runtime variables matching the `{name}` placeholders in `message` (and in the locale-specific template at /i18n/errors.<locale>.json). Empty for messages that have no variables. */
  messageArgs?: {
    [key: string]: string;
  };
  /** Who configured the constraint that produced this error. Use this to route the user to the right remediation path (TENANT_ADMIN → contact admin, AUTHOR → contact author, PLATFORM → contact support, USER → fix your own input). */
  responsible: Responsible;
};
export type Violation = {
  field: string;
  message: string;
};
export type ViolationReport = {
  title: string;
  status: number;
  key: string;
  violations: Violation[];
};
export type CreateAccessAttribute = {
  name: string;
  jsonSchema: string;
  publicOnUser?: boolean;
};
export type CreateAttributeValueByName = {
  attributeName: string;
  value: string;
};
export type AccessAttributeValue = {
  id: number;
  attributeId: number;
  name?: string | null;
  value: string;
  createdAt: Instant;
};
export type PaginationMetadata = {
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
  next?: string | null;
  previous?: string | null;
};
export type PaginatedResponseAccessAttributeValue = {
  data: AccessAttributeValue[];
  meta: PaginationMetadata;
};
export type AccessAttributeSortKey = 'NAME' | 'CREATED_AT';
export type SortOrder = 'ASC' | 'DESC';
export type ApiKeyInfo = {
  id: number;
  name: string;
  keyPrefix: string;
  createdAt: Instant | null;
  expiresAt: Instant | null;
  revoked: boolean;
};
export type AssociationIdFull = {
  valid?: boolean;
  id: number;
  tenantId: string;
};
export type ApiKeyCreated = {
  id: number;
  key: string;
  name: string;
  associationId: AssociationIdFull;
  expiresAt: Instant | null;
};
export type CreateApiKeyRequest = {
  name: string;
  expiresAt?: Instant | null;
};
export type RevokeApiKeyRequest = {
  reason?: string | null;
};
export type AssociationCreatedResponse = {
  baseUrl?: string;
  apiKey: string;
  expiresAt: Instant | null;
};
export type ProviderType =
  'KEYCLOAK' | 'FIREBASE' | 'EXTERNAL_OIDC' | 'API_KEY' | 'CONTROL_PLANE';
export type CreateAssociationOidcConfig = {
  clientId: string;
  clientSecretId: string;
  authServerUrl?: string | null;
  provider?: string | null;
  redirectUri?: string | null;
  issuer: string;
};
export type DemoRole = {
  name: string;
  externalId: string;
};
export type DemoMembership = {
  name: string;
  externalId: string;
};
export type DemoCategory = {
  name: string;
  externalId: string;
};
export type DemoGroup = {
  name: string;
  externalId: string;
};
export type DemoCompanyMembership = {
  groupId: string;
  membershipId: string;
};
export type DemoCompany = {
  externalId: string;
  name: string;
  address: string;
  postalCode: string;
  city: string;
  phone: string;
  email: string;
  groups?: DemoCompanyMembership[];
};
export type DemoTag = {
  name: string;
  mandatory: boolean;
};
export type DemoUserSettings = {
  notifyEmail: boolean;
  notifyPush: boolean;
};
export type DemoGroupRole = {
  groupId: string;
  roleId: string;
};
export type DemoCompanyCategory = {
  companyId: string;
  categoryId: string;
};
export type DemoAttribute = {
  name: string;
  value: string;
};
export type DemoUser = {
  externalId: string;
  firstName: string;
  lastName: string;
  email: string;
  settings: DemoUserSettings;
  companyIds?: string[];
  groupRoles?: DemoGroupRole[];
  companyCategories?: DemoCompanyCategory[];
  attributes?: DemoAttribute[];
  external?: boolean;
};
export type DemoData = {
  roles: DemoRole[];
  memberships: DemoMembership[];
  categories: DemoCategory[];
  groups: DemoGroup[];
  companies: DemoCompany[];
  tags: DemoTag[];
  users: DemoUser[];
  defaultUserPassword?: string | null;
};
export type DomainType = 'PRIMARY' | 'NORMAL' | 'EMAIL_ONLY';
export type AssociationDomain = {
  domain: string;
  type: DomainType;
  useHttp?: boolean;
};
export type CreateAssociation = {
  name: string;
  address: string;
  postalCode: string;
  city: string;
  domain: string;
  adminEmail: string;
  adminPassword: string;
  adminFirstName: string;
  adminLastName: string;
  tenantId?: string | null;
  createOnIdentityPlatform?: boolean;
  createdAt?: Instant;
  useHttp?: boolean;
  identityPlatformType?: ProviderType;
  oidcConfig?: CreateAssociationOidcConfig | null;
  demoDataName?: string | null;
  demoData?: DemoData | null;
  additionalDomains?: AssociationDomain[];
};
export type ArbitraryValue = string | number | number | boolean | object;
export type ConfigValue = {
  path: string;
  value: ArbitraryValue;
};
export type AssociationInfo = {
  name: string;
  demoMode: boolean;
  districtCodes?: string[];
};
export type Id = string | number;
export type Group = {
  id: Id;
  name: string;
  logo?: string | null;
  parentId?: number | null;
};
export type GroupMembershipType = {
  id: Id;
  name: string;
};
export type GroupWithMembership = {
  group: Group;
  membership: GroupMembershipType;
};
export type CompanySummary = {
  id: Id;
  name: string | null;
  city: string | null;
  postalCode: string | null;
  street?: string | null;
  phone?: string | null;
  fax?: string | null;
  groups?: GroupWithMembership[] | null;
};
export type PaginatedResponseCompanySummary = {
  data: CompanySummary[];
  meta: PaginationMetadata;
};
export type ResourceId = string | number;
export type CompanySortKey = 'NAME' | 'CITY' | 'POSTAL_CODE';
export type CreateGroupMembership = {
  groupId: ResourceId;
  membershipId: ResourceId;
};
export type ExternalGroupMembership = {
  guildId: string;
  membershipTypeId: string;
};
export type CreateCompany = {
  name: string;
  address: string;
  city: string;
  postalCode: string;
  phone?: string | null;
  secondaryPhone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  groupMemberships?: CreateGroupMembership[];
  externalMemberships?: ExternalGroupMembership[];
};
export type CompanyDetails = {
  id: Id;
  name: string | null;
  address: string | null;
  city: string | null;
  postalCode: string | null;
  phone: string | null;
  secondaryPhone: string | null;
  mobile: string | null;
  fax: string | null;
  email: string | null;
  website: string | null;
  logoUrl: string | null;
  groups: GroupWithMembership[];
};
export type UpdateCompany = {
  name?: string | null;
  address?: string | null;
  city?: string | null;
  postalCode?: string | null;
  phone?: string | null;
  secondaryPhone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  groupMemberships?: CreateGroupMembership[] | null;
};
export type AccessAttributeValueWithAttribute = {
  id: number;
  attribute: AccessAttribute;
  name?: string | null;
  value: string;
  createdAt: Instant;
};
export type UserSummary = {
  id: Id;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  companies?: CompanySummary[];
  appliedAccessAttributes?: AccessAttributeValueWithAttribute[];
  isExternal?: boolean;
  isCompanyUser?: boolean;
};
export type JsonElement = object;
export type JsonObject = {
  content: {
    [key: string]: JsonElement;
  };
  empty?: boolean;
  size?: number;
  keys?: string[];
  values?: JsonElement[];
  entries?: {
    key?: string;
    value?: JsonElement;
  }[];
};
export type CreatePolicyRule = {
  name: string;
  rule: string;
};
export type ResourceAction = {
  resourceTypes: string[];
  actions: string[];
};
export type Policies = {
  name: string;
  actions: ResourceAction[];
  rule: string;
  subject: string;
  object: string | null;
  effect: string;
  types?: string[];
};
export type TextBlockCreateDto = {
  key: string;
  locale: string;
  default: string;
  male?: string | null;
  female?: string | null;
  other?: string | null;
  company?: string | null;
};
export type AttributeTemplate = {
  name: string;
  template?: JsonObject;
};
export type RoleAttributeMapping = {
  attributes?: AttributeTemplate[];
};
export type TenantConfiguration = {
  accessAttributes: {
    [key: string]: JsonObject;
  };
  rules: CreatePolicyRule[];
  policies: Policies[];
  appointmentTypes: string[];
  textBlocks: TextBlockCreateDto[];
  roleAttributeMappings?: {
    [key: string]: RoleAttributeMapping;
  };
};
export type Association = {
  id: number;
  tenantId: string;
  name: string;
  domains: AssociationDomain[];
  address: string;
  zip: string;
  city: string;
};
export type PaginatedResponseAssociation = {
  data: Association[];
  meta: PaginationMetadata;
};
export type AuditStatus = 'PASSED' | 'FAILED' | 'WARNING';
export type AuditReport = {
  name: string;
  description: string;
  status: AuditStatus;
  message: string;
  createdAt?: Instant;
  details?: JsonObject | null;
};
export type BillableMembershipDto = {
  id: string;
  name: string;
  billable: boolean;
  companies: number;
};
export type SetBillableRequest = {
  billable: boolean;
};
export type BillingDimensionDto = {
  id: string;
  label: string;
  current: number;
};
export type BillingMetricDto = {
  key: string;
  label: string;
  fold: string;
  variables: string[];
  function: string | null;
  dimensions: BillingDimensionDto[];
  sample: number;
};
export type DnsRecordStatus = {
  recordType: string;
  name?: string | null;
  value?: string | null;
  valid?: string | null;
  priority?: string | null;
};
export type DomainVerification = {
  provider: string;
  domain: string;
  state: string;
  verified: boolean;
  unverifiedRecords?: DnsRecordStatus[];
  message?: string | null;
};
export type DomainType1 = 'PRIMARY' | 'FULL_APP' | 'EMAIL_ONLY';
export type DomainStatusDto = {
  domainId: number;
  domain: string;
  tenantId: string;
  priority: number;
  active: boolean;
  type: DomainType1;
  senders: string[];
};
export type DeliveryAlertDto = {
  id: number;
  tenantId: string | null;
  postId: Id | null;
  alertType: string;
  severity: string;
  message: string;
  totalCount: number;
  failedCount: number;
  failureRate: number | null;
  resolved: boolean;
  createdAt: Instant;
  resolvedAt: Instant | null;
};
export type PaginatedResponseDeliveryAlertDto = {
  data: DeliveryAlertDto[];
  meta: PaginationMetadata;
};
export type BounceDetails = {
  email: string;
  reasonCode: string | null;
  reasonDetail: string | null;
  source: string | null;
  blockedAt: Instant | null;
  tenantId: string | null;
};
export type BouncedUserDto = {
  user: UserSummary;
  bounce: BounceDetails;
};
export type PaginatedResponseBouncedUserDto = {
  data: BouncedUserDto[];
  meta: PaginationMetadata;
};
export type UnbounceResult = {
  localCleared: boolean;
  upstreamProviders: string[];
};
export type DeliveryRateDto = {
  tenantId: string | null;
  totalCount: number;
  deliveredCount: number;
  failedCount: number;
  pendingCount: number;
  deliveryRate: number;
  failureRate: number;
};
export type FailedNotificationDto = {
  notificationId: number;
  messageId: string;
  postId: Id | null;
  userId: Id;
  userEmail: string | null;
  recipientDomain: string | null;
  sendError: string | null;
  lastSenderId: string | null;
  attempts: number;
  failedAt: Instant | null;
  tenantId: string | null;
};
export type PaginatedResponseFailedNotificationDto = {
  data: FailedNotificationDto[];
  meta: PaginationMetadata;
};
export type ProviderProblemDto = {
  provider: string;
  totalCount: number;
  deliveredCount: number;
  failedCount: number;
  deferredCount: number;
  delayedCount: number;
  failureRate: number;
};
export type SenderStatsDto = {
  senderId: string;
  totalCount: number;
  deliveredCount: number;
  failedCount: number;
  pendingCount: number;
  deliveryRate: number;
};
export type InvoiceVariablesDto = {
  values: {
    [key: string]: number;
  };
  defaulted: string[];
  dimensioned: {
    [key: string]: {
      [key: string]: number;
    };
  };
};
export type InvoiceDto = {
  id: number;
  tenantId: string;
  associationName: string;
  invoiceMonth: string;
  invoiceUri: string;
  price: number | null;
  formula: string | null;
  variables: InvoiceVariablesDto | null;
};
export type LocalDate = string;
export type LexofficeAssignment = {
  tenantId: string;
  tenantName: string;
};
export type LexofficeContactView = {
  id: string;
  displayName: string;
  customerNumber?: number | null;
  vendorNumber?: number | null;
  roles?: string[];
  assignedTo?: LexofficeAssignment | null;
};
export type AssignLexofficeRequest = {
  lexofficeContactId: string;
};
export type LexofficeContactFilter = 'ALL' | 'UNASSIGNED' | 'ASSIGNED';
export type MaintenanceIntervalDto = {
  id: number | null;
  associationId: number | null;
  startTime: Instant;
  endTime: Instant;
  message: string | null;
  createdAt: Instant | null;
};
export type CreateMaintenanceIntervalRequest = {
  associationId?: number | null;
  startTime: Instant;
  endTime: Instant;
  message?: string | null;
};
export type UpdateMaintenanceIntervalRequest = {
  associationId?: number | null;
  startTime: Instant;
  endTime: Instant;
  message?: string | null;
};
export type ControlPlaneUserMappingEntry = {
  id: number;
  controlPlaneUserPk: ResourceId;
  controlPlaneUserEmail: string | null;
  targetTenantId: string;
  systemUserPk: ResourceId;
};
export type CreateMappingRequest = {
  targetTenantId: string;
  systemUserName: string;
};
export type ControlPlaneUserInfo = {
  id: ResourceId;
  email: string | null;
  roles: string[];
};
export type FormulaValidationResponse = {
  valid: boolean;
  price?: number | null;
  error?: string | null;
};
export type FormulaValidationRequest = {
  formula: string;
  numUsers?: number;
  numCompanies?: number;
};
export type PaymentConditionsDto = {
  paymentTermLabel: string;
  paymentTermDays: number;
  priceCalculationFormula?: string | null;
  aboPriceDescription?: string | null;
  invoiceRemark?: string | null;
  invoiceVat: number;
};
export type FormulaPreviewResponse = {
  valid: boolean;
  price: number | null;
  error: string | null;
  invoiceMonth: string;
  values: {
    [key: string]: number;
  };
  dimensioned: {
    [key: string]: {
      [key: string]: number;
    };
  };
  defaulted: string[];
};
export type FormulaPreviewRequest = {
  formula: string;
  invoiceMonth?: string | null;
};
export type Effect = 'ALLOW' | 'DENY';
export type MatchingResource = {
  resourceId: number;
  rule: string;
  effect: Effect;
  subjectAavId: number;
  objectAavId: number | null;
};
export type AccessTestResponse = {
  resourceId: number;
  accessGranted: boolean;
  matchingResources?: MatchingResource[];
};
export type ResourceType =
  | 'DOCUMENT'
  | 'FOLDER'
  | 'DOCUMENT_GROUP'
  | 'POST'
  | 'GUILD'
  | 'GROUP'
  | 'COMPANY'
  | 'EVENT'
  | 'USER_LIST'
  | 'ASSOCIATION'
  | 'CREATE_RESOURCE'
  | 'USER'
  | 'TAG'
  | 'EMAIL_SIGNATURE'
  | 'CHAT_CHANNEL'
  | 'DOCUMENT_CATEGORY'
  | 'TEXT_BLOCK'
  | 'SURVEY'
  | 'UNKNOWN'
  | 'EMAIL_TEMPLATE'
  | 'SCHEDULER_TASK'
  | 'ALL';
export type Action =
  | 'READ'
  | 'WRITE'
  | 'DELETE'
  | 'CREATE'
  | 'UPDATE'
  | 'LIST'
  | 'READ_METADATA'
  | 'READ_DRAFT'
  | 'PUBLISH'
  | 'COMMENT'
  | 'VOTE'
  | 'COMPANY_SET_ADMIN'
  | 'COMPANY_EDIT_MEMBERSHIP'
  | 'USER_UPDATE_ACCESS_ATTRIBUTES'
  | 'USER_SET_ADMIN'
  | 'JOIN'
  | 'EVENT_READ_ATTENDEES'
  | 'EVENT_ATTEND'
  | 'EVENT_SET_ATTENDEE_STATUS'
  | 'USER_UPDATE_REQUEST'
  | 'COMPANY_UPDATE_REQUEST'
  | 'CREATE_REQUEST'
  | 'GUILD_UPDATE_REQUEST'
  | 'USER_UPDATE_EMAIL'
  | 'ROLE_UPDATE_REQUEST'
  | 'READ_RECIPIENTS'
  | 'SURVEY_EDIT_RESPONSE'
  | 'SURVEY_READ_RESPONSES'
  | 'READ_UNPUBLISHED'
  | 'ALL'
  | 'SURVEY_PARTICIPATE';
export type AccessTestRequest = {
  userId: number;
  resourceType: ResourceType;
  action: Action;
  resourceId?: number | null;
};
export type StatWithTrend = {
  current: number;
  previous: number;
  trend?: number;
};
export type UserStatistics = {
  internal: StatWithTrend;
  external: StatWithTrend;
  total: StatWithTrend;
};
export type AssociationMonthlyStatistics = {
  tenantId: string;
  period: string;
  users: UserStatistics;
  companyCount: StatWithTrend;
  emailsSent: StatWithTrend;
  postsPublished: StatWithTrend;
  eventsPublished: StatWithTrend;
  surveysPublished: StatWithTrend;
};
export type EmailTemplateType =
  | 'POST'
  | 'SERVICE'
  | 'PASSWORD_RESET_LINK'
  | 'PASSWORD_NEW_LINK'
  | 'MAGIC_LINK'
  | 'NEWSLETTER'
  | 'EVENT_CONFIRMATION';
export type SyncUserRequest = {
  ids?: string[];
  password?: string | null;
};
export type PaginatedResponseUserSummary = {
  data: UserSummary[];
  meta: PaginationMetadata;
};
export type AccessAttributeFilter = object;
export type UserFilter = 'ALL' | 'EXTERNAL' | 'INTERNAL';
export type DedupeTableResult = {
  table: string;
  column: string;
  action: string;
  moved: number;
  dropped: number;
  left: number;
};
export type AttributeValueRewrite = {
  attribute: string;
  oldValueId: number;
  newValueId: number;
  applicationsMoved: number;
  applicationsDropped: number;
  oldValueDeactivated: boolean;
};
export type DedupeMergeResult = {
  winnerId: string;
  loserId: string;
  dryRun: boolean;
  tables: DedupeTableResult[];
  totalMoved: number;
  totalDropped: number;
  totalLeft: number;
  attributeValuesRewritten: AttributeValueRewrite[];
  loserSoftDeleted: boolean;
};
export type DuplicateUserRow = {
  id: string;
  firstName: string | null;
  lastName: string | null;
  isCompanyUser: boolean;
  external: boolean;
  hasLogin: boolean;
  createdAt: string | null;
};
export type DuplicateUserGroup = {
  email: string;
  external: boolean;
  winnerId: string;
  loserIds: string[];
  rows: DuplicateUserRow[];
  severity: string;
};
export type DocumentCategory = {
  id: Id;
  name: string;
};
export type PaginatedResponseDocumentCategory = {
  data: DocumentCategory[];
  meta: PaginationMetadata;
};
export type DocumentCategoryCreateDto = {
  name: string;
};
export type DocumentCategoryUpdateDto = {
  /** Optional property name for update */
  name?: string | null;
  empty?: boolean;
};
export type MoveDocumentsRequest = {
  documentIds: ResourceId[];
  targetFolderId: ResourceId;
};
export type UpdateDocument = {
  name?: string | null;
  recipients?: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  } | null;
  tags?: string[] | null;
  expiresAt?: string | null;
  empty?: boolean;
};
export type AppliedAccessAttributes = {
  id: ResourceId;
  appliedAccessAttributes: AccessAttributeValueWithAttribute[];
};
export type LocalDateTime = string;
export type DownloadLink = {
  url: string;
  expiresAt: LocalDateTime;
};
export type CreateDocumentResponse = {
  id: Id;
  uploadUrl: string;
};
export type UploadStatus = 'UPLOADING' | 'UPLOADED' | 'FAILED';
export type DocumentItem = {
  id: Id;
  folderId?: Id | null;
  createdAt?: LocalDateTime | null;
  type: string;
  name: string;
  icon?: string | null;
  categoryId?: number | null;
  uploadStatus?: UploadStatus | null;
  expiresAt?: Instant | null;
};
export type PaginatedResponseDocumentItem = {
  data: DocumentItem[];
  meta: PaginationMetadata;
};
export type DocumentSortKey = 'NAME' | 'CREATED_AT';
export type CreateFolder = {
  name: string;
  icon?: string | null;
  tags?: string[];
};
export type MoveFoldersRequest = {
  folderIds: ResourceId[];
  targetFolderId?: ResourceId | null;
};
export type UpdateFolderV2 = {
  name: string;
};
export type Folder1 = {
  id?: Id;
  name: string;
  creatorId: Id | null;
  parentId: Id | null;
  isVirtual: boolean;
  virtualParentId: Id | null;
  icon: string | null;
  createdAt: Instant;
  pathChecksum?: string | null;
};
export type Recipients = {
  accessAttributeValueIds?: number[];
  accessAttributes?: CreateAttributeValueByName[];
};
export type CreateDocument = {
  name: string;
  recipients: Recipients;
  tags?: string[];
  waitForUpload?: boolean;
};
export type Folder = {
  id: ResourceId;
  parentId: ResourceId | null;
  name: string;
  icon?: string | null;
};
export type Location = {
  id?: number | null;
  name: string;
  streetAddress: string;
  locality: string;
  postalCode: string;
  lat?: number | null;
  lng?: number | null;
  plusCode?: string | null;
};
export type EventPreviewSummary = {
  id: ResourceId;
  name: string;
  description?: string | null;
  startAt: Instant;
  endAt: Instant;
  location?: Location | null;
  locationString?: string | null;
  onlineMeetingUrl?: string | null;
  responseDeadline?: Instant | null;
  maxAttendees?: number | null;
  surveyId?: ResourceId | null;
  startDate?: string;
  startTime?: string;
};
export type EmailRenderRequestNewsletterArticle = {
  title: string;
  content: string;
  imageUrl?: string | null;
  postId: ResourceId;
};
export type EmailRenderRequest = {
  subject: string;
  html: string;
  text: string;
  imageUrl: string | null;
  postId: ResourceId;
  templateId: ResourceId;
  signatureId: ResourceId;
  event: EventPreviewSummary | null;
  hasSurvey: boolean;
  articles?: EmailRenderRequestNewsletterArticle[] | null;
};
export type InlineEmailTemplate = {
  name: string;
  description?: string | null;
  text: string;
  html: string;
  type: EmailTemplateType;
};
export type InlineEmailSignature = {
  name: string;
  signature?: string | null;
  title?: string | null;
  organizationName?: string | null;
  street?: string | null;
  city?: string | null;
  postalCode?: string | null;
  country?: string | null;
  phone?: string | null;
  mobile?: string | null;
  email: string;
  replyTo?: string | null;
  website?: string | null;
  facebook?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
  instagram?: string | null;
  youtube?: string | null;
  representatives?: string | null;
  legal?: string | null;
  logoUrl?: string | null;
  logoWidth?: number | null;
  logoHeight?: number | null;
};
export type EmailRenderPreviewRequest = {
  subject: string;
  html: string;
  text: string;
  imageUrl: string | null;
  postId: ResourceId;
  templateId?: ResourceId | null;
  signatureId?: ResourceId | null;
  inlineTemplate?: InlineEmailTemplate | null;
  inlineSignature?: InlineEmailSignature | null;
  event?: EventPreviewSummary | null;
  hasSurvey?: boolean;
  articles?: EmailRenderRequestNewsletterArticle[] | null;
};
export type EmailSignature = {
  id?: Id | null;
  name: string;
  signature?: string | null;
  title?: string | null;
  organizationName?: string | null;
  street?: string | null;
  city?: string | null;
  postalCode?: string | null;
  country?: string | null;
  phone?: string | null;
  mobile?: string | null;
  email: string;
  replyTo?: string | null;
  website?: string | null;
  facebook?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
  instagram?: string | null;
  youtube?: string | null;
  representatives?: string | null;
  legal?: string | null;
  logoUrl?: string | null;
  logoWidth?: number | null;
  logoHeight?: number | null;
  createdAt?: Instant;
};
export type PaginatedResponseEmailSignature = {
  data: EmailSignature[];
  meta: PaginationMetadata;
};
export type EmailSignatureCreateDto = {
  name: string;
  signature?: string | null;
  title?: string | null;
  organizationName?: string | null;
  street?: string | null;
  city?: string | null;
  postalCode?: string | null;
  country?: string | null;
  phone?: string | null;
  mobile?: string | null;
  email: string;
  replyTo?: string | null;
  website?: string | null;
  facebook?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
  instagram?: string | null;
  youtube?: string | null;
  representatives?: string | null;
  legal?: string | null;
  logoUrl?: string | null;
  logoWidth?: number | null;
  logoHeight?: number | null;
};
export type EmailSignatureUpdateDto = {
  /** Optional property name for update */
  name?: string | null;
  /** Optional property signature for update */
  signature?: string | null;
  /** Optional property title for update */
  title?: string | null;
  /** Optional property organizationName for update */
  organizationName?: string | null;
  /** Optional property street for update */
  street?: string | null;
  /** Optional property city for update */
  city?: string | null;
  /** Optional property postalCode for update */
  postalCode?: string | null;
  /** Optional property country for update */
  country?: string | null;
  /** Optional property phone for update */
  phone?: string | null;
  /** Optional property mobile for update */
  mobile?: string | null;
  /** Optional property email for update */
  email?: string | null;
  /** Optional property replyTo for update */
  replyTo?: string | null;
  /** Optional property website for update */
  website?: string | null;
  /** Optional property facebook for update */
  facebook?: string | null;
  /** Optional property twitter for update */
  twitter?: string | null;
  /** Optional property linkedin for update */
  linkedin?: string | null;
  /** Optional property instagram for update */
  instagram?: string | null;
  /** Optional property youtube for update */
  youtube?: string | null;
  /** Optional property representatives for update */
  representatives?: string | null;
  /** Optional property legal for update */
  legal?: string | null;
  /** Optional property logoUrl for update */
  logoUrl?: string | null;
  /** Optional property logoWidth for update */
  logoWidth?: number | null;
  /** Optional property logoHeight for update */
  logoHeight?: number | null;
  empty?: boolean;
};
export type EmailTemplateStatus = 'DRAFT' | 'PUBLISHED';
export type EmailTemplate = {
  id: Id;
  name: string;
  description?: string | null;
  text: string;
  html: string;
  language?: string;
  source?: string | null;
  status?: EmailTemplateStatus;
  createdAt: Instant;
  type?: EmailTemplateType;
};
export type PaginatedResponseEmailTemplate = {
  data: EmailTemplate[];
  meta: PaginationMetadata;
};
export type EmailTemplateCreateDto = {
  name: string;
  description?: string | null;
  text: string;
  html: string;
  language: string;
  source?: string | null;
  type: EmailTemplateType;
};
export type EmailTemplateUpdateDto = {
  /** Optional property name for update */
  name?: string | null;
  /** Optional property description for update */
  description?: string | null;
  /** Optional property text for update */
  text?: string | null;
  /** Optional property html for update */
  html?: string | null;
  /** Optional property language for update */
  language?: string | null;
  /** Optional property source for update */
  source?: string | null;
  /** Optional property status for update */
  status?:
    ('DRAFT' | 'PUBLISHED') | ('DRAFT' | 'PUBLISHED') | ('DRAFT' | 'PUBLISHED');
  empty?: boolean;
};
export type CopyEmailTemplateFromDefaultDto = {
  type: EmailTemplateType;
  name?: string | null;
  description?: string | null;
  language?: string | null;
};
export type EmailVariable = {
  token: string;
  name: string;
  group: string;
  kind: string;
  nullable?: boolean;
  label?: string | null;
  example?: string | null;
};
export type EmailTemplateVariablesDto = {
  type: EmailTemplateType;
  variables: EmailVariable[];
};
export type EmailTemplateStatusUpdateDto = {
  status: EmailTemplateStatus;
};
export type DomainEmailConfigEntry = {
  id?: number | null;
  domainId: number;
  senderId: string;
  senderType: string;
  senderEmail: string;
  entraTenantId?: string | null;
  entraClientId?: string | null;
  entraClientSecret?: string | null;
  isEnabled?: boolean;
  createdAt?: Instant | null;
  updatedAt?: Instant | null;
};
export type AttendeeStatus =
  | 'ATTENDING'
  | 'NOT_ATTENDING'
  | 'MAYBE_ATTENDING'
  | 'NO_ANSWER'
  | 'NOT_INVITED'
  | 'ATTENDED'
  | 'WAIT_LISTED';
export type AttendeesInfo = {
  numInvitations: number;
  numAttending?: number;
  numNotAttending?: number;
  numMaybeAttending?: number;
  numNoAnswer?: number;
};
export type EventDetails = {
  id: Id;
  name: string;
  description?: string | null;
  onlineMeetingUrl: string | null;
  startAt: Instant;
  endAt?: Instant | null;
  location?: Location | null;
  postIds?: Id[] | null;
  startAtDay?: LocalDate | null;
  endAtDay?: LocalDate | null;
  responseDeadline?: Instant | null;
  myAttendeeStatus?: AttendeeStatus;
  attendeesInfo?: AttendeesInfo | null;
  attendeeStatusAccessAttribute?: AccessAttribute | null;
  maxAttendees?: number | null;
  currentAttendees?: number;
  publishedAt?: Instant | null;
  attributes?: AccessAttributeValueWithAttribute[];
  publicEvent?: boolean;
  surveyId?: Id | null;
};
export type PaginatedResponseEventDetails = {
  data: EventDetails[];
  meta: PaginationMetadata;
};
export type PublishStatus = 'DRAFT' | 'PUBLISHED' | 'DELETED' | 'ALL';
export type EventAttendeeListAccess = 'PUBLIC' | 'PRIVATE' | 'INTERNAL';
export type CreateEvent = {
  name: string;
  description?: string | null;
  onlineMeetingUrl?: string | null;
  startAt: Instant;
  endAt: Instant;
  location?: Location | null;
  startAtDay?: LocalDate | null;
  endAtDay?: LocalDate | null;
  responseDeadline?: Instant | null;
  attendeeListAccess?: EventAttendeeListAccess;
  maxAttendees?: number | null;
  recipients?: Recipients;
  publicEvent?: boolean;
  surveyId?: ResourceId | null;
};
export type Gender = 'FEMALE' | 'MALE' | 'DIVERSE' | 'UNKNOWN';
export type EmailUser = {
  id: Id;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Gender | null;
  email?: string | null;
  companies?: CompanySummary[] | null;
  isExternal?: boolean | null;
  isCompanyUser?: boolean | null;
  emailBlocked?: boolean | null;
  emailValid?: boolean;
};
export type SurveyPrivacy = 'ANONYMOUS' | 'IDENTIFIED';
export type Survey = {
  id: Id;
  title?: string | null;
  json: string;
  responseDeadline: Instant;
  createdAt: Instant;
  isTemplate?: boolean;
  description?: string | null;
  privacy: SurveyPrivacy;
  publishedAt?: Instant | null;
};
export type SurveyRead = {
  id: Id;
  title?: string | null;
  json: string;
  responseDeadline: Instant;
  createdAt: Instant;
  creator?: EmailUser | null;
  isTemplate?: boolean;
  description?: string | null;
  privacy: SurveyPrivacy;
  publishedAt?: Instant | null;
};
export type SurveyResponse = {
  id: number;
  user: EmailUser | null;
  json: string;
  createdAt: Instant;
  updatedAt: Instant;
  publishedAt: Instant | null;
  privacy?: SurveyPrivacy;
};
export type SurveyWithResponse = {
  survey: Survey;
  response?: SurveyResponse | null;
  token: string;
};
export type SurveyWithResponseRead = {
  survey: SurveyRead;
  response?: SurveyResponse | null;
  token: string;
};
export type AttendResponse = {
  user: EmailUser;
  status: AttendeeStatus;
  surveyWithResponse?: SurveyWithResponse | null;
};
export type AttendResponseRead = {
  user: EmailUser;
  status: AttendeeStatus;
  surveyWithResponse?: SurveyWithResponseRead | null;
};
export type AttendWithToken = {
  token: string;
};
export type NullableResourceId =
  ((string | null) | (number | null) | (null | null)) | null;
export type UpdateEvent = {
  name?: string | null;
  description?: string | null;
  onlineMeetingUrl?: string | null;
  startAt?: string | null;
  endAt?: string | null;
  location?: {
    name?: string | null;
    streetAddress?: string | null;
    locality?: string | null;
    postalCode?: string | null;
    lat?: number | null;
    lng?: number | null;
    plusCode?: string | null;
  } | null;
  startAtDay?: string | null;
  endAtDay?: string | null;
  responseDeadline?: string | null;
  maxAttendees?: number | null;
  recipients?: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  } | null;
  publicEvent?: boolean | null;
  attendeeListAccess?:
    ('PUBLIC' | 'PRIVATE' | 'INTERNAL') | ('PUBLIC' | 'PRIVATE' | 'INTERNAL');
  surveyId?: NullableResourceId;
};
export type PaginatedResponseAttendResponse = {
  data: AttendResponse[];
  meta: PaginationMetadata;
};
export type PaginatedResponseAttendResponseRead = {
  data: AttendResponseRead[];
  meta: PaginationMetadata;
};
export type AttendRequest = {
  attendeeId?: ResourceId;
  attend: AttendeeStatus;
};
export type Group1 = {
  id: Id;
  parentId?: number | null;
  number?: string | null;
  logo?: string | null;
  name: string | null;
  createdAt?: Instant | null;
};
export type PaginatedResponseGroup = {
  data: Group1[];
  meta: PaginationMetadata;
};
export type GroupCreateDto = {
  parentId?: number | null;
  number?: string | null;
  logo?: string | null;
  name?: string | null;
};
export type GroupUpdateDto = {
  /** Optional property parentId for update */
  parentId?: number | null;
  /** Optional property number for update */
  number?: string | null;
  /** Optional property logo for update */
  logo?: string | null;
  /** Optional property name for update */
  name?: string | null;
  empty?: boolean;
};
export type PaginatedResponseEmailUser = {
  data: EmailUser[];
  meta: PaginationMetadata;
};
export type CreateImageResponse = {
  id: string;
  uploadUrl: string;
  downloadUrl: string;
};
export type CreateImage = {
  name: string;
};
export type NewsletterArticleSummary = {
  title: string;
  feedText: string;
  digestImageUrl?: string | null;
};
export type UserTokenNewsletterArticle = {
  token: string;
  summary: NewsletterArticleSummary;
};
export type UserTokenNewsletter = {
  token: string;
  summary: NewsletterArticleSummary;
  articles: UserTokenNewsletterArticle[];
};
export type PostType =
  | 'REGULAR'
  | 'UPDATE'
  | 'REMINDER'
  | 'ARTICLE'
  | 'NEWSLETTER_DIGEST'
  | 'NEWSLETTER_ARTICLE';
export type Tag = {
  id?: Id;
  name: string;
  color: string;
  associationId?: number;
  mandatoryNotification: boolean;
  active?: boolean;
  createdAt?: Instant;
};
export type EditorType = 'QUILL' | 'BLOCKNOTE';
export type PostDetails = {
  id: Id;
  title: string;
  bodyText: string;
  bodyHtml: string;
  bodyQuill: string;
  author: EmailUser;
  category: DocumentCategory;
  createdAt: LocalDateTime;
  numComments: number;
  numViews: number;
  numVotes: number;
  publishedAt?: LocalDateTime | null;
  imageUrl?: string | null;
  event?: EventDetails | null;
  attributes?: AccessAttributeValueWithAttribute[];
  iLiked?: boolean;
  emailTemplate?: EmailTemplate | null;
  signature?: EmailSignature | null;
  parentPostId?: Id | null;
  parentType?: PostType | null;
  parentPublishedAt?: LocalDateTime | null;
  tags?: Tag[];
  publishDelayedAt?: Instant | null;
  teaser?: string | null;
  survey?: Survey | null;
  type?: PostType;
  feedText?: string | null;
  editorType?: EditorType;
  numChildren?: number;
  digestImageUrl?: string | null;
  isPublic?: boolean;
  attachmentIds?: Id[];
  ILiked?: boolean;
};
export type PostDetailsRead = {
  id: Id;
  title: string;
  bodyText: string;
  bodyHtml: string;
  bodyQuill: string;
  author: EmailUser;
  category: DocumentCategory;
  createdAt: LocalDateTime;
  numComments: number;
  numViews: number;
  numVotes: number;
  publishedAt?: LocalDateTime | null;
  imageUrl?: string | null;
  event?: EventDetails | null;
  attributes?: AccessAttributeValueWithAttribute[];
  iLiked?: boolean;
  emailTemplate?: EmailTemplate | null;
  signature?: EmailSignature | null;
  parentPostId?: Id | null;
  parentType?: PostType | null;
  parentPublishedAt?: LocalDateTime | null;
  tags?: Tag[];
  publishDelayedAt?: Instant | null;
  teaser?: string | null;
  survey?: SurveyRead | null;
  type?: PostType;
  feedText?: string | null;
  editorType?: EditorType;
  numChildren?: number;
  digestImageUrl?: string | null;
  isPublic?: boolean;
  attachmentIds?: Id[];
  ILiked?: boolean;
};
export type EmailTemplateSummary = {
  id: Id;
  name: string;
  description: string | null;
  type: EmailTemplateType;
};
export type UserListInfo = {
  id: Id;
  name: string;
  description: string | null;
  createdAt: LocalDateTime;
  creator: EmailUser;
  accessAttributeValues?: AccessAttributeValueWithAttribute[];
  signature?: EmailSignature | null;
  templates?: {
    [key: string]: EmailTemplateSummary;
  };
  chatEnabled?: boolean;
  chatChannelId?: string | null;
};
export type PaginatedResponseUserListInfo = {
  data: UserListInfo[];
  meta: PaginationMetadata;
};
export type CreateUserList = {
  name: string;
  description?: string | null;
  recipients: Recipients;
  ephemeral?: boolean;
  signatureId?: ResourceId | null;
  templateIds?:
    | {
        [key: string]: ResourceId;
      }
    | {
        [key: string]: ResourceId;
      };
  chatEnabled?: boolean;
};
export type UpdateUserListInfo = {
  name?: string | null;
  description?: string | null;
  recipients?: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  } | null;
  signatureId?: number | string | null;
  chatEnabled?: boolean | null;
  templateIds?: number | string | null;
};
export type GroupSurrogate = {
  id: string;
  name: string;
};
export type EntityError = {
  id: string;
  error: string;
};
export type EntityUpdateSummaryGroupSurrogate = {
  toAdd: GroupSurrogate[];
  toRemove: GroupSurrogate[];
  toUpdate: {
    old: GroupSurrogate;
    new: GroupSurrogate;
  }[];
  errors: EntityError[];
};
export type RoleSurrogate = {
  id: string;
  name: string;
};
export type EntityUpdateSummaryRoleSurrogate = {
  toAdd: RoleSurrogate[];
  toRemove: RoleSurrogate[];
  toUpdate: {
    old: RoleSurrogate;
    new: RoleSurrogate;
  }[];
  errors: EntityError[];
};
export type MembershipSurrogate = {
  id: string;
  name: string;
};
export type EntityUpdateSummaryMembershipSurrogate = {
  toAdd: MembershipSurrogate[];
  toRemove: MembershipSurrogate[];
  toUpdate: {
    old: MembershipSurrogate;
    new: MembershipSurrogate;
  }[];
  errors: EntityError[];
};
export type CategorySurrogate = {
  id: string;
  name: string;
};
export type EntityUpdateSummaryCategorySurrogate = {
  toAdd: CategorySurrogate[];
  toRemove: CategorySurrogate[];
  toUpdate: {
    old: CategorySurrogate;
    new: CategorySurrogate;
  }[];
  errors: EntityError[];
};
export type CompanyGroupMembershipSurrogate = {
  groupId: string;
  membershipId: string;
};
export type CompanySurrogate = {
  id: string;
  name: string;
  address?: string | null;
  city?: string | null;
  postalCode?: string | null;
  phone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  website?: string | null;
  groupMemberships?: CompanyGroupMembershipSurrogate[];
};
export type EntityUpdateSummaryCompanySurrogate = {
  toAdd: CompanySurrogate[];
  toRemove: CompanySurrogate[];
  toUpdate: {
    old: CompanySurrogate;
    new: CompanySurrogate;
  }[];
  errors: EntityError[];
};
export type UserAttributeSurrogate = {
  name: string;
  value: string;
};
export type UserUpdateOptions = {
  keepLogin?: boolean;
};
export type UserSurrogate = {
  id: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: string | null;
  phone?: string | null;
  companyAccount?: boolean;
  external?: boolean;
  companyIds?: string[];
  attributes?: UserAttributeSurrogate[];
  updateOptions?: UserUpdateOptions;
};
export type EntityUpdateSummaryUserSurrogate = {
  toAdd: UserSurrogate[];
  toRemove: UserSurrogate[];
  toUpdate: {
    old: UserSurrogate;
    new: UserSurrogate;
  }[];
  errors: EntityError[];
};
export type UpdatePlan = {
  groups: EntityUpdateSummaryGroupSurrogate;
  roles: EntityUpdateSummaryRoleSurrogate;
  memberships: EntityUpdateSummaryMembershipSurrogate;
  categories: EntityUpdateSummaryCategorySurrogate;
  companies: EntityUpdateSummaryCompanySurrogate;
  users: EntityUpdateSummaryUserSurrogate;
};
export type BatchImportResult = {
  roles?: EntityError[];
  categories?: EntityError[];
  groups?: EntityError[];
  memberships?: EntityError[];
  companies?: EntityError[];
  users?: EntityError[];
  hasErrors?: boolean;
};
export type Reject = object;
export type Accept = object;
export type Undecided = object;
export type Decision =
  | ({
      type: 'Reject';
    } & Reject)
  | ({
      type: 'Accept';
    } & Accept)
  | ({
      type: 'Undecided';
    } & Undecided);
export type FieldUpdateRequestString = {
  old: string | null;
  new: string;
  decision?: Decision;
};
export type FieldUpdateRequestBoolean = {
  old: boolean | null;
  new: boolean;
  decision?: Decision;
};
export type FieldUpdateRequestListExternalGroupMembership = {
  old: ExternalGroupMembership[] | null;
  new: ExternalGroupMembership[];
  decision?: Decision;
};
export type ExternalCompanyUpdateRequest = {
  externalId: string;
  companyId: ResourceId;
  name?: FieldUpdateRequestString | null;
  address?: FieldUpdateRequestString | null;
  city?: FieldUpdateRequestString | null;
  postalCode?: FieldUpdateRequestString | null;
  phone?: FieldUpdateRequestString | null;
  secondaryPhone?: FieldUpdateRequestString | null;
  mobile?: FieldUpdateRequestString | null;
  fax?: FieldUpdateRequestString | null;
  email?: FieldUpdateRequestString | null;
  website?: FieldUpdateRequestString | null;
  logoUrl?: FieldUpdateRequestString | null;
  isCompanyAccount?: FieldUpdateRequestBoolean | null;
  externalGroupMemberships?: FieldUpdateRequestListExternalGroupMembership | null;
};
export type ExternalCompanyUpdateRequestRead = {
  id?: number;
  externalId: string;
  companyId: ResourceId;
  company?: CompanySummary | null;
  name?: FieldUpdateRequestString | null;
  address?: FieldUpdateRequestString | null;
  city?: FieldUpdateRequestString | null;
  postalCode?: FieldUpdateRequestString | null;
  phone?: FieldUpdateRequestString | null;
  secondaryPhone?: FieldUpdateRequestString | null;
  mobile?: FieldUpdateRequestString | null;
  fax?: FieldUpdateRequestString | null;
  email?: FieldUpdateRequestString | null;
  website?: FieldUpdateRequestString | null;
  logoUrl?: FieldUpdateRequestString | null;
  isCompanyAccount?: FieldUpdateRequestBoolean | null;
  externalGroupMemberships?: FieldUpdateRequestListExternalGroupMembership | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalCompanyDeleteRequest = {
  externalId: string;
};
export type ExternalCompanyDeleteRequestRead = {
  id?: number;
  externalId: string;
  company?: CompanySummary | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalCompanyCreateRequest = {
  externalId: string;
  name: string;
  address?: string | null;
  city?: string | null;
  postalCode?: string | null;
  phone?: string | null;
  secondaryPhone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  isCompanyAccount?: boolean;
  externalGroupMemberships?: ExternalGroupMembership[];
};
export type ExternalCompanyCreateRequestRead = {
  id?: number;
  externalId: string;
  name: string;
  address?: string | null;
  city?: string | null;
  postalCode?: string | null;
  phone?: string | null;
  secondaryPhone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  isCompanyAccount?: boolean;
  externalGroupMemberships?: ExternalGroupMembership[];
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalCompanyChangeRequest =
  | ({
      type: 'ExternalCompanyUpdateRequest';
    } & ExternalCompanyUpdateRequest)
  | ({
      type: 'ExternalCompanyDeleteRequest';
    } & ExternalCompanyDeleteRequest)
  | ({
      type: 'ExternalCompanyCreateRequest';
    } & ExternalCompanyCreateRequest);
export type ExternalCompanyChangeRequestRead =
  | ({
      type: 'ExternalCompanyUpdateRequest';
    } & ExternalCompanyUpdateRequestRead)
  | ({
      type: 'ExternalCompanyDeleteRequest';
    } & ExternalCompanyDeleteRequestRead)
  | ({
      type: 'ExternalCompanyCreateRequest';
    } & ExternalCompanyCreateRequestRead);
export type PaginatedResponseExternalCompanyChangeRequest = {
  data: ExternalCompanyChangeRequest[];
  meta: PaginationMetadata;
};
export type PaginatedResponseExternalCompanyChangeRequestRead = {
  data: ExternalCompanyChangeRequestRead[];
  meta: PaginationMetadata;
};
export type SquashedExternalCompanyUpdate = {
  externalId: string;
  name: string;
  address?: string | null;
  city?: string | null;
  postalCode?: string | null;
  phone?: string | null;
  secondaryPhone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  isCompanyAccount?: boolean;
  externalGroupMemberships?: ExternalGroupMembership[];
  createdAt: Instant;
  committedAt: Instant;
};
export type ExternalCompanyUpdateResponse = {
  name: Decision;
  address: Decision;
  city: Decision;
  postalCode: Decision;
  phone: Decision;
  secondaryPhone: Decision;
  mobile: Decision;
  fax: Decision;
  email: Decision;
  website: Decision;
  logoUrl: Decision;
  guildMemberships: Decision;
  followUpAt?: Instant | null;
};
export type ExternalCompanyDeleteResponse = {
  decision: Decision;
  followUpAt?: Instant | null;
};
export type ExternalCompanyCreateResponse = {
  decision: Decision;
  followUpAt?: Instant | null;
};
export type ExternalCompanyChangeResponse =
  | ({
      type: 'ExternalCompanyUpdateResponse';
    } & ExternalCompanyUpdateResponse)
  | ({
      type: 'ExternalCompanyDeleteResponse';
    } & ExternalCompanyDeleteResponse)
  | ({
      type: 'ExternalCompanyCreateResponse';
    } & ExternalCompanyCreateResponse);
export type ExternalMembershipTypeUpdateRequest = {
  externalId: string;
  name: FieldUpdateRequestString;
};
export type ExternalMembershipTypeUpdateRequestRead = {
  id?: number;
  externalId: string;
  name: FieldUpdateRequestString;
  membershipType?: GroupMembershipType | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalMembershipTypeDeleteRequest = {
  externalId: string;
};
export type ExternalMembershipTypeDeleteRequestRead = {
  id?: number;
  externalId: string;
  membershipType?: GroupMembershipType | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalMembershipTypeCreateRequest = {
  externalId: string;
  name: string;
};
export type ExternalMembershipTypeCreateRequestRead = {
  id?: number;
  externalId: string;
  name: string;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalDocumentCategoryChangeRequest =
  | ({
      type: 'ExternalMembershipTypeUpdateRequest';
    } & ExternalMembershipTypeUpdateRequest)
  | ({
      type: 'ExternalMembershipTypeDeleteRequest';
    } & ExternalMembershipTypeDeleteRequest)
  | ({
      type: 'ExternalMembershipTypeCreateRequest';
    } & ExternalMembershipTypeCreateRequest);
export type ExternalDocumentCategoryChangeRequestRead =
  | ({
      type: 'ExternalMembershipTypeUpdateRequest';
    } & ExternalMembershipTypeUpdateRequestRead)
  | ({
      type: 'ExternalMembershipTypeDeleteRequest';
    } & ExternalMembershipTypeDeleteRequestRead)
  | ({
      type: 'ExternalMembershipTypeCreateRequest';
    } & ExternalMembershipTypeCreateRequestRead);
export type PaginatedResponseExternalDocumentCategoryChangeRequest = {
  data: ExternalDocumentCategoryChangeRequest[];
  meta: PaginationMetadata;
};
export type PaginatedResponseExternalDocumentCategoryChangeRequestRead = {
  data: ExternalDocumentCategoryChangeRequestRead[];
  meta: PaginationMetadata;
};
export type SquashedExternalDocumentCategoryUpdate = {
  externalId: string;
  name: string;
  createdAt: Instant;
  committedAt: Instant;
};
export type ExternalDocumentCategoryChangeResponse = object;
export type SetExternalIdsResult = {
  unresolvedGroups?: string[];
  unresolvedRoles?: string[];
  unresolvedMemberships?: string[];
  unresolvedCategories?: string[];
  unresolvedCompanies?: string[];
  unresolvedUsers?: string[];
};
export type SetExternalIdsRequest = {
  groups?: {
    [key: string]: string;
  };
  roles?: {
    [key: string]: string;
  };
  memberships?: {
    [key: string]: string;
  };
  categories?: {
    [key: string]: string;
  };
  companies?: {
    [key: string]: string;
  };
  users?: {
    [key: string]: string;
  };
};
export type ExternalGuildUpdateRequest = {
  externalId: string;
  name?: FieldUpdateRequestString | null;
};
export type ExternalGuildUpdateRequestRead = {
  id?: number;
  externalId: string;
  name?: FieldUpdateRequestString | null;
  group?: Group | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalGuildDeleteRequest = {
  externalId: string;
};
export type ExternalGuildDeleteRequestRead = {
  id?: number;
  externalId: string;
  group?: Group | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalGuildCreateRequest = {
  externalId: string;
  name: string;
};
export type ExternalGuildCreateRequestRead = {
  id?: number;
  externalId: string;
  name: string;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalGuildChangeRequest =
  | ({
      type: 'ExternalGuildUpdateRequest';
    } & ExternalGuildUpdateRequest)
  | ({
      type: 'ExternalGuildDeleteRequest';
    } & ExternalGuildDeleteRequest)
  | ({
      type: 'ExternalGuildCreateRequest';
    } & ExternalGuildCreateRequest);
export type ExternalGuildChangeRequestRead =
  | ({
      type: 'ExternalGuildUpdateRequest';
    } & ExternalGuildUpdateRequestRead)
  | ({
      type: 'ExternalGuildDeleteRequest';
    } & ExternalGuildDeleteRequestRead)
  | ({
      type: 'ExternalGuildCreateRequest';
    } & ExternalGuildCreateRequestRead);
export type PaginatedResponseExternalGuildChangeRequest = {
  data: ExternalGuildChangeRequest[];
  meta: PaginationMetadata;
};
export type PaginatedResponseExternalGuildChangeRequestRead = {
  data: ExternalGuildChangeRequestRead[];
  meta: PaginationMetadata;
};
export type SquashedExternalGuildUpdate = {
  externalId: string;
  name: string;
  createdAt: Instant;
  committedAt: Instant;
};
export type ExternalGuildChangeResponse = object;
export type ExternalMembershipTypeChangeRequest =
  | ({
      type: 'ExternalMembershipTypeUpdateRequest';
    } & ExternalMembershipTypeUpdateRequest)
  | ({
      type: 'ExternalMembershipTypeDeleteRequest';
    } & ExternalMembershipTypeDeleteRequest)
  | ({
      type: 'ExternalMembershipTypeCreateRequest';
    } & ExternalMembershipTypeCreateRequest);
export type ExternalMembershipTypeChangeRequestRead =
  | ({
      type: 'ExternalMembershipTypeUpdateRequest';
    } & ExternalMembershipTypeUpdateRequestRead)
  | ({
      type: 'ExternalMembershipTypeDeleteRequest';
    } & ExternalMembershipTypeDeleteRequestRead)
  | ({
      type: 'ExternalMembershipTypeCreateRequest';
    } & ExternalMembershipTypeCreateRequestRead);
export type PaginatedResponseExternalMembershipTypeChangeRequest = {
  data: ExternalMembershipTypeChangeRequest[];
  meta: PaginationMetadata;
};
export type PaginatedResponseExternalMembershipTypeChangeRequestRead = {
  data: ExternalMembershipTypeChangeRequestRead[];
  meta: PaginationMetadata;
};
export type SquashedExternalMembershipTypeUpdate = {
  externalId: string;
  name: string;
  createdAt: Instant;
  committedAt: Instant;
};
export type ExternalMembershipTypeChangeResponse = object;
export type ExternalRoleUpdateRequest = {
  externalId: string;
  name: FieldUpdateRequestString;
};
export type Role = {
  id: Id;
  name: string;
};
export type ExternalRoleUpdateRequestRead = {
  id?: number;
  externalId: string;
  name: FieldUpdateRequestString;
  role?: Role | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalRoleDeleteRequest = {
  externalId: string;
};
export type ExternalRoleDeleteRequestRead = {
  id?: number;
  externalId: string;
  role?: Role | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalRoleCreateRequest = {
  externalId: string;
  name: string;
};
export type ExternalRoleCreateRequestRead = {
  id?: number;
  externalId: string;
  name: string;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalRoleChangeRequest =
  | ({
      type: 'ExternalRoleUpdateRequest';
    } & ExternalRoleUpdateRequest)
  | ({
      type: 'ExternalRoleDeleteRequest';
    } & ExternalRoleDeleteRequest)
  | ({
      type: 'ExternalRoleCreateRequest';
    } & ExternalRoleCreateRequest);
export type ExternalRoleChangeRequestRead =
  | ({
      type: 'ExternalRoleUpdateRequest';
    } & ExternalRoleUpdateRequestRead)
  | ({
      type: 'ExternalRoleDeleteRequest';
    } & ExternalRoleDeleteRequestRead)
  | ({
      type: 'ExternalRoleCreateRequest';
    } & ExternalRoleCreateRequestRead);
export type PaginatedResponseExternalRoleChangeRequest = {
  data: ExternalRoleChangeRequest[];
  meta: PaginationMetadata;
};
export type PaginatedResponseExternalRoleChangeRequestRead = {
  data: ExternalRoleChangeRequestRead[];
  meta: PaginationMetadata;
};
export type SquashedExternalRoleUpdate = {
  externalId: string;
  name: string;
  createdAt: Instant;
  committedAt: Instant;
};
export type ExternalRoleChangeResponse = object;
export type NullableFieldUpdateRequestString = {
  old: string | null;
  new: string | null;
  decision?: Decision;
};
export type NullableFieldUpdateRequestGender = {
  old: Gender | null;
  new: Gender | null;
  decision?: Decision;
};
export type ExternalGroupRoles = {
  groupId: string;
  roleId: string;
  location?: string | null;
};
export type FieldUpdateRequestListExternalGroupRoles = {
  old: ExternalGroupRoles[] | null;
  new: ExternalGroupRoles[];
  decision?: Decision;
};
export type ExternalCompanyCategoryAccess = {
  companyId: string;
  categoryId: string;
  location?: string | null;
};
export type FieldUpdateRequestListExternalCompanyCategoryAccess = {
  old: ExternalCompanyCategoryAccess[] | null;
  new: ExternalCompanyCategoryAccess[];
  decision?: Decision;
};
export type FieldUpdateRequestListString = {
  old: string[] | null;
  new: string[];
  decision?: Decision;
};
export type ExternalAttribute = {
  name: string;
  value: JsonElement;
};
export type FieldUpdateRequestListExternalAttribute = {
  old: ExternalAttribute[] | null;
  new: ExternalAttribute[];
  decision?: Decision;
};
export type ExternalUserUpdateRequest = {
  externalId: string;
  firstName?: NullableFieldUpdateRequestString | null;
  lastName?: NullableFieldUpdateRequestString | null;
  gender?: NullableFieldUpdateRequestGender | null;
  email?: NullableFieldUpdateRequestString | null;
  phone?: NullableFieldUpdateRequestString | null;
  mobile?: NullableFieldUpdateRequestString | null;
  groupRoles?: FieldUpdateRequestListExternalGroupRoles | null;
  companyAccount?: FieldUpdateRequestBoolean | null;
  external?: FieldUpdateRequestBoolean | null;
  companyCategoryAccess?: FieldUpdateRequestListExternalCompanyCategoryAccess | null;
  companyIds?: FieldUpdateRequestListString | null;
  companyId?: FieldUpdateRequestString | null;
  attributes?: FieldUpdateRequestListExternalAttribute | null;
};
export type ExternalUserUpdateRequestRead = {
  id: number;
  externalId: string;
  user?: EmailUser | null;
  firstName?: NullableFieldUpdateRequestString | null;
  lastName?: NullableFieldUpdateRequestString | null;
  gender?: NullableFieldUpdateRequestGender | null;
  email?: NullableFieldUpdateRequestString | null;
  phone?: NullableFieldUpdateRequestString | null;
  mobile?: NullableFieldUpdateRequestString | null;
  groupRoles?: FieldUpdateRequestListExternalGroupRoles | null;
  companyAccount?: FieldUpdateRequestBoolean | null;
  external?: FieldUpdateRequestBoolean | null;
  companyCategoryAccess?: FieldUpdateRequestListExternalCompanyCategoryAccess | null;
  companyIds?: FieldUpdateRequestListString | null;
  companyId?: FieldUpdateRequestString | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
  attributes?: FieldUpdateRequestListExternalAttribute | null;
};
export type UserDeleteMode = 'SOFT' | 'HARD';
export type ExternalUserDeleteRequest = {
  externalId: string;
  deleteMode?: UserDeleteMode;
};
export type ExternalUserDeleteRequestRead = {
  id?: number;
  externalId: string;
  user?: EmailUser | null;
  deleteMode?: UserDeleteMode;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalUserCreateRequest = {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Gender | null;
  phone?: string | null;
  mobile?: string | null;
  password?: string | null;
  companyAccount?: boolean;
  external?: boolean;
  externalId: string;
  externalCompanyIds?: string[];
  externalCompanyId?: string | null;
  externalGroupRoles?: ExternalGroupRoles[] | null;
  externalCompanyCategoryAccess?: ExternalCompanyCategoryAccess[] | null;
  attributes?: ExternalAttribute[] | null;
};
export type ExternalUserCreateRequestRead = {
  id?: number;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  gender?: Gender | null;
  phone?: string | null;
  mobile?: string | null;
  password?: string | null;
  companyAccount?: boolean;
  external?: boolean;
  externalId: string;
  externalCompanyIds?: string[];
  externalCompanyId?: string | null;
  externalGroupRoles?: ExternalGroupRoles[] | null;
  externalCompanyCategoryAccess?: ExternalCompanyCategoryAccess[] | null;
  attributes?: ExternalAttribute[] | null;
  createdAt?: Instant | null;
  committedAt?: Instant | null;
};
export type ExternalUserChangeRequest =
  | ({
      type: 'ExternalUserUpdateRequest';
    } & ExternalUserUpdateRequest)
  | ({
      type: 'ExternalUserDeleteRequest';
    } & ExternalUserDeleteRequest)
  | ({
      type: 'ExternalUserCreateRequest';
    } & ExternalUserCreateRequest);
export type ExternalUserChangeRequestRead =
  | ({
      type: 'ExternalUserUpdateRequest';
    } & ExternalUserUpdateRequestRead)
  | ({
      type: 'ExternalUserDeleteRequest';
    } & ExternalUserDeleteRequestRead)
  | ({
      type: 'ExternalUserCreateRequest';
    } & ExternalUserCreateRequestRead);
export type PaginatedResponseExternalUserChangeRequest = {
  data: ExternalUserChangeRequest[];
  meta: PaginationMetadata;
};
export type PaginatedResponseExternalUserChangeRequestRead = {
  data: ExternalUserChangeRequestRead[];
  meta: PaginationMetadata;
};
export type ExternalIdWithEmails = {
  externalId: string;
  email: string | null;
  emailFromLastImport: string | null;
};
export type ExternalUserUpdateHash = {
  externalId: string;
  sha256: string;
};
export type SyncChange = {
  field: string;
  current: string | null;
  expected: string | null;
  diff?: string | null;
};
export type SyncResult = {
  externalId: string;
  userId: string;
  changes: SyncChange[];
  applied: boolean;
};
export type ExternalUserChangeResponse = object;
export type GroupMembership = {
  id: Id;
  name: string;
};
export type GroupMembershipCreateDto = {
  name: string;
};
export type GroupMembershipUpdateDto = {
  /** Optional property name for update */
  name?: string | null;
  empty?: boolean;
};
export type PolicyRule = {
  id: number;
  name: string;
  rule: string;
};
export type Policy = {
  id?: number;
  name: string;
  description: string | null;
  action: string;
  resourceType: ResourceType;
  rule: PolicyRule;
  subjectAttributeId: number;
  objectAttributeId?: number | null;
  effect?: Effect;
};
export type PaginatedResponsePolicy = {
  data: Policy[];
  meta: PaginationMetadata;
};
export type PolicySortKey = 'NAME' | 'ACTION' | 'RESOURCE_TYPE';
export type CreatePolicy = {
  name: string;
  description: string | null;
  action: string;
  resourceType: ResourceType;
  ruleName: string;
  subjectAttributeName: string;
  objectAttributeName: string | null;
  effect?: Effect;
};
export type UpdatePolicy = {
  name?: string | null;
  description?: string | null;
  action?: string | null;
  resourceType?: string | null;
  ruleId?: number | null;
};
export type PostSummary = {
  id: Id;
  title: string;
  bodyText: string;
  bodyHtml: string;
  bodyQuill: string;
  author: EmailUser;
  category: DocumentCategory;
  createdAt: LocalDateTime;
  numComments: number;
  numViews: number;
  numVotes: number;
  numAttachments: number;
  hasEvent: boolean;
  publishedAt?: LocalDateTime | null;
  imageUrl?: string | null;
  iLiked?: boolean;
  parentPostId?: Id | null;
  parentPostType?: PostType | null;
  parentPublishedAt?: LocalDateTime | null;
  publishDelayedAt?: Instant | null;
  tags?: Tag[];
  teaser?: string | null;
  hasSurvey?: boolean;
  type?: PostType;
  feedText?: string | null;
  hasChildren?: boolean;
  organizationName?: string | null;
  editorType?: EditorType;
  digestImageUrl?: string | null;
  isPublic?: boolean;
  ILiked?: boolean;
};
export type PaginatedResponsePostSummary = {
  data: PostSummary[];
  meta: PaginationMetadata;
};
export type PostStatus = 'DRAFT' | 'PUBLISHED' | 'PLANNED';
export type PostSection = {
  id: string;
  content: string;
};
export type CreatePost = {
  title: string;
  bodyText: string;
  bodyHtml: string;
  bodyQuill: string;
  eventId?: ResourceId | null;
  surveyId?: ResourceId | null;
  attachments?: ResourceId[];
  recipients: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  };
  imageUrl?: string | null;
  emailTemplateId?: ResourceId | null;
  emailSignatureId?: ResourceId | null;
  parentId?: ResourceId | null;
  tagIds?: ResourceId[];
  publishDelayedAt?: Instant | null;
  teaser?: string | null;
  type?: PostType;
  feedText?: string | null;
  editorType?: EditorType;
  sections?: PostSection[] | null;
  digestImageUrl?: string | null;
};
export type ResourceIdArray = ResourceId[];
export type UpdatePost = {
  title?: string | null;
  bodyText?: string | null;
  bodyHtml?: string | null;
  bodyQuill?: string | null;
  categoryId?: number | object | null;
  eventId?: NullableResourceId;
  recipients?: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  } | null;
  emailTemplateId?: NullableResourceId;
  imageUrl?: string | null;
  attachments?: ResourceIdArray;
  emailSignatureId?: NullableResourceId;
  tagIds?: ResourceId[] | null;
  /** ISO-8601 timestamp. Omit to leave the schedule unchanged; send null to clear it. */
  publishDelayedAt?: string | null;
  teaser?: string | null;
  surveyId?: NullableResourceId;
  feedText?: string | null;
  sections?: PostSection[] | null;
  digestImageUrl?: string | null;
  isPublic?: boolean | null;
};
export type PostSearchRecord = {
  id: ResourceId;
  title: string;
  teaser: string;
  feedText: string;
  content: string;
  sections: PostSection[];
  createdAt: Instant;
};
export type PaginatedResponsePostSearchRecord = {
  data: PostSearchRecord[];
  meta: PaginationMetadata;
};
export type PostAttachment = {
  id: number;
  name: string;
  url: string;
  icon: string;
};
export type PaginatedResponsePostAttachment = {
  data: PostAttachment[];
  meta: PaginationMetadata;
};
export type PostNameAndId = {
  id: Id;
  name: string;
  parentId?: Id | null;
};
export type PostComment = {
  id: number;
  postId: number;
  body: string;
  parentId: number | null;
  author: EmailUser;
  createdAt: LocalDateTime;
  deletedAt?: LocalDateTime | null;
  iLiked?: boolean;
  ILiked?: boolean;
};
export type PaginatedResponsePostComment = {
  data: PostComment[];
  meta: PaginationMetadata;
};
export type CreateComment = {
  body: string;
  postId: number;
  parentId?: number | null;
};
export type NewsletterArticle = {
  id?: number;
  postId: Id;
  sortIndex: number;
  summary: NewsletterArticleSummary;
};
export type Newsletter = {
  postId: Id;
  summary: NewsletterArticleSummary;
  articles: NewsletterArticle[];
};
export type CreateNewsletterArticle = {
  postId: ResourceId;
  sortIndex: number;
};
export type UpdateNewsletterArticle = {
  sortIndex?: number | null;
};
export type NotificationHistoryEntry = {
  id: number;
  notificationId: number;
  messageId: string;
  eventType: string;
  createdAt: Instant;
  sendingIp?: string | null;
  errorCode?: string | null;
  errorDetail?: string | null;
  nextAttemptAt?: Instant | null;
  requireDifferentIp?: boolean | null;
  senderId?: string | null;
  requireDifferentSender?: boolean | null;
  mailgunEventId?: string | null;
  source?: string | null;
};
export type PostNotificationError = {
  type: string;
  message: string;
  description?: string | null;
  createdAt: LocalDateTime;
  postNotificationId?: number | null;
};
export type PostNotification = {
  id?: number;
  userId?: number;
  type: string;
  queuedAt: LocalDateTime;
  sentAt?: LocalDateTime | null;
  receivedAt?: LocalDateTime | null;
  readAt?: LocalDateTime | null;
  errors?: PostNotificationError[];
  failedAt?: LocalDateTime | null;
  sendError?: string | null;
};
export type NotificationSettings = {
  tagId?: number | null;
  email: boolean;
  cloudMessage: boolean;
  fax: boolean;
  postal: boolean;
};
export type PostRecipient = {
  user: EmailUser;
  notifications?: PostNotification[];
  notificationSettings?: NotificationSettings | null;
  policies?: string[];
};
export type PaginatedResponsePostRecipient = {
  data: PostRecipient[];
  meta: PaginationMetadata;
};
export type UserEmailFilter =
  'ALL' | 'HAS_EMAIL' | 'HAS_NO_EMAIL' | 'EMAIL_BLOCKED';
export type PostRecipientsSummary = {
  type?: string;
  numSent: number;
  numReceived: number;
  numRead?: number | null;
};
export type PostRecipientSummaries = {
  total: PostRecipientsSummary | null;
  email: PostRecipientsSummary | null;
  cloudMessage: PostRecipientsSummary | null;
};
export type NotificationStatus =
  | 'QUEUED'
  | 'PENDING'
  | 'ACCEPTED'
  | 'SENT'
  | 'DELIVERED'
  | 'FAILED'
  | 'DEFERRED'
  | 'DELAYED';
export type UndeliveredNotification = {
  id: number;
  batchId: string;
  messageId: string;
  postId: Id | null;
  userId: Id;
  recipientDomain: string | null;
  sendStatus: NotificationStatus | null;
  sendError: string | null;
  nextAttemptAt: Instant | null;
  attempts: number;
  lastSendingIp: string | null;
  requireDifferentIp: boolean;
  lastSenderId: string | null;
  requireDifferentSender: boolean;
  cooldownUntil: Instant | null;
  cooldownReasonCode: string | null;
  cooldownReasonDetail: string | null;
  effectiveNextTry: Instant | null;
};
export type Vote = {
  vote: boolean;
};
export type PaginatedResponseRole = {
  data: Role[];
  meta: PaginationMetadata;
};
export type CreateRole = {
  name: string;
};
export type SchedulerTaskStatus =
  'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
export type SchedulerTask = {
  id?: Id;
  type: string;
  status?: SchedulerTaskStatus;
  payload?: string | null;
  result?: string | null;
  errorMessage?: string | null;
  claimedBy?: string | null;
  heartbeatAt?: Instant | null;
  startedAt?: Instant | null;
  completedAt?: Instant | null;
  createdAt?: Instant;
};
export type ProgressStatus = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';
export type ProgressStep = {
  key: string;
  label: string;
  current: number;
  max?: number | null;
  unit?: string;
  status?: ProgressStatus;
  percent?: number | null;
};
export type TaskProgress = {
  percent?: number | null;
  label?: string | null;
  etaSeconds?: number | null;
  steps?: ProgressStep[];
};
export type SchedulerTaskView = {
  task: SchedulerTask;
  progress?: TaskProgress | null;
};
export type BatchTaskRunRequest = {
  tenantId: string;
  taskId: ResourceId;
  type: string;
};
export type EmailSendRequest = {
  id: number;
  postId: ResourceId | null;
  subject: string;
  bodyText: string;
  bodyHtml: string;
  fromEmail: string;
  fromDomain: string;
  batchId: string;
  completedAt?: Instant | null;
  associationId?: AssociationIdFull | null;
  notificationIds?: number[] | null;
  fromIp?: string | null;
  senderId?: string | null;
};
export type PostBuildCacheRequest = {
  id?: ResourceId | null;
  action?: Action;
  buildTopFeed?: boolean;
};
export type HttpMethod =
  | 'HTTP_METHOD_UNSPECIFIED'
  | 'POST'
  | 'GET'
  | 'HEAD'
  | 'PUT'
  | 'DELETE'
  | 'PATCH'
  | 'OPTIONS'
  | 'UNRECOGNIZED';
export type HttpJob = {
  name?: string;
  path?: string;
  method?: HttpMethod;
  body?: string;
  scheduleTime?: Instant | null;
  headers?: {
    [key: string]: string;
  };
  queryParams?: {
    [key: string]: string;
  };
};
export type CreateSurvey = {
  title?: string | null;
  json: string;
  responseDeadline: Instant;
  isTemplate?: boolean;
  description?: string | null;
  recipients?: Recipients;
  privacy?: SurveyPrivacy;
};
export type CreateOrUpdateSurveyResponseWithToken = {
  json: string;
  publish?: boolean;
  token: string;
  makeIdentifiable?: boolean;
};
export type PaginatedResponseSurvey = {
  data: Survey[];
  meta: PaginationMetadata;
};
export type PaginatedResponseSurveyRead = {
  data: SurveyRead[];
  meta: PaginationMetadata;
};
export type UpdateSurvey = {
  title?: string | null;
  json?: string | null;
  responseDeadline?: string | null;
  isTemplate?: boolean | null;
  description?: string | null;
  privacy?: ('ANONYMOUS' | 'IDENTIFIED') | ('ANONYMOUS' | 'IDENTIFIED');
  recipients?: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  } | null;
};
export type SurveyResponseList = {
  items: SurveyResponse[];
  totalRecipients: number;
};
export type SurveyParticipant = {
  user: EmailUser;
  response?: SurveyResponse | null;
};
export type PaginatedResponseSurveyParticipant = {
  data: SurveyParticipant[];
  meta: PaginationMetadata;
};
export type CreateSurveyResponse = {
  json: string;
  publish?: boolean;
  userId?: ResourceId | null;
  privacy?: SurveyPrivacy | null;
};
export type PaginatedResponseSurveyResponse = {
  data: SurveyResponse[];
  meta: PaginationMetadata;
};
export type TextBlock = {
  id?: Id;
  key: string;
  locale: string;
  default: string;
  male?: string | null;
  female?: string | null;
  other?: string | null;
  company?: string | null;
};
export type PaginatedResponseTextBlock = {
  data: TextBlock[];
  meta: PaginationMetadata;
};
export type TextBlockUpdateDto = {
  /** Optional property default for update */
  default?: string | null;
  /** Optional property male for update */
  male?: string | null;
  /** Optional property female for update */
  female?: string | null;
  /** Optional property other for update */
  other?: string | null;
  /** Optional property company for update */
  company?: string | null;
  empty?: boolean;
};
export type GenerateTextResponse = {
  text: string;
};
export type GenerateText = {
  text: string;
};
export type AppliedAttributeValues = {
  accessAttributeValueIds?: number[];
  accessAttributes?: CreateAttributeValueByName[];
};
export type CreateUser = {
  gender?: Gender;
  firstName: string;
  lastName: string;
  email: string | null;
  password?: string | null;
  phone?: string | null;
  mobile?: string | null;
  appliedAttributeValues?: AppliedAttributeValues;
  notificationSettings?: NotificationSettings;
  isExternal?: boolean;
  isCompanyUser?: boolean;
  externalGroupRoles?: ExternalGroupRoles[];
  companyIds?: ResourceId[];
  identityId?: string | null;
};
export type UserTagNotificationSetting = {
  tagId: Id;
  name: string;
  color: string;
  mandatoryNotification: boolean;
  notifyEmail: boolean;
  notifyCloudMessage: boolean;
  notifyFax: boolean;
  notifyPostal: boolean;
};
export type UserDetails = {
  id: Id;
  gender: Gender;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone?: string | null;
  mobile?: string | null;
  companies: CompanySummary[] | null;
  appliedAccessAttributes: AccessAttributeValueWithAttribute[];
  defaultNotificationSettings?: NotificationSettings;
  tagNotificationSettings?: UserTagNotificationSetting[];
  isExternal?: boolean;
  chatToken?: string | null;
  isCompanyUser?: boolean;
};
export type BlockedRecipientDto = {
  userId: Id;
  email: string;
  reasonCode?: string | null;
  reasonDetail?: string | null;
  source?: string | null;
  createdAt?: Instant | null;
};
export type PaginatedResponseBlockedRecipientDto = {
  data: BlockedRecipientDto[];
  meta: PaginationMetadata;
};
export type UpdateUser = {
  email?: string | null;
  gender?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  mobile?: string | null;
  appliedAttributeValues?: {
    accessAttributeValueIds?: number[];
    accessAttributes?: CreateAttributeValueByName[];
  } | null;
  appliedAttributeValuesUpdate?: {
    idsToAdd?: number[];
    idsToRemove?: number[];
    empty?: boolean;
    notEmpty?: boolean;
    noop?: boolean;
  } | null;
  notificationSettings?: NotificationSettings;
  isCompanyUser?: boolean | null;
  isExternal?: boolean | null;
  companyIds?: ResourceId[] | null;
  empty?: boolean;
};
export type ChatToken = {
  token: string;
};
export type SetCloudMessageToken = {
  token: string;
};
export type ResetPasswordType = 'RESET' | 'NEW_USER';
export type ResetPasswordRequest = {
  continuePath?: string | null;
  type?: ResetPasswordType;
  forceReprovision?: boolean;
};
export type UserTagNotificationUpdate = {
  tagId: ResourceId;
  notifyEmail: boolean;
  notifyCloudMessage: boolean;
  notifyFax: boolean;
  notifyPostal: boolean;
};
export type UserTagNotificationSettings = {
  userId: ResourceId;
  notificationSettings: UserTagNotificationSetting[];
};
export type RecoverPasswordRequest = {
  email: string;
  tenantId: string;
  continuePath?: string | null;
  type?: ResetPasswordType;
};
export type SetPasswordWithTokenRequest = {
  token: string;
  password: string;
};
export type SignInWithEmailLink = {
  tenantId: string;
  email: string;
  continuePath?: string | null;
};
export type TenantInfo = {
  name: string;
  tenantId: string;
  domain: string;
};
export type UnsubscribePreview = {
  tag?: string | null;
  tagName?: string | null;
  alreadyUnsubscribed?: boolean;
};
export type UnsubscribeTopic = {
  tag: string;
  name: string;
  color: string;
  mandatory: boolean;
  emailEnabled: boolean;
};
export type UnsubscribePreferences = {
  tag: string | null;
  tagName: string | null;
  allEmail: boolean;
  emailEnabled: boolean;
  topics: UnsubscribeTopic[];
  canManage: boolean;
};
export type SetEmailEnabledRequest = {
  emailEnabled: boolean;
};
export type Version = {
  version: string;
  tag: string;
  head: string;
};
export const {
  useGetApiAccessAttributesQuery,
  usePostApiAccessAttributesMutation,
  usePostApiAccessAttributesValuesMutation,
  useGetApiAccessAttributesByIdQuery,
  useGetApiAccessAttributesByIdValuesQuery,
  useGetApiAccessAttributesByIdValuesAndValueIdQuery,
  useDeleteApiAccessAttributesByIdValuesAndValueIdMutation,
  useGetApiApiKeysQuery,
  usePostApiApiKeysMutation,
  useDeleteApiApiKeysByIdMutation,
  usePostApiAssociationMutation,
  useGetApiAssociationAdminAccessAttributeValueQuery,
  usePostApiAssociationConfigMutation,
  useGetApiAssociationConfigQuery,
  useGetApiAssociationInfoQuery,
  useGetApiAuthLoginQuery,
  useGetApiAuthLogoutQuery,
  useGetApiAuthSessionQuery,
  useGetApiChatDevicesQuery,
  useGetApiChatTokenQuery,
  useGetApiCompaniesQuery,
  usePostApiCompaniesMutation,
  useGetApiCompaniesByExternalIdByExternalIdQuery,
  useGetApiCompaniesMyQuery,
  usePatchApiCompaniesByIdMutation,
  useGetApiCompaniesByIdQuery,
  useDeleteApiCompaniesByIdMutation,
  useGetApiCompaniesByIdUsersQuery,
  usePostApiControlPlaneAssociationMutation,
  usePostApiControlPlaneAssociationResetByTenantIdMutation,
  usePostApiControlPlaneAssociationSetTenantConfigByTenantIdMutation,
  usePostApiControlPlaneAssociationSyncIpByTenantIdMutation,
  useGetApiControlPlaneAssociationsQuery,
  usePostApiControlPlaneAuditByTenantIdMutation,
  useGetApiControlPlaneBillableMembershipsByTenantIdQuery,
  usePutApiControlPlaneBillableMembershipsByTenantIdAndMembershipIdMutation,
  useGetApiControlPlaneBillingMetricsByTenantIdQuery,
  usePostApiControlPlaneDistrictCodeByTenantIdMutation,
  usePostApiControlPlaneDomainSyncMutation,
  usePostApiControlPlaneDomainSyncByTenantIdMutation,
  usePostApiControlPlaneDomainVerifyByTenantIdMutation,
  useGetApiControlPlaneDomainsByTenantIdQuery,
  useGetApiControlPlaneEmailAlertsQuery,
  usePostApiControlPlaneEmailAlertsGenerateMutation,
  usePostApiControlPlaneEmailAlertsByIdResolveMutation,
  useGetApiControlPlaneEmailBouncedQuery,
  useDeleteApiControlPlaneEmailBouncedByTenantIdAndUserIdMutation,
  useGetApiControlPlaneEmailDeliveryRatesQuery,
  useGetApiControlPlaneEmailFailedQuery,
  useGetApiControlPlaneEmailProvidersQuery,
  useGetApiControlPlaneEmailSendersQuery,
  useGetApiControlPlaneInvoicesQuery,
  useGetApiControlPlaneInvoicesCreateQuery,
  useDeleteApiControlPlaneLexofficeAssignmentByTenantIdMutation,
  useGetApiControlPlaneLexofficeAssignmentByTenantIdQuery,
  usePutApiControlPlaneLexofficeAssignmentByTenantIdMutation,
  useGetApiControlPlaneLexofficeContactsQuery,
  useGetApiControlPlaneMaintenanceQuery,
  usePostApiControlPlaneMaintenanceMutation,
  useDeleteApiControlPlaneMaintenanceExpiredMutation,
  usePutApiControlPlaneMaintenanceByIdMutation,
  useDeleteApiControlPlaneMaintenanceByIdMutation,
  useGetApiControlPlaneMappingsQuery,
  usePostApiControlPlaneMappingsMutation,
  useDeleteApiControlPlaneMappingsByIdMutation,
  useGetApiControlPlaneMeQuery,
  usePostApiControlPlanePaymentConditionsValidateMutation,
  usePutApiControlPlanePaymentConditionsByTenantIdMutation,
  useGetApiControlPlanePaymentConditionsByTenantIdQuery,
  useDeleteApiControlPlanePaymentConditionsByTenantIdMutation,
  usePostApiControlPlanePaymentConditionsByTenantIdPreviewMutation,
  usePostApiControlPlanePolicyAccessTestByTenantIdMutation,
  usePostApiControlPlanePolicyCacheByTenantIdMutation,
  useGetApiControlPlaneStatisticsQuery,
  useGetApiControlPlaneStatisticsByTenantIdQuery,
  usePostApiControlPlaneTemplatesByTenantIdLoadDefaultsMutation,
  usePostApiControlPlaneTemplatesByTenantIdResetAndTypeMutation,
  usePostApiControlPlaneTextBlocksByTenantIdLoadDefaultsMutation,
  usePostApiControlPlaneUserSyncIpByTenantIdMutation,
  useGetApiControlPlaneUsersByTenantIdQuery,
  usePostApiControlPlaneUsersByTenantIdDedupeMutation,
  useGetApiControlPlaneUsersByTenantIdDuplicatesQuery,
  useGetApiDistrictCodeQuery,
  useGetApiDistrictCodeByPostalCodeByPostalCodeQuery,
  useGetApiDocumentCategoriesQuery,
  usePostApiDocumentCategoriesMutation,
  useGetApiDocumentCategoriesByExternalIdByExternalIdQuery,
  usePatchApiDocumentCategoriesByIdMutation,
  useGetApiDocumentCategoriesByIdQuery,
  useDeleteApiDocumentCategoriesByIdMutation,
  usePostApiDocumentFilesMoveMutation,
  usePutApiDocumentFilesByIdMutation,
  useDeleteApiDocumentFilesByIdMutation,
  useGetApiDocumentFilesByIdAccessQuery,
  useGetApiDocumentFilesByIdDownloadMutation,
  useGetApiDocumentFilesByIdReplaceMutation,
  useGetApiDocumentFoldersQuery,
  usePostApiDocumentFoldersMutation,
  usePostApiDocumentFoldersMoveMutation,
  usePutApiDocumentFoldersByIdMutation,
  useGetApiDocumentFoldersByIdQuery,
  useDeleteApiDocumentFoldersByIdMutation,
  useGetApiDocumentFoldersByIdAccessQuery,
  useGetApiDocumentFoldersByIdContentsQuery,
  usePostApiDocumentFoldersByIdFilesMutation,
  usePostApiDocumentFoldersByIdFoldersMutation,
  useGetApiDocumentFoldersByIdParentsQuery,
  usePostApiEmailRenderCustomQuery,
  usePostApiEmailRenderCustomPreviewMutation,
  useGetApiEmailRenderPostByPostIdQuery,
  useGetApiEmailSignatureQuery,
  usePostApiEmailSignatureMutation,
  usePatchApiEmailSignatureByIdMutation,
  useGetApiEmailSignatureByIdQuery,
  useDeleteApiEmailSignatureByIdMutation,
  useGetApiEmailTemplateQuery,
  usePostApiEmailTemplateMutation,
  usePatchApiEmailTemplateByIdMutation,
  useGetApiEmailTemplateByIdQuery,
  useDeleteApiEmailTemplateByIdMutation,
  useGetApiEmailTemplatesQuery,
  usePostApiEmailTemplatesMutation,
  usePostApiEmailTemplatesCopyFromDefaultMutation,
  useGetApiEmailTemplatesVariablesQuery,
  usePatchApiEmailTemplatesByIdMutation,
  useGetApiEmailTemplatesByIdQuery,
  usePutApiEmailTemplatesByIdStatusMutation,
  usePutApiEmailConfigMutation,
  useGetApiEmailConfigQuery,
  useGetApiEmailConfigDomainByDomainIdQuery,
  useDeleteApiEmailConfigByDomainIdAndSenderIdMutation,
  useGetApiEventsQuery,
  usePostApiEventsMutation,
  usePostApiEventsAttendMutation,
  useGetApiEventsAttendeeStatusAttributeQuery,
  usePatchApiEventsByIdMutation,
  useGetApiEventsByIdQuery,
  useDeleteApiEventsByIdMutation,
  useGetApiEventsByIdAllAttendeesQuery,
  useGetApiEventsByIdAttendeesQuery,
  usePostApiEventsByIdAttendeesMutation,
  useGetApiEventsByIdIcsQuery,
  usePostApiEventsByIdPublishMutation,
  useGetApiGroupQuery,
  usePostApiGroupMutation,
  useGetApiGroupByExternalIdByIdQuery,
  usePatchApiGroupByIdMutation,
  useGetApiGroupByIdQuery,
  useDeleteApiGroupByIdMutation,
  useGetApiGroupByIdMembersQuery,
  usePostApiImagesMutation,
  useGetApiLandingNewsletterByTokenQuery,
  useGetApiLandingPostByTokenQuery,
  useGetApiListsQuery,
  usePostApiListsMutation,
  usePatchApiListsByIdMutation,
  useGetApiListsByIdQuery,
  useDeleteApiListsByIdMutation,
  useGetApiListsByIdUsersQuery,
  useGetApiMaintenanceQuery,
  usePostApiMasterDataImportBatchImportMutation,
  usePostApiMasterDataImportBatchImportAsyncMutation,
  usePostApiMasterDataImportBatchImportExecuteMutation,
  usePostApiMasterDataImportBatchImportExecuteAsyncMutation,
  usePostApiMasterDataImportBatchImportPlanMutation,
  usePostApiMasterDataImportBatchImportPlanAsyncMutation,
  useGetApiMasterDataImportCompaniesQuery,
  usePostApiMasterDataImportCompaniesMutation,
  useGetApiMasterDataImportCompaniesByExternalIdByExternalIdQuery,
  useGetApiMasterDataImportCompaniesExternalIdsQuery,
  useGetApiMasterDataImportCompaniesSquashedByExternalIdQuery,
  usePostApiMasterDataImportCompaniesByIdMutation,
  useGetApiMasterDataImportCompaniesByIdQuery,
  useGetApiMasterDataImportDocumentCategoriesQuery,
  usePostApiMasterDataImportDocumentCategoriesMutation,
  useGetApiMasterDataImportDocumentCategoriesByExternalIdByExternalIdQuery,
  useGetApiMasterDataImportDocumentCategoriesExternalIdsQuery,
  useGetApiMasterDataImportDocumentCategoriesSquashedByExternalIdQuery,
  usePostApiMasterDataImportDocumentCategoriesByIdMutation,
  useGetApiMasterDataImportDocumentCategoriesByIdQuery,
  useGetApiMasterDataImportExportQuery,
  usePostApiMasterDataImportExternalIdsMutation,
  useGetApiMasterDataImportGuildsQuery,
  usePostApiMasterDataImportGuildsMutation,
  useGetApiMasterDataImportGuildsExternalIdsQuery,
  useGetApiMasterDataImportGuildsSquashedByExternalIdQuery,
  usePostApiMasterDataImportGuildsByIdMutation,
  useGetApiMasterDataImportGuildsByIdQuery,
  useGetApiMasterDataImportMembershipTypesQuery,
  usePostApiMasterDataImportMembershipTypesMutation,
  useGetApiMasterDataImportMembershipTypesByExternalIdByExternalIdQuery,
  useGetApiMasterDataImportMembershipTypesExternalIdsQuery,
  useGetApiMasterDataImportMembershipTypesSquashedByExternalIdQuery,
  usePostApiMasterDataImportMembershipTypesByIdMutation,
  useGetApiMasterDataImportMembershipTypesByIdQuery,
  useGetApiMasterDataImportRolesQuery,
  usePostApiMasterDataImportRolesMutation,
  useGetApiMasterDataImportRolesByExternalIdByExternalIdQuery,
  useGetApiMasterDataImportRolesExternalIdsQuery,
  useGetApiMasterDataImportRolesSquashedByExternalIdQuery,
  usePostApiMasterDataImportRolesByIdMutation,
  useGetApiMasterDataImportRolesByIdQuery,
  useGetApiMasterDataImportUsersQuery,
  usePostApiMasterDataImportUsersMutation,
  useGetApiMasterDataImportUsersByExternalIdByExternalIdQuery,
  useGetApiMasterDataImportUsersExternalIdsQuery,
  useGetApiMasterDataImportUsersExternalIdsWithEmailsQuery,
  useGetApiMasterDataImportUsersExternalIdsRebuildQuery,
  useGetApiMasterDataImportUsersHashesQuery,
  usePostApiMasterDataImportUsersLatestMutation,
  usePostApiMasterDataImportUsersSyncAllToSquashedMutation,
  usePostApiMasterDataImportUsersSyncByIdMutation,
  usePostApiMasterDataImportUsersByIdMutation,
  useGetApiMasterDataImportUsersByIdQuery,
  usePostApiMasterDataImportUsersByUserIdSyncToSquashedMutation,
  useGetApiMembershipTypeQuery,
  usePostApiMembershipTypeMutation,
  useGetApiMembershipTypeAllQuery,
  useGetApiMembershipTypeByExternalIdByExternalIdQuery,
  usePatchApiMembershipTypeByIdMutation,
  useGetApiMembershipTypeByIdQuery,
  useDeleteApiMembershipTypeByIdMutation,
  useGetApiOidcCallbackQuery,
  useGetApiOidcLoginQuery,
  useGetApiOidcLogoutQuery,
  useGetApiPolicyQuery,
  usePostApiPolicyMutation,
  usePatchApiPolicyByIdMutation,
  useGetApiPolicyByIdQuery,
  useDeleteApiPolicyByIdMutation,
  useGetApiPostsQuery,
  usePostApiPostsMutation,
  useGetApiPostsDraftsQuery,
  useGetApiPostsDraftsRootQuery,
  usePatchApiPostsDraftsByIdMutation,
  useGetApiPostsDraftsByIdQuery,
  useGetApiPostsPlannedQuery,
  useGetApiPostsPlannedByIdQuery,
  useGetApiPostsRootQuery,
  useGetApiPostsSearchQuery,
  useGetApiPostsSummaryByIdQuery,
  usePatchApiPostsByIdMutation,
  useGetApiPostsByIdQuery,
  useDeleteApiPostsByIdMutation,
  useGetApiPostsByIdAttachmentsQuery,
  useGetApiPostsByIdBreadcrumbsQuery,
  useGetApiPostsByIdCommentsQuery,
  usePostApiPostsByIdCommentsMutation,
  useGetApiPostsByIdEmailSignatureQuery,
  useGetApiPostsByIdEmailTemplateQuery,
  useGetApiPostsByIdNewsletterQuery,
  usePostApiPostsByIdNewsletterMutation,
  usePatchApiPostsByIdNewsletterAndArticleIdMutation,
  useDeleteApiPostsByIdNewsletterAndArticleIdMutation,
  useGetApiPostsByIdNotificationsQuery,
  useGetApiPostsByIdNotificationsUserAndTargetUserIdHistoryQuery,
  useGetApiPostsByIdNotificationsAndNotificationIdHistoryQuery,
  useGetApiPostsByIdParentsQuery,
  usePostApiPostsByIdPublishMutation,
  useGetApiPostsByIdRecipientsQuery,
  useGetApiPostsByIdRecipientsSummaryQuery,
  useGetApiPostsByIdResendAndNotificationIdMutation,
  usePostApiPostsByIdSendMutation,
  usePostApiPostsByIdSendAndUserIdMutation,
  useGetApiPostsByIdUndeliveredNotificationsQuery,
  usePostApiPostsByIdVoteMutation,
  useGetApiRolesQuery,
  usePostApiRolesMutation,
  useGetApiRolesByExternalIdByExternalIdQuery,
  usePatchApiRolesByRoleIdMutation,
  useGetApiRolesByRoleIdQuery,
  useGetApiSchedulerTasksQuery,
  useGetApiSchedulerTasksByIdQuery,
  usePostApiSchedulerAssociationMutation,
  usePostApiSchedulerBatchTasksRunMutation,
  useGetApiSchedulerBrevoEventsQuery,
  useGetApiSchedulerBrevoEventsPollByTenantIdQuery,
  useGetApiSchedulerCalculateMonthlyStatsCalculateQuery,
  usePostApiSchedulerChatSyncByTenantIdMutation,
  usePostApiSchedulerDistrictCodeByTenantIdMutation,
  usePostApiSchedulerDomainSyncMutation,
  usePostApiSchedulerDomainSyncByTenantIdMutation,
  useGetApiSchedulerEmailAlertsQuery,
  useGetApiSchedulerEmailEventsQuery,
  useGetApiSchedulerEmailSenderQuery,
  usePostApiSchedulerEmailSenderSendMutation,
  useGetApiSchedulerEmailSenderSmoothQuery,
  usePostApiSchedulerEmailSenderByTenantIdAndPostIdMutation,
  useGetApiSchedulerInvoicesCreateQuery,
  useGetApiSchedulerMailgunEventsQuery,
  useGetApiSchedulerMailgunEventsPollByTenantIdQuery,
  usePostApiSchedulerMeilisearchCompaniesByTenantIdMutation,
  usePostApiSchedulerMeilisearchPostTimestampsByTenantIdMutation,
  usePostApiSchedulerMeilisearchPostTypesByTenantIdMutation,
  usePostApiSchedulerMeilisearchPostsByTenantIdMutation,
  usePostApiSchedulerMeilisearchSetupMutation,
  useGetApiSchedulerMsGraphEventsQuery,
  usePostApiSchedulerPlannedPostsCacheByTenantIdMutation,
  useGetApiSchedulerPlannedPostsPublishQuery,
  useGetApiSchedulerPlannedPostsPublishByTenantIdAndPostIdQuery,
  usePostApiSchedulerStorageDocumentUploadMutation,
  usePostApiSchedulerTasksExecuteMutation,
  usePostApiSchedulerTasksTestMutation,
  useGetApiSchedulerTasksTestQuery,
  usePostApiSurveysMutation,
  useGetApiSurveysByTokenByTokenQuery,
  usePostApiSurveysRespondMutation,
  useGetApiSurveysTemplatesQuery,
  usePatchApiSurveysByIdMutation,
  useGetApiSurveysByIdQuery,
  useDeleteApiSurveysByIdMutation,
  useGetApiSurveysByIdAllResponsesQuery,
  useGetApiSurveysByIdParticipantsQuery,
  usePostApiSurveysByIdPublishMutation,
  usePatchApiSurveysByIdResponseMutation,
  useGetApiSurveysByIdResponseQuery,
  usePostApiSurveysByIdResponseMutation,
  useGetApiSurveysByIdResponseByUserAndUserIdQuery,
  usePatchApiSurveysByIdResponseAndResponseIdMutation,
  useGetApiSurveysByIdResponsesQuery,
  useGetApiTagsQuery,
  usePostApiTagsMutation,
  usePatchApiTagsByIdMutation,
  useDeleteApiTagsByIdMutation,
  usePostApiTestIdentityPlatformManagedOverrideMutation,
  useGetApiTextBlockQuery,
  usePostApiTextBlockMutation,
  usePostApiTextBlockLoadDefaultsMutation,
  usePatchApiTextBlockByIdMutation,
  useGetApiTextBlockByIdQuery,
  useDeleteApiTextBlockByIdMutation,
  usePostApiTextGeneratorFeedMessageMutation,
  usePostApiTextGeneratorTeaserMutation,
  useGetApiUsersQuery,
  usePostApiUsersMutation,
  useGetApiUsersByExternalIdByExternalIdQuery,
  useGetApiUsersEmailBlockedQuery,
  useDeleteApiUsersEmailBlockedByUserIdMutation,
  usePatchApiUsersMeMutation,
  useGetApiUsersMeQuery,
  useGetApiUsersMeChatTokenQuery,
  usePostApiUsersMeCloudMessageTokenMutation,
  usePostApiUsersMeResetPasswordMutation,
  usePatchApiUsersMeTagNotificationSettingsMutation,
  useGetApiUsersMeTagNotificationSettingsQuery,
  usePutApiUsersNotificationSettingsByTokenMutation,
  useGetApiUsersNotificationSettingsByTokenQuery,
  usePostApiUsersRecoverPasswordMutation,
  usePostApiUsersSetPasswordMutation,
  usePostApiUsersSignInWithEmailLinkMutation,
  useGetApiUsersTenantQuery,
  useGetApiUsersUnsubscribeByCredentialQuery,
  usePostApiUsersUnsubscribeByCredentialMutation,
  usePutApiUsersUnsubscribeByCredentialEmailMutation,
  useGetApiUsersUnsubscribeByCredentialPreferencesQuery,
  usePutApiUsersUnsubscribeByCredentialTopicsAndTagMutation,
  usePatchApiUsersByIdMutation,
  useGetApiUsersByIdQuery,
  useDeleteApiUsersByIdMutation,
  usePostApiUsersByIdResetPasswordMutation,
  usePatchApiUsersByIdTagNotificationSettingsMutation,
  useGetApiUsersByIdTagNotificationSettingsQuery,
  useGetApiVersionQuery
} = injectedRtkApi;
